(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.PAMH = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/* ==========================================================
 * bootstrap-alert.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#alerts
 * ==========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* ALERT CLASS DEFINITION
  * ====================== */

  var dismiss = '[data-dismiss="alert"]'
    , Alert = function (el) {
        $(el).on('click', dismiss, this.close)
      }

  Alert.prototype.close = function (e) {
    var $this = $(this)
      , selector = $this.attr('data-target')
      , $parent

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
    }

    $parent = $(selector)

    e && e.preventDefault()

    $parent.length || ($parent = $this.hasClass('alert') ? $this : $this.parent())

    $parent.trigger(e = $.Event('close'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      $parent
        .trigger('closed')
        .remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent.on($.support.transition.end, removeElement) :
      removeElement()
  }


 /* ALERT PLUGIN DEFINITION
  * ======================= */

  var old = $.fn.alert

  $.fn.alert = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('alert')
      if (!data) $this.data('alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  $.fn.alert.Constructor = Alert


 /* ALERT NO CONFLICT
  * ================= */

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


 /* ALERT DATA-API
  * ============== */

  $(document).on('click.alert.data-api', dismiss, Alert.prototype.close)

}(window.jQuery);
},{}],2:[function(require,module,exports){
/* ============================================================
 * bootstrap-button.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#buttons
 * ============================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


!function ($) {

  "use strict"; // jshint ;_;


 /* BUTTON PUBLIC CLASS DEFINITION
  * ============================== */

  var Button = function (element, options) {
    this.$element = $(element)
    this.options = $.extend({}, $.fn.button.defaults, options)
  }

  Button.prototype.setState = function (state) {
    var d = 'disabled'
      , $el = this.$element
      , data = $el.data()
      , val = $el.is('input') ? 'val' : 'html'

    state = state + 'Text'
    data.resetText || $el.data('resetText', $el[val]())

    $el[val](data[state] || this.options[state])

    // push to event loop to allow forms to submit
    setTimeout(function () {
      state == 'loadingText' ?
        $el.addClass(d).attr(d, d) :
        $el.removeClass(d).removeAttr(d)
    }, 0)
  }

  Button.prototype.toggle = function () {
    var $parent = this.$element.closest('[data-toggle="buttons-radio"]')

    $parent && $parent
      .find('.active')
      .removeClass('active')

    this.$element.toggleClass('active')
  }


 /* BUTTON PLUGIN DEFINITION
  * ======================== */

  var old = $.fn.button

  $.fn.button = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('button')
        , options = typeof option == 'object' && option
      if (!data) $this.data('button', (data = new Button(this, options)))
      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  $.fn.button.defaults = {
    loadingText: 'loading...'
  }

  $.fn.button.Constructor = Button


 /* BUTTON NO CONFLICT
  * ================== */

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


 /* BUTTON DATA-API
  * =============== */

  $(document).on('click.button.data-api', '[data-toggle^=button]', function (e) {
    var $btn = $(e.target)
    if (!$btn.hasClass('btn')) $btn = $btn.closest('.btn')
    $btn.button('toggle')
  })

}(window.jQuery);
},{}],3:[function(require,module,exports){
/* ============================================================
 * bootstrap-dropdown.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#dropdowns
 * ============================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


!function ($) {

  "use strict"; // jshint ;_;


 /* DROPDOWN CLASS DEFINITION
  * ========================= */

  var toggle = '[data-toggle=dropdown]'
    , Dropdown = function (element) {
        var $el = $(element).on('click.dropdown.data-api', this.toggle)
        $('html').on('click.dropdown.data-api', function () {
          $el.parent().removeClass('open')
        })
      }

  Dropdown.prototype = {

    constructor: Dropdown

  , toggle: function (e) {
      var $this = $(this)
        , $parent
        , isActive

      if ($this.is('.disabled, :disabled')) return

      $parent = getParent($this)

      isActive = $parent.hasClass('open')

      clearMenus()

      if (!isActive) {
        if ('ontouchstart' in document.documentElement) {
          // if mobile we we use a backdrop because click events don't delegate
          $('<div class="dropdown-backdrop"/>').insertBefore($(this)).on('click', clearMenus)
        }
        $parent.toggleClass('open')
      }

      $this.focus()

      return false
    }

  , keydown: function (e) {
      var $this
        , $items
        , $active
        , $parent
        , isActive
        , index

      if (!/(38|40|27)/.test(e.keyCode)) return

      $this = $(this)

      e.preventDefault()
      e.stopPropagation()

      if ($this.is('.disabled, :disabled')) return

      $parent = getParent($this)

      isActive = $parent.hasClass('open')

      if (!isActive || (isActive && e.keyCode == 27)) {
        if (e.which == 27) $parent.find(toggle).focus()
        return $this.click()
      }

      $items = $('[role=menu] li:not(.divider):visible a', $parent)

      if (!$items.length) return

      index = $items.index($items.filter(':focus'))

      if (e.keyCode == 38 && index > 0) index--                                        // up
      if (e.keyCode == 40 && index < $items.length - 1) index++                        // down
      if (!~index) index = 0

      $items
        .eq(index)
        .focus()
    }

  }

  function clearMenus() {
    $('.dropdown-backdrop').remove()
    $(toggle).each(function () {
      getParent($(this)).removeClass('open')
    })
  }

  function getParent($this) {
    var selector = $this.attr('data-target')
      , $parent

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
    }

    $parent = selector && $(selector)

    if (!$parent || !$parent.length) $parent = $this.parent()

    return $parent
  }


  /* DROPDOWN PLUGIN DEFINITION
   * ========================== */

  var old = $.fn.dropdown

  $.fn.dropdown = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('dropdown')
      if (!data) $this.data('dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  $.fn.dropdown.Constructor = Dropdown


 /* DROPDOWN NO CONFLICT
  * ==================== */

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  /* APPLY TO STANDARD DROPDOWN ELEMENTS
   * =================================== */

  $(document)
    .on('click.dropdown.data-api', clearMenus)
    .on('click.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.dropdown.data-api'  , toggle, Dropdown.prototype.toggle)
    .on('keydown.dropdown.data-api', toggle + ', [role=menu]' , Dropdown.prototype.keydown)

}(window.jQuery);

},{}],4:[function(require,module,exports){
/* ===========================================================
 * bootstrap-popover.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#popovers
 * ===========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* POPOVER PUBLIC CLASS DEFINITION
  * =============================== */

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }


  /* NOTE: POPOVER EXTENDS BOOTSTRAP-TOOLTIP.js
     ========================================== */

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype, {

    constructor: Popover

  , setContent: function () {
      var $tip = this.tip()
        , title = this.getTitle()
        , content = this.getContent()

      $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
      $tip.find('.popover-content')[this.options.html ? 'html' : 'text'](content)

      $tip.removeClass('fade top bottom left right in')
    }

  , hasContent: function () {
      return this.getTitle() || this.getContent()
    }

  , getContent: function () {
      var content
        , $e = this.$element
        , o = this.options

      content = (typeof o.content == 'function' ? o.content.call($e[0]) :  o.content)
        || $e.attr('data-content')

      return content
    }

  , tip: function () {
      if (!this.$tip) {
        this.$tip = $(this.options.template)
      }
      return this.$tip
    }

  , destroy: function () {
      this.hide().$element.off('.' + this.type).removeData(this.type)
    }

  })


 /* POPOVER PLUGIN DEFINITION
  * ======================= */

  var old = $.fn.popover

  $.fn.popover = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('popover')
        , options = typeof option == 'object' && option
      if (!data) $this.data('popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.popover.Constructor = Popover

  $.fn.popover.defaults = $.extend({} , $.fn.tooltip.defaults, {
    placement: 'right'
  , trigger: 'click'
  , content: ''
  , template: '<div class="popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


 /* POPOVER NO CONFLICT
  * =================== */

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(window.jQuery);

},{}],5:[function(require,module,exports){
/* ========================================================
 * bootstrap-tab.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#tabs
 * ========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ======================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* TAB CLASS DEFINITION
  * ==================== */

  var Tab = function (element) {
    this.element = $(element)
  }

  Tab.prototype = {

    constructor: Tab

  , show: function () {
      var $this = this.element
        , $ul = $this.closest('ul:not(.dropdown-menu)')
        , selector = $this.attr('data-target')
        , previous
        , $target
        , e

      if (!selector) {
        selector = $this.attr('href')
        selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
      }

      if ( $this.parent('li').hasClass('active') ) return

      previous = $ul.find('.active:last a')[0]

      e = $.Event('show', {
        relatedTarget: previous
      })

      $this.trigger(e)

      if (e.isDefaultPrevented()) return

      $target = $(selector)

      this.activate($this.parent('li'), $ul)
      this.activate($target, $target.parent(), function () {
        $this.trigger({
          type: 'shown'
        , relatedTarget: previous
        })
      })
    }

  , activate: function ( element, container, callback) {
      var $active = container.find('> .active')
        , transition = callback
            && $.support.transition
            && $active.hasClass('fade')

      function next() {
        $active
          .removeClass('active')
          .find('> .dropdown-menu > .active')
          .removeClass('active')

        element.addClass('active')

        if (transition) {
          element[0].offsetWidth // reflow for transition
          element.addClass('in')
        } else {
          element.removeClass('fade')
        }

        if ( element.parent('.dropdown-menu') ) {
          element.closest('li.dropdown').addClass('active')
        }

        callback && callback()
      }

      transition ?
        $active.one($.support.transition.end, next) :
        next()

      $active.removeClass('in')
    }
  }


 /* TAB PLUGIN DEFINITION
  * ===================== */

  var old = $.fn.tab

  $.fn.tab = function ( option ) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('tab')
      if (!data) $this.data('tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.tab.Constructor = Tab


 /* TAB NO CONFLICT
  * =============== */

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


 /* TAB DATA-API
  * ============ */

  $(document).on('click.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]', function (e) {
    e.preventDefault()
    $(this).tab('show')
  })

}(window.jQuery);
},{}],6:[function(require,module,exports){
/* ===========================================================
 * bootstrap-tooltip.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#tooltips
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ===========================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


 /* TOOLTIP PUBLIC CLASS DEFINITION
  * =============================== */

  var Tooltip = function (element, options) {
    this.init('tooltip', element, options)
  }

  Tooltip.prototype = {

    constructor: Tooltip

  , init: function (type, element, options) {
      var eventIn
        , eventOut
        , triggers
        , trigger
        , i

      this.type = type
      this.$element = $(element)
      this.options = this.getOptions(options)
      this.enabled = true

      triggers = this.options.trigger.split(' ')

      for (i = triggers.length; i--;) {
        trigger = triggers[i]
        if (trigger == 'click') {
          this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
        } else if (trigger != 'manual') {
          eventIn = trigger == 'hover' ? 'mouseenter' : 'focus'
          eventOut = trigger == 'hover' ? 'mouseleave' : 'blur'
          this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
          this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
        }
      }

      this.options.selector ?
        (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
        this.fixTitle()
    }

  , getOptions: function (options) {
      options = $.extend({}, $.fn[this.type].defaults, this.$element.data(), options)

      if (options.delay && typeof options.delay == 'number') {
        options.delay = {
          show: options.delay
        , hide: options.delay
        }
      }

      return options
    }

  , enter: function (e) {
      var defaults = $.fn[this.type].defaults
        , options = {}
        , self

      this._options && $.each(this._options, function (key, value) {
        if (defaults[key] != value) options[key] = value
      }, this)

      self = $(e.currentTarget)[this.type](options).data(this.type)

      if (!self.options.delay || !self.options.delay.show) return self.show()

      clearTimeout(this.timeout)
      self.hoverState = 'in'
      this.timeout = setTimeout(function() {
        if (self.hoverState == 'in') self.show()
      }, self.options.delay.show)
    }

  , leave: function (e) {
      var self = $(e.currentTarget)[this.type](this._options).data(this.type)

      if (this.timeout) clearTimeout(this.timeout)
      if (!self.options.delay || !self.options.delay.hide) return self.hide()

      self.hoverState = 'out'
      this.timeout = setTimeout(function() {
        if (self.hoverState == 'out') self.hide()
      }, self.options.delay.hide)
    }

  , show: function () {
      var $tip
        , pos
        , actualWidth
        , actualHeight
        , placement
        , tp
        , e = $.Event('show')

      if (this.hasContent() && this.enabled) {
        this.$element.trigger(e)
        if (e.isDefaultPrevented()) return
        $tip = this.tip()
        this.setContent()

        if (this.options.animation) {
          $tip.addClass('fade')
        }

        placement = typeof this.options.placement == 'function' ?
          this.options.placement.call(this, $tip[0], this.$element[0]) :
          this.options.placement

        $tip
          .detach()
          .css({ top: 0, left: 0, display: 'block' })

        this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)

        pos = this.getPosition()

        actualWidth = $tip[0].offsetWidth
        actualHeight = $tip[0].offsetHeight

        switch (placement) {
          case 'bottom':
            tp = {top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2}
            break
          case 'top':
            tp = {top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2}
            break
          case 'left':
            tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth}
            break
          case 'right':
            tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width}
            break
        }

        this.applyPlacement(tp, placement)
        this.$element.trigger('shown')
      }
    }

  , applyPlacement: function(offset, placement){
      var $tip = this.tip()
        , width = $tip[0].offsetWidth
        , height = $tip[0].offsetHeight
        , actualWidth
        , actualHeight
        , delta
        , replace

      $tip
        .offset(offset)
        .addClass(placement)
        .addClass('in')

      actualWidth = $tip[0].offsetWidth
      actualHeight = $tip[0].offsetHeight

      if (placement == 'top' && actualHeight != height) {
        offset.top = offset.top + height - actualHeight
        replace = true
      }

      if (placement == 'bottom' || placement == 'top') {
        delta = 0

        if (offset.left < 0){
          delta = offset.left * -2
          offset.left = 0
          $tip.offset(offset)
          actualWidth = $tip[0].offsetWidth
          actualHeight = $tip[0].offsetHeight
        }

        this.replaceArrow(delta - width + actualWidth, actualWidth, 'left')
      } else {
        this.replaceArrow(actualHeight - height, actualHeight, 'top')
      }

      if (replace) $tip.offset(offset)
    }

  , replaceArrow: function(delta, dimension, position){
      this
        .arrow()
        .css(position, delta ? (50 * (1 - delta / dimension) + "%") : '')
    }

  , setContent: function () {
      var $tip = this.tip()
        , title = this.getTitle()

      $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
      $tip.removeClass('fade in top bottom left right')
    }

  , hide: function () {
      var that = this
        , $tip = this.tip()
        , e = $.Event('hide')

      this.$element.trigger(e)
      if (e.isDefaultPrevented()) return

      $tip.removeClass('in')

      function removeWithAnimation() {
        var timeout = setTimeout(function () {
          $tip.off($.support.transition.end).detach()
        }, 500)

        $tip.one($.support.transition.end, function () {
          clearTimeout(timeout)
          $tip.detach()
        })
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        removeWithAnimation() :
        $tip.detach()

      this.$element.trigger('hidden')

      return this
    }

  , fixTitle: function () {
      var $e = this.$element
      if ($e.attr('title') || typeof($e.attr('data-original-title')) != 'string') {
        $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
      }
    }

  , hasContent: function () {
      return this.getTitle()
    }

  , getPosition: function () {
      var el = this.$element[0]
      return $.extend({}, (typeof el.getBoundingClientRect == 'function') ? el.getBoundingClientRect() : {
        width: el.offsetWidth
      , height: el.offsetHeight
      }, this.$element.offset())
    }

  , getTitle: function () {
      var title
        , $e = this.$element
        , o = this.options

      title = $e.attr('data-original-title')
        || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

      return title
    }

  , tip: function () {
      return this.$tip = this.$tip || $(this.options.template)
    }

  , arrow: function(){
      return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
    }

  , validate: function () {
      if (!this.$element[0].parentNode) {
        this.hide()
        this.$element = null
        this.options = null
      }
    }

  , enable: function () {
      this.enabled = true
    }

  , disable: function () {
      this.enabled = false
    }

  , toggleEnabled: function () {
      this.enabled = !this.enabled
    }

  , toggle: function (e) {
      var self = e ? $(e.currentTarget)[this.type](this._options).data(this.type) : this
      self.tip().hasClass('in') ? self.hide() : self.show()
    }

  , destroy: function () {
      this.hide().$element.off('.' + this.type).removeData(this.type)
    }

  }


 /* TOOLTIP PLUGIN DEFINITION
  * ========================= */

  var old = $.fn.tooltip

  $.fn.tooltip = function ( option ) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('tooltip')
        , options = typeof option == 'object' && option
      if (!data) $this.data('tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.tooltip.Constructor = Tooltip

  $.fn.tooltip.defaults = {
    animation: true
  , placement: 'top'
  , selector: false
  , template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
  , trigger: 'hover focus'
  , title: ''
  , delay: 0
  , html: false
  , container: false
  }


 /* TOOLTIP NO CONFLICT
  * =================== */

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(window.jQuery);

},{}],7:[function(require,module,exports){
/* ===================================================
 * bootstrap-transition.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#transitions
 * ===================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */


!function ($) {

  "use strict"; // jshint ;_;


  /* CSS TRANSITION SUPPORT (http://www.modernizr.com/)
   * ======================================================= */

  $(function () {

    $.support.transition = (function () {

      var transitionEnd = (function () {

        var el = document.createElement('bootstrap')
          , transEndEventNames = {
               'WebkitTransition' : 'webkitTransitionEnd'
            ,  'MozTransition'    : 'transitionend'
            ,  'OTransition'      : 'oTransitionEnd otransitionend'
            ,  'transition'       : 'transitionend'
            }
          , name

        for (name in transEndEventNames){
          if (el.style[name] !== undefined) {
            return transEndEventNames[name]
          }
        }

      }())

      return transitionEnd && {
        end: transitionEnd
      }

    })()

  })

}(window.jQuery);
},{}],8:[function(require,module,exports){
/* =============================================================
 * bootstrap-typeahead.js v2.3.2
 * http://getbootstrap.com/2.3.2/javascript.html#typeahead
 * =============================================================
 * Copyright 2013 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */


!function($){

  "use strict"; // jshint ;_;


 /* TYPEAHEAD PUBLIC CLASS DEFINITION
  * ================================= */

  var Typeahead = function (element, options) {
    this.$element = $(element)
    this.options = $.extend({}, $.fn.typeahead.defaults, options)
    this.matcher = this.options.matcher || this.matcher
    this.sorter = this.options.sorter || this.sorter
    this.highlighter = this.options.highlighter || this.highlighter
    this.updater = this.options.updater || this.updater
    this.source = this.options.source
    this.$menu = $(this.options.menu)
    this.shown = false
    this.listen()
  }

  Typeahead.prototype = {

    constructor: Typeahead

  , select: function () {
      var val = this.$menu.find('.active').attr('data-value')
      this.$element
        .val(this.updater(val))
        .change()
      return this.hide()
    }

  , updater: function (item) {
      return item
    }

  , show: function () {
      var pos = $.extend({}, this.$element.position(), {
        height: this.$element[0].offsetHeight
      })

      this.$menu
        .insertAfter(this.$element)
        .css({
          top: pos.top + pos.height
        , left: pos.left
        })
        .show()

      this.shown = true
      return this
    }

  , hide: function () {
      this.$menu.hide()
      this.shown = false
      return this
    }

  , lookup: function (event) {
      var items

      this.query = this.$element.val()

      if (!this.query || this.query.length < this.options.minLength) {
        return this.shown ? this.hide() : this
      }

      items = $.isFunction(this.source) ? this.source(this.query, $.proxy(this.process, this)) : this.source

      return items ? this.process(items) : this
    }

  , process: function (items) {
      var that = this

      items = $.grep(items, function (item) {
        return that.matcher(item)
      })

      items = this.sorter(items)

      if (!items.length) {
        return this.shown ? this.hide() : this
      }

      return this.render(items.slice(0, this.options.items)).show()
    }

  , matcher: function (item) {
      return ~item.toLowerCase().indexOf(this.query.toLowerCase())
    }

  , sorter: function (items) {
      var beginswith = []
        , caseSensitive = []
        , caseInsensitive = []
        , item

      while (item = items.shift()) {
        if (!item.toLowerCase().indexOf(this.query.toLowerCase())) beginswith.push(item)
        else if (~item.indexOf(this.query)) caseSensitive.push(item)
        else caseInsensitive.push(item)
      }

      return beginswith.concat(caseSensitive, caseInsensitive)
    }

  , highlighter: function (item) {
      var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&')
      return item.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
        return '<strong>' + match + '</strong>'
      })
    }

  , render: function (items) {
      var that = this

      items = $(items).map(function (i, item) {
        i = $(that.options.item).attr('data-value', item)
        i.find('a').html(that.highlighter(item))
        return i[0]
      })

      items.first().addClass('active')
      this.$menu.html(items)
      return this
    }

  , next: function (event) {
      var active = this.$menu.find('.active').removeClass('active')
        , next = active.next()

      if (!next.length) {
        next = $(this.$menu.find('li')[0])
      }

      next.addClass('active')
    }

  , prev: function (event) {
      var active = this.$menu.find('.active').removeClass('active')
        , prev = active.prev()

      if (!prev.length) {
        prev = this.$menu.find('li').last()
      }

      prev.addClass('active')
    }

  , listen: function () {
      this.$element
        .on('focus',    $.proxy(this.focus, this))
        .on('blur',     $.proxy(this.blur, this))
        .on('keypress', $.proxy(this.keypress, this))
        .on('keyup',    $.proxy(this.keyup, this))

      if (this.eventSupported('keydown')) {
        this.$element.on('keydown', $.proxy(this.keydown, this))
      }

      this.$menu
        .on('click', $.proxy(this.click, this))
        .on('mouseenter', 'li', $.proxy(this.mouseenter, this))
        .on('mouseleave', 'li', $.proxy(this.mouseleave, this))
    }

  , eventSupported: function(eventName) {
      var isSupported = eventName in this.$element
      if (!isSupported) {
        this.$element.setAttribute(eventName, 'return;')
        isSupported = typeof this.$element[eventName] === 'function'
      }
      return isSupported
    }

  , move: function (e) {
      if (!this.shown) return

      switch(e.keyCode) {
        case 9: // tab
        case 13: // enter
        case 27: // escape
          e.preventDefault()
          break

        case 38: // up arrow
          e.preventDefault()
          this.prev()
          break

        case 40: // down arrow
          e.preventDefault()
          this.next()
          break
      }

      e.stopPropagation()
    }

  , keydown: function (e) {
      this.suppressKeyPressRepeat = ~$.inArray(e.keyCode, [40,38,9,13,27])
      this.move(e)
    }

  , keypress: function (e) {
      if (this.suppressKeyPressRepeat) return
      this.move(e)
    }

  , keyup: function (e) {
      switch(e.keyCode) {
        case 40: // down arrow
        case 38: // up arrow
        case 16: // shift
        case 17: // ctrl
        case 18: // alt
          break

        case 9: // tab
        case 13: // enter
          if (!this.shown) return
          this.select()
          break

        case 27: // escape
          if (!this.shown) return
          this.hide()
          break

        default:
          this.lookup()
      }

      e.stopPropagation()
      e.preventDefault()
  }

  , focus: function (e) {
      this.focused = true
    }

  , blur: function (e) {
      this.focused = false
      if (!this.mousedover && this.shown) this.hide()
    }

  , click: function (e) {
      e.stopPropagation()
      e.preventDefault()
      this.select()
      this.$element.focus()
    }

  , mouseenter: function (e) {
      this.mousedover = true
      this.$menu.find('.active').removeClass('active')
      $(e.currentTarget).addClass('active')
    }

  , mouseleave: function (e) {
      this.mousedover = false
      if (!this.focused && this.shown) this.hide()
    }

  }


  /* TYPEAHEAD PLUGIN DEFINITION
   * =========================== */

  var old = $.fn.typeahead

  $.fn.typeahead = function (option) {
    return this.each(function () {
      var $this = $(this)
        , data = $this.data('typeahead')
        , options = typeof option == 'object' && option
      if (!data) $this.data('typeahead', (data = new Typeahead(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  $.fn.typeahead.defaults = {
    source: []
  , items: 8
  , menu: '<ul class="typeahead dropdown-menu"></ul>'
  , item: '<li><a href="#"></a></li>'
  , minLength: 1
  }

  $.fn.typeahead.Constructor = Typeahead


 /* TYPEAHEAD NO CONFLICT
  * =================== */

  $.fn.typeahead.noConflict = function () {
    $.fn.typeahead = old
    return this
  }


 /* TYPEAHEAD DATA-API
  * ================== */

  $(document).on('focus.typeahead.data-api', '[data-provide="typeahead"]', function (e) {
    var $this = $(this)
    if ($this.data('typeahead')) return
    $this.typeahead($this.data())
  })

}(window.jQuery);

},{}],9:[function(require,module,exports){
/**
 * gemini-scrollbar
 * @version 1.5.2
 * @link http://noeldelgado.github.io/gemini-scrollbar/
 * @license MIT
 */
(function() {
  var SCROLLBAR_WIDTH, DONT_CREATE_GEMINI, CLASSNAMES;

  CLASSNAMES = {
    element: 'gm-scrollbar-container',
    verticalScrollbar: 'gm-scrollbar -vertical',
    horizontalScrollbar: 'gm-scrollbar -horizontal',
    thumb: 'thumb',
    view: 'gm-scroll-view',
    autoshow: 'gm-autoshow',
    disable: 'gm-scrollbar-disable-selection',
    prevented: 'gm-prevented',
    resizeTrigger: 'gm-resize-trigger',
  };

  function getScrollbarWidth() {
    var e = document.createElement('div'), sw;
    e.style.position = 'absolute';
    e.style.top = '-9999px';
    e.style.width = '100px';
    e.style.height = '100px';
    e.style.overflow = 'scroll';
    e.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(e);
    sw = (e.offsetWidth - e.clientWidth);
    document.body.removeChild(e);
    return sw;
  }

  function addClass(el, classNames) {
    if (el.classList) {
      return classNames.forEach(function(cl) {
        el.classList.add(cl);
      });
    }
    el.className += ' ' + classNames.join(' ');
  }

  function removeClass(el, classNames) {
    if (el.classList) {
      return classNames.forEach(function(cl) {
        el.classList.remove(cl);
      });
    }
    el.className = el.className.replace(new RegExp('(^|\\b)' + classNames.join('|') + '(\\b|$)', 'gi'), ' ');
  }

  /* Copyright (c) 2015 Lucas Wiener
   * https://github.com/wnr/element-resize-detector
   */
  function isIE() {
    var agent = navigator.userAgent.toLowerCase();
    return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
  }

  function GeminiScrollbar(config) {
    this.element = null;
    this.autoshow = false;
    this.createElements = true;
    this.forceGemini = false;
    this.onResize = null;
    this.minThumbSize = 20;

    Object.keys(config || {}).forEach(function (propertyName) {
      this[propertyName] = config[propertyName];
    }, this);

    SCROLLBAR_WIDTH = getScrollbarWidth();
    DONT_CREATE_GEMINI = ((SCROLLBAR_WIDTH === 0) && (this.forceGemini === false));

    this._cache = {events: {}};
    this._created = false;
    this._cursorDown = false;
    this._prevPageX = 0;
    this._prevPageY = 0;

    this._document = null;
    this._viewElement = this.element;
    this._scrollbarVerticalElement = null;
    this._thumbVerticalElement = null;
    this._scrollbarHorizontalElement = null;
    this._scrollbarHorizontalElement = null;
  }

  GeminiScrollbar.prototype.create = function create() {
    if (DONT_CREATE_GEMINI) {
      addClass(this.element, [CLASSNAMES.prevented]);

      if (this.onResize) {
        // still need a resize trigger if we have an onResize callback, which
        // also means we need a separate _viewElement to do the scrolling.
        if (this.createElements === true) {
          this._viewElement = document.createElement('div');
          while(this.element.childNodes.length > 0) {
            this._viewElement.appendChild(this.element.childNodes[0]);
          }
          this.element.appendChild(this._viewElement);
        } else {
          this._viewElement = this.element.querySelector('.' + CLASSNAMES.view);
        }
        addClass(this.element, [CLASSNAMES.element]);
        addClass(this._viewElement, [CLASSNAMES.view]);
        this._createResizeTrigger();
      }

      return this;
    }

    if (this._created === true) {
      console.warn('calling on a already-created object');
      return this;
    }

    if (this.autoshow) {
      addClass(this.element, [CLASSNAMES.autoshow]);
    }

    this._document = document;

    if (this.createElements === true) {
      this._viewElement = document.createElement('div');
      this._scrollbarVerticalElement = document.createElement('div');
      this._thumbVerticalElement = document.createElement('div');
      this._scrollbarHorizontalElement = document.createElement('div');
      this._thumbHorizontalElement = document.createElement('div');
      while(this.element.childNodes.length > 0) {
        this._viewElement.appendChild(this.element.childNodes[0]);
      }

      this._scrollbarVerticalElement.appendChild(this._thumbVerticalElement);
      this._scrollbarHorizontalElement.appendChild(this._thumbHorizontalElement);
      this.element.appendChild(this._scrollbarVerticalElement);
      this.element.appendChild(this._scrollbarHorizontalElement);
      this.element.appendChild(this._viewElement);
    } else {
      this._viewElement = this.element.querySelector('.' + CLASSNAMES.view);
      this._scrollbarVerticalElement = this.element.querySelector('.' + CLASSNAMES.verticalScrollbar.split(' ').join('.'));
      this._thumbVerticalElement = this._scrollbarVerticalElement.querySelector('.' + CLASSNAMES.thumb);
      this._scrollbarHorizontalElement = this.element.querySelector('.' + CLASSNAMES.horizontalScrollbar.split(' ').join('.'));
      this._thumbHorizontalElement = this._scrollbarHorizontalElement.querySelector('.' + CLASSNAMES.thumb);
    }

    addClass(this.element, [CLASSNAMES.element]);
    addClass(this._viewElement, [CLASSNAMES.view]);
    addClass(this._scrollbarVerticalElement, CLASSNAMES.verticalScrollbar.split(/\s/));
    addClass(this._scrollbarHorizontalElement, CLASSNAMES.horizontalScrollbar.split(/\s/));
    addClass(this._thumbVerticalElement, [CLASSNAMES.thumb]);
    addClass(this._thumbHorizontalElement, [CLASSNAMES.thumb]);

    this._scrollbarVerticalElement.style.display = '';
    this._scrollbarHorizontalElement.style.display = '';

    this._createResizeTrigger();

    this._created = true;

    return this._bindEvents().update();
  };

  GeminiScrollbar.prototype._createResizeTrigger = function createResizeTrigger() {
    // We need to arrange for self.scrollbar.update to be called whenever
    // the DOM is changed resulting in a size-change for our div. To make
    // this happen, we use a technique described here:
    // http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/.
    //
    // The idea is that we create an <object> element in our div, which we
    // arrange to have the same size as that div. The <object> element
    // contains a Window object, to which we can attach an onresize
    // handler.
    //
    // (React appears to get very confused by the object (we end up with
    // Chrome windows which only show half of the text they are supposed
    // to), so we always do this manually.)

    var obj = document.createElement('object');
    addClass(obj, [CLASSNAMES.resizeTrigger]);
    obj.type = 'text/html';
    obj.setAttribute('tabindex', '-1');
    var resizeHandler = this._resizeHandler.bind(this);
    obj.onload = function () {
      var win = obj.contentDocument.defaultView;
      win.addEventListener('resize', resizeHandler);
    };

    //IE: Does not like that this happens before, even if it is also added after.
    if (!isIE()) {
      obj.data = 'about:blank';
    }

    this.element.appendChild(obj);

    //IE: This must occur after adding the object to the DOM.
    if (isIE()) {
      obj.data = 'about:blank';
    }

    this._resizeTriggerElement = obj;
  };

  GeminiScrollbar.prototype.update = function update() {
    if (DONT_CREATE_GEMINI) {
      return this;
    }

    if (this._created === false) {
      console.warn('calling on a not-yet-created object');
      return this;
    }

    this._viewElement.style.width = ((this.element.offsetWidth + SCROLLBAR_WIDTH).toString() + 'px');
    this._viewElement.style.height = ((this.element.offsetHeight + SCROLLBAR_WIDTH).toString() + 'px');

    this._naturalThumbSizeX = this._scrollbarHorizontalElement.clientWidth / this._viewElement.scrollWidth * this._scrollbarHorizontalElement.clientWidth;
    this._naturalThumbSizeY = this._scrollbarVerticalElement.clientHeight / this._viewElement.scrollHeight * this._scrollbarVerticalElement.clientHeight;

    this._scrollTopMax = this._viewElement.scrollHeight - this._viewElement.clientHeight;
    this._scrollLeftMax = this._viewElement.scrollWidth - this._viewElement.clientWidth;

    if (this._naturalThumbSizeY < this.minThumbSize) {
      this._thumbVerticalElement.style.height = this.minThumbSize + 'px';
    } else if (this._scrollTopMax) {
      this._thumbVerticalElement.style.height = this._naturalThumbSizeY + 'px';
    } else {
      this._thumbVerticalElement.style.height = '0px';
    }

    if (this._naturalThumbSizeX < this.minThumbSize) {
      this._thumbHorizontalElement.style.width = this.minThumbSize + 'px';
    } else if (this._scrollLeftMax) {
      this._thumbHorizontalElement.style.width = this._naturalThumbSizeX + 'px';
    } else {
      this._thumbHorizontalElement.style.width = '0px';
    }

    this._thumbSizeY = this._thumbVerticalElement.clientHeight;
    this._thumbSizeX = this._thumbHorizontalElement.clientWidth;

    this._trackTopMax = this._scrollbarVerticalElement.clientHeight - this._thumbSizeY;
    this._trackLeftMax = this._scrollbarHorizontalElement.clientWidth - this._thumbSizeX;

    this._scrollHandler();

    return this;
  };

  GeminiScrollbar.prototype.destroy = function destroy() {
    if (this._resizeTriggerElement) {
      this.element.removeChild(this._resizeTriggerElement);
      this._resizeTriggerElement = null;
    }

    if (DONT_CREATE_GEMINI) {
      return this;
    }

    if (this._created === false) {
      console.warn('calling on a not-yet-created object');
      return this;
    }

    this._unbinEvents();

    removeClass(this.element, [CLASSNAMES.element, CLASSNAMES.autoshow]);

    if (this.createElements === true) {
      this.element.removeChild(this._scrollbarVerticalElement);
      this.element.removeChild(this._scrollbarHorizontalElement);
      while(this._viewElement.childNodes.length > 0) {
        this.element.appendChild(this._viewElement.childNodes[0]);
      }
      this.element.removeChild(this._viewElement);
    } else {
      this._viewElement.style.width = '';
      this._viewElement.style.height = '';
      this._scrollbarVerticalElement.style.display = 'none';
      this._scrollbarHorizontalElement.style.display = 'none';
    }

    this._created = false;
    this._document = null;

    return null;
  };

  GeminiScrollbar.prototype.getViewElement = function getViewElement() {
    return this._viewElement;
  };

  GeminiScrollbar.prototype._bindEvents = function _bindEvents() {
    this._cache.events.scrollHandler = this._scrollHandler.bind(this);
    this._cache.events.clickVerticalTrackHandler = this._clickVerticalTrackHandler.bind(this);
    this._cache.events.clickHorizontalTrackHandler = this._clickHorizontalTrackHandler.bind(this);
    this._cache.events.clickVerticalThumbHandler = this._clickVerticalThumbHandler.bind(this);
    this._cache.events.clickHorizontalThumbHandler = this._clickHorizontalThumbHandler.bind(this);
    this._cache.events.mouseUpDocumentHandler = this._mouseUpDocumentHandler.bind(this);
    this._cache.events.mouseMoveDocumentHandler = this._mouseMoveDocumentHandler.bind(this);

    this._viewElement.addEventListener('scroll', this._cache.events.scrollHandler);
    this._scrollbarVerticalElement.addEventListener('mousedown', this._cache.events.clickVerticalTrackHandler);
    this._scrollbarHorizontalElement.addEventListener('mousedown', this._cache.events.clickHorizontalTrackHandler);
    this._thumbVerticalElement.addEventListener('mousedown', this._cache.events.clickVerticalThumbHandler);
    this._thumbHorizontalElement.addEventListener('mousedown', this._cache.events.clickHorizontalThumbHandler);
    this._document.addEventListener('mouseup', this._cache.events.mouseUpDocumentHandler);

    return this;
  };

  GeminiScrollbar.prototype._unbinEvents = function _unbinEvents() {
    this._viewElement.removeEventListener('scroll', this._cache.events.scrollHandler);
    this._scrollbarVerticalElement.removeEventListener('mousedown', this._cache.events.clickVerticalTrackHandler);
    this._scrollbarHorizontalElement.removeEventListener('mousedown', this._cache.events.clickHorizontalTrackHandler);
    this._thumbVerticalElement.removeEventListener('mousedown', this._cache.events.clickVerticalThumbHandler);
    this._thumbHorizontalElement.removeEventListener('mousedown', this._cache.events.clickHorizontalThumbHandler);
    this._document.removeEventListener('mouseup', this._cache.events.mouseUpDocumentHandler);
    this._document.removeEventListener('mousemove', this._cache.events.mouseMoveDocumentHandler);

    return this;
  };

  GeminiScrollbar.prototype._scrollHandler = function _scrollHandler() {
    var x = (this._viewElement.scrollLeft * this._trackLeftMax / this._scrollLeftMax) || 0;
    var y = (this._viewElement.scrollTop * this._trackTopMax / this._scrollTopMax) || 0;

    this._thumbHorizontalElement.style.msTransform = 'translateX(' + x + 'px)';
    this._thumbHorizontalElement.style.webkitTransform = 'translate3d(' + x + 'px, 0, 0)';
    this._thumbHorizontalElement.style.transform = 'translate3d(' + x + 'px, 0, 0)';

    this._thumbVerticalElement.style.msTransform = 'translateY(' + y + 'px)';
    this._thumbVerticalElement.style.webkitTransform = 'translate3d(0, ' + y + 'px, 0)';
    this._thumbVerticalElement.style.transform = 'translate3d(0, ' + y + 'px, 0)';
  };

  GeminiScrollbar.prototype._resizeHandler = function _resizeHandler() {
    this.update();
    if (this.onResize) {
      this.onResize();
    }
  };

  GeminiScrollbar.prototype._clickVerticalTrackHandler = function _clickVerticalTrackHandler(e) {
    var offset = e.offsetY - this._naturalThumbSizeY * .5
      , thumbPositionPercentage = offset * 100 / this._scrollbarVerticalElement.clientHeight;

    this._viewElement.scrollTop = thumbPositionPercentage * this._viewElement.scrollHeight / 100;
  };

  GeminiScrollbar.prototype._clickHorizontalTrackHandler = function _clickHorizontalTrackHandler(e) {
    var offset = e.offsetX - this._naturalThumbSizeX * .5
      , thumbPositionPercentage = offset * 100 / this._scrollbarHorizontalElement.clientWidth;

    this._viewElement.scrollLeft = thumbPositionPercentage * this._viewElement.scrollWidth / 100;
  };

  GeminiScrollbar.prototype._clickVerticalThumbHandler = function _clickVerticalThumbHandler(e) {
    this._startDrag(e);
    this._prevPageY = this._thumbSizeY - e.offsetY;
  };

  GeminiScrollbar.prototype._clickHorizontalThumbHandler = function _clickHorizontalThumbHandler(e) {
    this._startDrag(e);
    this._prevPageX = this._thumbSizeX - e.offsetX;
  };

  GeminiScrollbar.prototype._startDrag = function _startDrag(e) {
    e.stopImmediatePropagation();
    this._cursorDown = true;
    addClass(document.body, [CLASSNAMES.disable]);
    this._document.addEventListener('mousemove', this._cache.events.mouseMoveDocumentHandler);
    this._document.onselectstart = function() {return false;};
  };

  GeminiScrollbar.prototype._mouseUpDocumentHandler = function _mouseUpDocumentHandler() {
    this._cursorDown = false;
    this._prevPageX = this._prevPageY = 0;
    removeClass(document.body, [CLASSNAMES.disable]);
    this._document.removeEventListener('mousemove', this._cache.events.mouseMoveDocumentHandler);
    this._document.onselectstart = null;
  };

  GeminiScrollbar.prototype._mouseMoveDocumentHandler = function _mouseMoveDocumentHandler(e) {
    if (this._cursorDown === false) {return;}

    var offset, thumbClickPosition;

    if (this._prevPageY) {
      offset = e.clientY - this._scrollbarVerticalElement.getBoundingClientRect().top;
      thumbClickPosition = this._thumbSizeY - this._prevPageY;

      this._viewElement.scrollTop = this._scrollTopMax * (offset - thumbClickPosition) / this._trackTopMax;

      return void 0;
    }

    if (this._prevPageX) {
      offset = e.clientX - this._scrollbarHorizontalElement.getBoundingClientRect().left;
      thumbClickPosition = this._thumbSizeX - this._prevPageX;

      this._viewElement.scrollLeft = this._scrollLeftMax * (offset - thumbClickPosition) / this._trackLeftMax;
    }
  };

  if (typeof exports === 'object') {
    module.exports = GeminiScrollbar;
  } else {
    window.GeminiScrollbar = GeminiScrollbar;
  }
})();

},{}],10:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

},{"./_root":15}],11:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    getRawTag = require('./_getRawTag'),
    objectToString = require('./_objectToString');

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;

},{"./_Symbol":10,"./_getRawTag":13,"./_objectToString":14}],12:[function(require,module,exports){
(function (global){
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],13:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

},{"./_Symbol":10}],14:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

},{}],15:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

},{"./_freeGlobal":12}],16:[function(require,module,exports){
var isObject = require('./isObject'),
    now = require('./now'),
    toNumber = require('./toNumber');

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;

},{"./isObject":17,"./now":20,"./toNumber":22}],17:[function(require,module,exports){
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

},{}],18:[function(require,module,exports){
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

},{}],19:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;

},{"./_baseGetTag":11,"./isObjectLike":18}],20:[function(require,module,exports){
var root = require('./_root');

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;

},{"./_root":15}],21:[function(require,module,exports){
var debounce = require('./debounce'),
    isObject = require('./isObject');

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;

},{"./debounce":16,"./isObject":17}],22:[function(require,module,exports){
var isObject = require('./isObject'),
    isSymbol = require('./isSymbol');

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;

},{"./isObject":17,"./isSymbol":19}],23:[function(require,module,exports){
//! moment.js
//! version : 2.19.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year())) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;

    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        oldLocale = globalLocale._abbr;
        try {
            // workaround for React Native 0.49+
            var pretendingNotToRequireV1 = require;
            pretendingNotToRequireV1('moment/locale/' + name);
        } catch (e) {
            // In the test environment, the external module 'moment'
            // can't be resolved because we're running inside it.
            // Fallback to using the old relative import
            try {
                var pretendingNotToRequireV2 = require;
                pretendingNotToRequireV2('./locale/' + name);
            } catch (e) { }
        }

        // because defineLocale currently also sets the global locale, we
        // want to undo that for lazy loaded locales
        getSetGlobalLocale(oldLocale);
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.19.0';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

},{}],24:[function(require,module,exports){
$(function () {
  $('input[name=never_parked]').change(function () {
    var isChecked = this.checked;

    if (!isChecked) {
      return false;
    }

    $('#id_end_date').val('');
    $('#id_end_time').val('00:00:00');

  });
});

},{}],25:[function(require,module,exports){
var debug = require('./extensions/debug.js');
var eventTracking = require('./extensions/event_tracking.js');
var moment = require('moment');
var throttle = require('lodash/throttle');
var GeminiScrollbar = require('gemini-scrollbar')

debug.registerAjax();

function ucwords(e) {
    var t = e.toLowerCase().split(" ");
    for (var n = 0; n < t.length; n++) {
        var r = t[n].charAt(0).toUpperCase();
        t[n] = r + t[n].substr(1)
    }
    return t.join(" ")
}

function JSONSuccess(data) {
    var obj = typeof data != "object" ? $.parseJSON(data) : data;
    $.each(obj, function (e, t) {
        if (e == "content") {
            $.each(t, function (e, t) {
                JSONContent(t)
            })
        }
        if (e == "notifications") {
            $.each(t, function (e, t) {
                JSONNotifications(t)
            })
        }
        if (e == "redirect") {
            PAMH.redirect = t
        }
        if (e == "javascript") {
            PAMH.javascript = t
        }
    });
    if (PAMH.javascript) {
        eval(PAMH.javascript)
    }
    if (PAMH.redirect) {
        window.location = PAMH.redirect
    }
    $("#pamh_modal").modal("hide")
}

function JSONError(data) {
    var obj = typeof data != "object" ? $.parseJSON(data) : data;
    $.each(obj, function (e, t) {
        if (e == "alert") {
            alert(t)
        }
        if (e == "form") {
            JSONFormValidation(t);
            JSONNotifications({
                title: "Form errors",
                message: "Please correct the errors in the submitted data",
                type: "error"
            })
        }
        if (e == "notifications") {
            $.each(t, function (e, t) {
                JSONNotifications(t)
            })
        }
        if (e == "javascript") {
            PAMH.javascript = t
        }
    });
    if (PAMH.javascript) {
        eval(PAMH.javascript)
    }
}

function JSONNotifications(e) {
    if (typeof $.gritter != "undefined"){
        $.gritter.add({
            title: e.title,
            text: e.message,
            image: "/media/img/icons/gritter/" + e.type + ".png",
            sticky: e.sticky,
            time: e.sticky ? "" : 3e3,
            class_name: "gritter-" + e.type
        })
    }
}

function JSONFormValidation(e) {
    $(".dynamic").remove();
    $(".control-group").removeClass("error");
    $.each(e, function (e, t) {
        $("[name='" + e + "']")
        .closest(".control-group")
        .addClass("error")
        .find(".controls")
        .append($("<span />", {
            "class": "help-block dynamic",
            text: t
        }))
    })
}

function JSONContent(e) {
    if (e.transition) {
        $(e.container)[e.transition]()
    }
    if (e.manipulation) {
        $(e.container)[e.manipulation](e.html)
    }
}

function array_filter(e, t) {
    var n = {},
        r;
    t = t || function (e) {
        return e
    };
    for (r in e) {
        if (t(e[r])) {
            n[r] = e[r]
        }
    }
    return n
}

function array_unique(e) {
    var t = "",
        n = {},
        r = "";
    var i = function (e, t) {
        var n = "";
        for (n in t) {
            if (t.hasOwnProperty(n)) {
                if (t[n] + "" === e + "") {
                    return n
                }
            }
        }
        return false
    };
    for (t in e) {
        if (e.hasOwnProperty(t)) {
            r = e[t];
            if (false === i(r, n)) {
                n[t] = r
            }
        }
    }
    return n
}

function number_format(e, t, n, r) {
    e = (e + "").replace(/[^0-9+\-Ee.]/g, "");
    var i = !isFinite(+e) ? 0 : +e,
        s = !isFinite(+t) ? 0 : Math.abs(t),
        o = typeof r === "undefined" ? "," : r,
        u = typeof n === "undefined" ? "." : n,
        a = "",
        f = function (e, t) {
            var n = Math.pow(10, t);
            return "" + Math.round(e * n) / n
        };
    a = (s ? f(i, s) : "" + Math.round(i)).split(".");
    if (a[0].length > 3) {
        a[0] = a[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, o)
    }
    if ((a[1] || "").length < s) {
        a[1] = a[1] || "";
        a[1] += (new Array(s - a[1].length + 1)).join("0")
    }
    return a.join(u)
}

function formatted_total(e, t) {
    var n = number_format(e, 2, ".", ",");
    return PAMH.CurrencyCodes[t] + n
}


function roundNumber(e, t) {
    var n = t ? t : 0;
    var r = Math.round(e * Math.pow(10, n)) / Math.pow(10, n);
    return r.toFixed(2)
}

function addSpecificDate() {
    PAMH.specific_date_count++;
    $("#specific-date-container").append(PAMH.specific_dates_container);
    $("input.specific_dates_date").last().unbind().removeClass("hasDatepicker").attr({
        autocomplete: "off",
        name: "specific_dates_date_" + PAMH.specific_date_count,
        id: "id_specific_dates_date_" + PAMH.specific_date_count
    }).removeAttr("value").datepicker(PAMH.datePickerOptions);
    var e = $("#specific-date-container").height();
    $("#specific-date-container").animate({
        scrollTop: e
    }, 1e3);
    return false
}
var PAMH = {};

module.exports = PAMH;

require('./listings/add.js');
PAMH.user = require('./user.js');
PAMH.listing_details = require('./listings/details.js');
PAMH.search_results = require('./search/results.js');

PAMH.domain = ("https:" == document.location.protocol ? "https://" : "http://") + (window.location.hostname ? window.location.hostname : "www.justpark.com");
try {
    PAMH.MapsAvailable = typeof google.maps != "undefined" ? true : false
} catch (err) {
    PAMH.MapsAvailable = false
}
PAMH.mapUtils = {};

/**
 * Indicates if the date provided is invalid or not
 */
Date.prototype.isInvalid = function() {
  return Object.prototype.toString.call(this) === "[object Date]" && isNaN(this.getTime());
};

$(function () {
    if ($.browser.mozilla) {
        $("html").addClass("ff")
    } else {
        if ($.browser.webkit) {
            $("html").addClass("webkit")
        } else {
            if ($.browser.msie) {
                $("html").addClass("msie")
            } else {
                if ($.browser.opera) {
                    $("html").addClass("opera")
                }
            }
        }
    }
    // I really don't like this "global" event.
    // I am too scary to remove it from here though.
    // Just an info.
    $(document).ajaxComplete(function () {
        $("form button[disabled]").removeAttr("disabled");
        PAMH.listing_details.setCorrectState();
    });
    $(document).ajaxSend(function (e, t, n) {
        t.setRequestHeader("X-OVERLAY", "1");
    })
});
PAMH.emailRegex = new RegExp("([\\w\\-\\+_]+(\\.[\\w\\-\\+_]+)*@[\\w\\-\\+_]+.[\\w\\-\\+_]+(\\.[\\w\\-\\+_]+)*)", "i");
PAMH.phoneRegex = new RegExp("([0-9]{3,5}[\\.\\s\\-]?[0-9]{3,8}[\\.\\s\\-]?[0-9]{2,5})", "i");
PAMH.websiteRegex = new RegExp("((http://)|(www\\.))([\\w\\d:#@%()~_?\\+-=\\.&]*)", "i");
PAMH.fakePhoneRegex = new RegExp("([0-9o][\\.\\-_]?){8,25}|((zero|one|two|three|four|five|six|seven|eight|nine)[\\.\\-_\\s]*){6,12}", "i");
PAMH.fakeEmailRegex = new RegExp("(btinternet|live\\.co|googlemail|gmail|hotmail|hot mail|yahoo| dot com| dot co| com )", "i");
PAMH.bookingRegex = new RegExp("(?:(?:Booking #)|(?:#B))([0-9]{4,8})", "i");

$(function () {
    $(".search ul.search-results div.heading a").click(function () {
        var e = $(this);
        var t = e.closest("ul").children("li").index(e.parents("li"));
        t++;
        return true
    });
});
jQuery.substitute = function (e, t) {
    return e.replace(/\{(.+?)\}/g, function (e, n) {
        return n in t ? t[n] : e
    })
};
jQuery.expr[":"].econtains = function (e, t, n, r) {
    return (e.textContent || e.innerText || $(e).text() || "").toLowerCase() == n[3].toLowerCase()
};
(function (e) {
    e.fn.serializeJSON = function () {
        var t = {};
        jQuery.map(e(this).serializeArray(), function (e, n) {
            t[e.name] = e.value
        });
        return t
    }
})(jQuery);
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
};
window.log = function () {
    log.history = log.history || [];
    log.history.push(arguments);
    // @todo: this is overriding the window.log original feature. Change it
    if (typeof debug !== 'undefined') {
        debug.log(Array.prototype.slice.call(arguments))
    }
};
(function (e) {
    var t = e.write;
    e.write = function (n) {
        if (/docwriteregexwhitelist/.test(n)) {
            t.apply(e, arguments)
        }
    }
})(document);

require('bootstrap/js/bootstrap-transition.js');
require('bootstrap/js/bootstrap-dropdown.js');
require('bootstrap/js/bootstrap-tab.js');
require('bootstrap/js/bootstrap-tooltip.js');
require('bootstrap/js/bootstrap-popover.js');
require('bootstrap/js/bootstrap-alert.js');
require('bootstrap/js/bootstrap-button.js');
require('bootstrap/js/bootstrap-typeahead.js');

// FIXME: can't use repo, our codebase is incompatible with bootstrap-modal v2.3.2
require('./extensions/modal.js');

// Custom extensions
require('./extensions/character_counter.js');
require('./extensions/growl.js');

// Modules
require('./listings/edit.js');
require('./cancellations/cancellation_end_date.js');


(function (e, t) {
    function n(t, n) {
        var i, s, o, u = t.nodeName.toLowerCase();
        return "area" === u ? (i = t.parentNode, s = i.name, !t.href || !s || i.nodeName.toLowerCase() !== "map" ? !1 : (o = e("img[usemap=#" + s + "]")[0], !!o && r(o))) : (/input|select|textarea|button|object/.test(u) ? !t.disabled : "a" === u ? t.href || n : n) && r(t)
    }

    function r(t) {
        return e.expr.filters.visible(t) && !e(t).parents().addBack().filter(function () {
            return e.css(this, "visibility") === "hidden"
        }).length
    }
    var i = 0,
        s = /^ui-id-\d+$/;
    e.ui = e.ui || {};
    if (e.ui.version) {
        return
    }
    e.extend(e.ui, {
        version: "1.10.0",
        keyCode: {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            NUMPAD_ADD: 107,
            NUMPAD_DECIMAL: 110,
            NUMPAD_DIVIDE: 111,
            NUMPAD_ENTER: 108,
            NUMPAD_MULTIPLY: 106,
            NUMPAD_SUBTRACT: 109,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38
        }
    }), e.fn.extend({
        _focus: e.fn.focus,
        focus: function (t, n) {
            return typeof t == "number" ? this.each(function () {
                var r = this;
                setTimeout(function () {
                    e(r).focus(), n && n.call(r)
                }, t)
            }) : this._focus.apply(this, arguments)
        },
        scrollParent: function () {
            var t;
            return e.ui.ie && /(static|relative)/.test(this.css("position")) || /absolute/.test(this.css("position")) ? t = this.parents().filter(function () {
                return /(relative|absolute|fixed)/.test(e.css(this, "position")) && /(auto|scroll)/.test(e.css(this, "overflow") + e.css(this, "overflow-y") + e.css(this, "overflow-x"))
            }).eq(0) : t = this.parents().filter(function () {
                return /(auto|scroll)/.test(e.css(this, "overflow") + e.css(this, "overflow-y") + e.css(this, "overflow-x"))
            }).eq(0), /fixed/.test(this.css("position")) || !t.length ? e(document) : t
        },
        zIndex: function (n) {
            if (n !== t) {
                return this.css("zIndex", n)
            }
            if (this.length) {
                var r = e(this[0]),
                    i, s;
                while (r.length && r[0] !== document) {
                    i = r.css("position");
                    if (i === "absolute" || i === "relative" || i === "fixed") {
                        s = parseInt(r.css("zIndex"), 10);
                        if (!isNaN(s) && s !== 0) {
                            return s
                        }
                    }
                    r = r.parent()
                }
            }
            return 0
        },
        uniqueId: function () {
            return this.each(function () {
                this.id || (this.id = "ui-id-" + ++i)
            })
        },
        removeUniqueId: function () {
            return this.each(function () {
                s.test(this.id) && e(this).removeAttr("id")
            })
        }
    }), e.extend(e.expr[":"], {
        data: e.expr.createPseudo ? e.expr.createPseudo(function (t) {
            return function (n) {
                return !!e.data(n, t)
            }
        }) : function (t, n, r) {
            return !!e.data(t, r[3])
        },
        focusable: function (t) {
            return n(t, !isNaN(e.attr(t, "tabindex")))
        },
        tabbable: function (t) {
            var r = e.attr(t, "tabindex"),
                i = isNaN(r);
            return (i || r >= 0) && n(t, !i)
        }
    }), e("<a>").outerWidth(1).jquery || e.each(["Width", "Height"], function (n, r) {
        function i(t, n, r, i) {
            return e.each(s, function () {
                n -= parseFloat(e.css(t, "padding" + this)) || 0, r && (n -= parseFloat(e.css(t, "border" + this + "Width")) || 0), i && (n -= parseFloat(e.css(t, "margin" + this)) || 0)
            }), n
        }
        var s = r === "Width" ? ["Left", "Right"] : ["Top", "Bottom"],
            o = r.toLowerCase(),
            u = {
                innerWidth: e.fn.innerWidth,
                innerHeight: e.fn.innerHeight,
                outerWidth: e.fn.outerWidth,
                outerHeight: e.fn.outerHeight
            };
        e.fn["inner" + r] = function (n) {
            return n === t ? u["inner" + r].call(this) : this.each(function () {
                e(this).css(o, i(this, n) + "px")
            })
        }, e.fn["outer" + r] = function (t, n) {
            return typeof t != "number" ? u["outer" + r].call(this, t) : this.each(function () {
                e(this).css(o, i(this, t, !0, n) + "px")
            })
        }
    }), e.fn.addBack || (e.fn.addBack = function (e) {
        return this.add(e == null ? this.prevObject : this.prevObject.filter(e))
    }), e("<a>").data("a-b", "a").removeData("a-b").data("a-b") && (e.fn.removeData = function (t) {
        return function (n) {
            return arguments.length ? t.call(this, e.camelCase(n)) : t.call(this)
        }
    }(e.fn.removeData)), e.ui.ie = !!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()), e.support.selectstart = "onselectstart" in document.createElement("div"), e.fn.extend({
        disableSelection: function () {
            return this.bind((e.support.selectstart ? "selectstart" : "mousedown") + ".ui-disableSelection", function (e) {
                e.preventDefault()
            })
        },
        enableSelection: function () {
            return this.unbind(".ui-disableSelection")
        }
    }), e.extend(e.ui, {
        plugin: {
            add: function (t, n, r) {
                var i, s = e.ui[t].prototype;
                for (i in r) {
                    s.plugins[i] = s.plugins[i] || [], s.plugins[i].push([n, r[i]])
                }
            },
            call: function (e, t, n) {
                var r, i = e.plugins[t];
                if (!i || !e.element[0].parentNode || e.element[0].parentNode.nodeType === 11) {
                    return
                }
                for (r = 0; r < i.length; r++) {
                    e.options[i[r][0]] && i[r][1].apply(e.element, n)
                }
            }
        },
        hasScroll: function (t, n) {
            if (e(t).css("overflow") === "hidden") {
                return !1
            }
            var r = n && n === "left" ? "scrollLeft" : "scrollTop",
                i = !1;
            return t[r] > 0 ? !0 : (t[r] = 1, i = t[r] > 0, t[r] = 0, i)
        }
    })
})(jQuery);
(function (e, t) {
    var n = 0,
        r = Array.prototype.slice,
        i = e.cleanData;
    e.cleanData = function (t) {
        for (var n = 0, r;
            (r = t[n]) != null; n++) {
            try {
                e(r).triggerHandler("remove")
            } catch (s) {}
        }
        i(t)
    }, e.widget = function (t, n, r) {
        var i, s, o, u, a = {},
            f = t.split(".")[0];
        t = t.split(".")[1], i = f + "-" + t, r || (r = n, n = e.Widget), e.expr[":"][i.toLowerCase()] = function (t) {
            return !!e.data(t, i)
        }, e[f] = e[f] || {}, s = e[f][t], o = e[f][t] = function (e, t) {
            if (!this._createWidget) {
                return new o(e, t)
            }
            arguments.length && this._createWidget(e, t)
        }, e.extend(o, s, {
            version: r.version,
            _proto: e.extend({}, r),
            _childConstructors: []
        }), u = new n, u.options = e.widget.extend({}, u.options), e.each(r, function (t, r) {
            if (!e.isFunction(r)) {
                a[t] = r;
                return
            }
            a[t] = function () {
                var e = function () {
                        return n.prototype[t].apply(this, arguments)
                    },
                    i = function (e) {
                        return n.prototype[t].apply(this, e)
                    };
                return function () {
                    var t = this._super,
                        n = this._superApply,
                        s;
                    return this._super = e, this._superApply = i, s = r.apply(this, arguments), this._super = t, this._superApply = n, s
                }
            }()
        }), o.prototype = e.widget.extend(u, {
            widgetEventPrefix: s ? u.widgetEventPrefix : t
        }, a, {
            constructor: o,
            namespace: f,
            widgetName: t,
            widgetFullName: i
        }), s ? (e.each(s._childConstructors, function (t, n) {
            var r = n.prototype;
            e.widget(r.namespace + "." + r.widgetName, o, n._proto)
        }), delete s._childConstructors) : n._childConstructors.push(o), e.widget.bridge(t, o)
    }, e.widget.extend = function (n) {
        var i = r.call(arguments, 1),
            s = 0,
            o = i.length,
            u, a;
        for (; s < o; s++) {
            for (u in i[s]) {
                a = i[s][u], i[s].hasOwnProperty(u) && a !== t && (e.isPlainObject(a) ? n[u] = e.isPlainObject(n[u]) ? e.widget.extend({}, n[u], a) : e.widget.extend({}, a) : n[u] = a)
            }
        }
        return n
    }, e.widget.bridge = function (n, i) {
        var s = i.prototype.widgetFullName || n;
        e.fn[n] = function (o) {
            var u = typeof o == "string",
                a = r.call(arguments, 1),
                f = this;
            return o = !u && a.length ? e.widget.extend.apply(null, [o].concat(a)) : o, u ? this.each(function () {
                var r, i = e.data(this, s);
                if (!i) {
                    return e.error("cannot call methods on " + n + " prior to initialization; attempted to call method '" + o + "'")
                }
                if (!e.isFunction(i[o]) || o.charAt(0) === "_") {
                    return e.error("no such method '" + o + "' for " + n + " widget instance")
                }
                r = i[o].apply(i, a);
                if (r !== i && r !== t) {
                    return f = r && r.jquery ? f.pushStack(r.get()) : r, !1
                }
            }) : this.each(function () {
                var t = e.data(this, s);
                t ? t.option(o || {})._init() : e.data(this, s, new i(o, this))
            }), f
        }
    }, e.Widget = function () {}, e.Widget._childConstructors = [], e.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: {
            disabled: !1,
            create: null
        },
        _createWidget: function (t, r) {
            r = e(r || this.defaultElement || this)[0], this.element = e(r), this.uuid = n++, this.eventNamespace = "." + this.widgetName + this.uuid, this.options = e.widget.extend({}, this.options, this._getCreateOptions(), t), this.bindings = e(), this.hoverable = e(), this.focusable = e(), r !== this && (e.data(r, this.widgetFullName, this), this._on(!0, this.element, {
                remove: function (e) {
                    e.target === r && this.destroy()
                }
            }), this.document = e(r.style ? r.ownerDocument : r.document || r), this.window = e(this.document[0].defaultView || this.document[0].parentWindow)), this._create(), this._trigger("create", null, this._getCreateEventData()), this._init()
        },
        _getCreateOptions: e.noop,
        _getCreateEventData: e.noop,
        _create: e.noop,
        _init: e.noop,
        destroy: function () {
            this._destroy(), this.element.unbind(this.eventNamespace).removeData(this.widgetName).removeData(this.widgetFullName).removeData(e.camelCase(this.widgetFullName)), this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName + "-disabled ui-state-disabled"), this.bindings.unbind(this.eventNamespace), this.hoverable.removeClass("ui-state-hover"), this.focusable.removeClass("ui-state-focus")
        },
        _destroy: e.noop,
        widget: function () {
            return this.element
        },
        option: function (n, r) {
            var i = n,
                s, o, u;
            if (arguments.length === 0) {
                return e.widget.extend({}, this.options)
            }
            if (typeof n == "string") {
                i = {}, s = n.split("."), n = s.shift();
                if (s.length) {
                    o = i[n] = e.widget.extend({}, this.options[n]);
                    for (u = 0; u < s.length - 1; u++) {
                        o[s[u]] = o[s[u]] || {}, o = o[s[u]]
                    }
                    n = s.pop();
                    if (r === t) {
                        return o[n] === t ? null : o[n]
                    }
                    o[n] = r
                } else {
                    if (r === t) {
                        return this.options[n] === t ? null : this.options[n]
                    }
                    i[n] = r
                }
            }
            return this._setOptions(i), this
        },
        _setOptions: function (e) {
            var t;
            for (t in e) {
                this._setOption(t, e[t])
            }
            return this
        },
        _setOption: function (e, t) {
            return this.options[e] = t, e === "disabled" && (this.widget().toggleClass(this.widgetFullName + "-disabled ui-state-disabled", !!t).attr("aria-disabled", t), this.hoverable.removeClass("ui-state-hover"), this.focusable.removeClass("ui-state-focus")), this
        },
        enable: function () {
            return this._setOption("disabled", !1)
        },
        disable: function () {
            return this._setOption("disabled", !0)
        },
        _on: function (t, n, r) {
            var i, s = this;
            typeof t != "boolean" && (r = n, n = t, t = !1), r ? (n = i = e(n), this.bindings = this.bindings.add(n)) : (r = n, n = this.element, i = this.widget()), e.each(r, function (r, o) {
                function u() {
                    if (!t && (s.options.disabled === !0 || e(this).hasClass("ui-state-disabled"))) {
                        return
                    }
                    return (typeof o == "string" ? s[o] : o).apply(s, arguments)
                }
                typeof o != "string" && (u.guid = o.guid = o.guid || u.guid || e.guid++);
                var a = r.match(/^(\w+)\s*(.*)$/),
                    f = a[1] + s.eventNamespace,
                    l = a[2];
                l ? i.delegate(l, f, u) : n.bind(f, u)
            })
        },
        _off: function (e, t) {
            t = (t || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace, e.unbind(t).undelegate(t)
        },
        _delay: function (e, t) {
            function n() {
                return (typeof e == "string" ? r[e] : e).apply(r, arguments)
            }
            var r = this;
            return setTimeout(n, t || 0)
        },
        _hoverable: function (t) {
            this.hoverable = this.hoverable.add(t), this._on(t, {
                mouseenter: function (t) {
                    e(t.currentTarget).addClass("ui-state-hover")
                },
                mouseleave: function (t) {
                    e(t.currentTarget).removeClass("ui-state-hover")
                }
            })
        },
        _focusable: function (t) {
            this.focusable = this.focusable.add(t), this._on(t, {
                focusin: function (t) {
                    e(t.currentTarget).addClass("ui-state-focus")
                },
                focusout: function (t) {
                    e(t.currentTarget).removeClass("ui-state-focus")
                }
            })
        },
        _trigger: function (t, n, r) {
            var i, s, o = this.options[t];
            r = r || {}, n = e.Event(n), n.type = (t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t).toLowerCase(), n.target = this.element[0], s = n.originalEvent;
            if (s) {
                for (i in s) {
                    i in n || (n[i] = s[i])
                }
            }
            return this.element.trigger(n, r), !(e.isFunction(o) && o.apply(this.element[0], [n].concat(r)) === !1 || n.isDefaultPrevented())
        }
    }, e.each({
        show: "fadeIn",
        hide: "fadeOut"
    }, function (t, n) {
        e.Widget.prototype["_" + t] = function (r, i, s) {
            typeof i == "string" && (i = {
                effect: i
            });
            var o, u = i ? i === !0 || typeof i == "number" ? n : i.effect || n : t;
            i = i || {}, typeof i == "number" && (i = {
                duration: i
            }), o = !e.isEmptyObject(i), i.complete = s, i.delay && r.delay(i.delay), o && e.effects && e.effects.effect[u] ? r[t](i) : u !== t && r[u] ? r[u](i.duration, i.easing, s) : r.queue(function (n) {
                e(this)[t](), s && s.call(r[0]), n()
            })
        }
    })
})(jQuery);
(function (e, t) {
    var n = !1;
    e(document).mouseup(function () {
        n = !1
    }), e.widget("ui.mouse", {
        version: "1.10.0",
        options: {
            cancel: "input,textarea,button,select,option",
            distance: 1,
            delay: 0
        },
        _mouseInit: function () {
            var t = this;
            this.element.bind("mousedown." + this.widgetName, function (e) {
                return t._mouseDown(e)
            }).bind("click." + this.widgetName, function (n) {
                if (!0 === e.data(n.target, t.widgetName + ".preventClickEvent")) {
                    return e.removeData(n.target, t.widgetName + ".preventClickEvent"), n.stopImmediatePropagation(), !1
                }
            }), this.started = !1
        },
        _mouseDestroy: function () {
            this.element.unbind("." + this.widgetName), this._mouseMoveDelegate && e(document).unbind("mousemove." + this.widgetName, this._mouseMoveDelegate).unbind("mouseup." + this.widgetName, this._mouseUpDelegate)
        },
        _mouseDown: function (t) {
            if (n) {
                return
            }
            this._mouseStarted && this._mouseUp(t), this._mouseDownEvent = t;
            var r = this,
                i = t.which === 1,
                s = typeof this.options.cancel == "string" && t.target.nodeName ? e(t.target).closest(this.options.cancel).length : !1;
            if (!i || s || !this._mouseCapture(t)) {
                return !0
            }
            this.mouseDelayMet = !this.options.delay, this.mouseDelayMet || (this._mouseDelayTimer = setTimeout(function () {
                r.mouseDelayMet = !0
            }, this.options.delay));
            if (this._mouseDistanceMet(t) && this._mouseDelayMet(t)) {
                this._mouseStarted = this._mouseStart(t) !== !1;
                if (!this._mouseStarted) {
                    return t.preventDefault(), !0
                }
            }
            return !0 === e.data(t.target, this.widgetName + ".preventClickEvent") && e.removeData(t.target, this.widgetName + ".preventClickEvent"), this._mouseMoveDelegate = function (e) {
                return r._mouseMove(e)
            }, this._mouseUpDelegate = function (e) {
                return r._mouseUp(e)
            }, e(document).bind("mousemove." + this.widgetName, this._mouseMoveDelegate).bind("mouseup." + this.widgetName, this._mouseUpDelegate), t.preventDefault(), n = !0, !0
        },
        _mouseMove: function (t) {
            return e.ui.ie && (!document.documentMode || document.documentMode < 9) && !t.button ? this._mouseUp(t) : this._mouseStarted ? (this._mouseDrag(t), t.preventDefault()) : (this._mouseDistanceMet(t) && this._mouseDelayMet(t) && (this._mouseStarted = this._mouseStart(this._mouseDownEvent, t) !== !1, this._mouseStarted ? this._mouseDrag(t) : this._mouseUp(t)), !this._mouseStarted)
        },
        _mouseUp: function (t) {
            return e(document).unbind("mousemove." + this.widgetName, this._mouseMoveDelegate).unbind("mouseup." + this.widgetName, this._mouseUpDelegate), this._mouseStarted && (this._mouseStarted = !1, t.target === this._mouseDownEvent.target && e.data(t.target, this.widgetName + ".preventClickEvent", !0), this._mouseStop(t)), !1
        },
        _mouseDistanceMet: function (e) {
            return Math.max(Math.abs(this._mouseDownEvent.pageX - e.pageX), Math.abs(this._mouseDownEvent.pageY - e.pageY)) >= this.options.distance
        },
        _mouseDelayMet: function () {
            return this.mouseDelayMet
        },
        _mouseStart: function () {},
        _mouseDrag: function () {},
        _mouseStop: function () {},
        _mouseCapture: function () {
            return !0
        }
    })
})(jQuery);
(function (e, t) {
    e.widget("ui.draggable", e.ui.mouse, {
        version: "1.10.0",
        widgetEventPrefix: "drag",
        options: {
            addClasses: !0,
            appendTo: "parent",
            axis: !1,
            connectToSortable: !1,
            containment: !1,
            cursor: "auto",
            cursorAt: !1,
            grid: !1,
            handle: !1,
            helper: "original",
            iframeFix: !1,
            opacity: !1,
            refreshPositions: !1,
            revert: !1,
            revertDuration: 500,
            scope: "default",
            scroll: !0,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            snap: !1,
            snapMode: "both",
            snapTolerance: 20,
            stack: !1,
            zIndex: !1,
            drag: null,
            start: null,
            stop: null
        },
        _create: function () {
            this.options.helper === "original" && !/^(?:r|a|f)/.test(this.element.css("position")) && (this.element[0].style.position = "relative"), this.options.addClasses && this.element.addClass("ui-draggable"), this.options.disabled && this.element.addClass("ui-draggable-disabled"), this._mouseInit()
        },
        _destroy: function () {
            this.element.removeClass("ui-draggable ui-draggable-dragging ui-draggable-disabled"), this._mouseDestroy()
        },
        _mouseCapture: function (t) {
            var n = this.options;
            return this.helper || n.disabled || e(t.target).closest(".ui-resizable-handle").length > 0 ? !1 : (this.handle = this._getHandle(t), this.handle ? (e(n.iframeFix === !0 ? "iframe" : n.iframeFix).each(function () {
                e("<div class='ui-draggable-iframeFix' style='background: #fff;'></div>").css({
                    width: this.offsetWidth + "px",
                    height: this.offsetHeight + "px",
                    position: "absolute",
                    opacity: "0.001",
                    zIndex: 1e3
                }).css(e(this).offset()).appendTo("body")
            }), !0) : !1)
        },
        _mouseStart: function (t) {
            var n = this.options;
            return this.helper = this._createHelper(t), this.helper.addClass("ui-draggable-dragging"), this._cacheHelperProportions(), e.ui.ddmanager && (e.ui.ddmanager.current = this), this._cacheMargins(), this.cssPosition = this.helper.css("position"), this.scrollParent = this.helper.scrollParent(), this.offset = this.positionAbs = this.element.offset(), this.offset = {
                top: this.offset.top - this.margins.top,
                left: this.offset.left - this.margins.left
            }, e.extend(this.offset, {
                click: {
                    left: t.pageX - this.offset.left,
                    top: t.pageY - this.offset.top
                },
                parent: this._getParentOffset(),
                relative: this._getRelativeOffset()
            }), this.originalPosition = this.position = this._generatePosition(t), this.originalPageX = t.pageX, this.originalPageY = t.pageY, n.cursorAt && this._adjustOffsetFromHelper(n.cursorAt), n.containment && this._setContainment(), this._trigger("start", t) === !1 ? (this._clear(), !1) : (this._cacheHelperProportions(), e.ui.ddmanager && !n.dropBehaviour && e.ui.ddmanager.prepareOffsets(this, t), this._mouseDrag(t, !0), e.ui.ddmanager && e.ui.ddmanager.dragStart(this, t), !0)
        },
        _mouseDrag: function (t, n) {
            this.position = this._generatePosition(t), this.positionAbs = this._convertPositionTo("absolute");
            if (!n) {
                var r = this._uiHash();
                if (this._trigger("drag", t, r) === !1) {
                    return this._mouseUp({}), !1
                }
                this.position = r.position
            }
            if (!this.options.axis || this.options.axis !== "y") {
                this.helper[0].style.left = this.position.left + "px"
            }
            if (!this.options.axis || this.options.axis !== "x") {
                this.helper[0].style.top = this.position.top + "px"
            }
            return e.ui.ddmanager && e.ui.ddmanager.drag(this, t), !1
        },
        _mouseStop: function (t) {
            var n, r = this,
                i = !1,
                s = !1;
            e.ui.ddmanager && !this.options.dropBehaviour && (s = e.ui.ddmanager.drop(this, t)), this.dropped && (s = this.dropped, this.dropped = !1), n = this.element[0];
            while (n && (n = n.parentNode)) {
                n === document && (i = !0)
            }
            return !i && this.options.helper === "original" ? !1 : (this.options.revert === "invalid" && !s || this.options.revert === "valid" && s || this.options.revert === !0 || e.isFunction(this.options.revert) && this.options.revert.call(this.element, s) ? e(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function () {
                r._trigger("stop", t) !== !1 && r._clear()
            }) : this._trigger("stop", t) !== !1 && this._clear(), !1)
        },
        _mouseUp: function (t) {
            return e("div.ui-draggable-iframeFix").each(function () {
                this.parentNode.removeChild(this)
            }), e.ui.ddmanager && e.ui.ddmanager.dragStop(this, t), e.ui.mouse.prototype._mouseUp.call(this, t)
        },
        cancel: function () {
            return this.helper.is(".ui-draggable-dragging") ? this._mouseUp({}) : this._clear(), this
        },
        _getHandle: function (t) {
            var n = !this.options.handle || !e(this.options.handle, this.element).length ? !0 : !1;
            return e(this.options.handle, this.element).find("*").addBack().each(function () {
                this === t.target && (n = !0)
            }), n
        },
        _createHelper: function (t) {
            var n = this.options,
                r = e.isFunction(n.helper) ? e(n.helper.apply(this.element[0], [t])) : n.helper === "clone" ? this.element.clone().removeAttr("id") : this.element;
            return r.parents("body").length || r.appendTo(n.appendTo === "parent" ? this.element[0].parentNode : n.appendTo), r[0] !== this.element[0] && !/(fixed|absolute)/.test(r.css("position")) && r.css("position", "absolute"), r
        },
        _adjustOffsetFromHelper: function (t) {
            typeof t == "string" && (t = t.split(" ")), e.isArray(t) && (t = {
                left: +t[0],
                top: +t[1] || 0
            }), "left" in t && (this.offset.click.left = t.left + this.margins.left), "right" in t && (this.offset.click.left = this.helperProportions.width - t.right + this.margins.left), "top" in t && (this.offset.click.top = t.top + this.margins.top), "bottom" in t && (this.offset.click.top = this.helperProportions.height - t.bottom + this.margins.top)
        },
        _getParentOffset: function () {
            this.offsetParent = this.helper.offsetParent();
            var t = this.offsetParent.offset();
            this.cssPosition === "absolute" && this.scrollParent[0] !== document && e.contains(this.scrollParent[0], this.offsetParent[0]) && (t.left += this.scrollParent.scrollLeft(), t.top += this.scrollParent.scrollTop());
            if (this.offsetParent[0] === document.body || this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() === "html" && e.ui.ie) {
                t = {
                    top: 0,
                    left: 0
                }
            }
            return {
                top: t.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
                left: t.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
            }
        },
        _getRelativeOffset: function () {
            if (this.cssPosition === "relative") {
                var e = this.element.position();
                return {
                    top: e.top - (parseInt(this.helper.css("top"), 10) || 0) + this.scrollParent.scrollTop(),
                    left: e.left - (parseInt(this.helper.css("left"), 10) || 0) + this.scrollParent.scrollLeft()
                }
            }
            return {
                top: 0,
                left: 0
            }
        },
        _cacheMargins: function () {
            this.margins = {
                left: parseInt(this.element.css("marginLeft"), 10) || 0,
                top: parseInt(this.element.css("marginTop"), 10) || 0,
                right: parseInt(this.element.css("marginRight"), 10) || 0,
                bottom: parseInt(this.element.css("marginBottom"), 10) || 0
            }
        },
        _cacheHelperProportions: function () {
            this.helperProportions = {
                width: this.helper.outerWidth(),
                height: this.helper.outerHeight()
            }
        },
        _setContainment: function () {
            var t, n, r, i = this.options;
            i.containment === "parent" && (i.containment = this.helper[0].parentNode);
            if (i.containment === "document" || i.containment === "window") {
                this.containment = [i.containment === "document" ? 0 : e(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left, i.containment === "document" ? 0 : e(window).scrollTop() - this.offset.relative.top - this.offset.parent.top, (i.containment === "document" ? 0 : e(window).scrollLeft()) + e(i.containment === "document" ? document : window).width() - this.helperProportions.width - this.margins.left, (i.containment === "document" ? 0 : e(window).scrollTop()) + (e(i.containment === "document" ? document : window).height() || document.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top]
            }
            if (!/^(document|window|parent)$/.test(i.containment) && i.containment.constructor !== Array) {
                n = e(i.containment), r = n[0];
                if (!r) {
                    return
                }
                t = e(r).css("overflow") !== "hidden", this.containment = [(parseInt(e(r).css("borderLeftWidth"), 10) || 0) + (parseInt(e(r).css("paddingLeft"), 10) || 0), (parseInt(e(r).css("borderTopWidth"), 10) || 0) + (parseInt(e(r).css("paddingTop"), 10) || 0), (t ? Math.max(r.scrollWidth, r.offsetWidth) : r.offsetWidth) - (parseInt(e(r).css("borderLeftWidth"), 10) || 0) - (parseInt(e(r).css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left - this.margins.right, (t ? Math.max(r.scrollHeight, r.offsetHeight) : r.offsetHeight) - (parseInt(e(r).css("borderTopWidth"), 10) || 0) - (parseInt(e(r).css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top - this.margins.bottom], this.relative_container = n
            } else {
                i.containment.constructor === Array && (this.containment = i.containment)
            }
        },
        _convertPositionTo: function (t, n) {
            n || (n = this.position);
            var r = t === "absolute" ? 1 : -1,
                i = this.cssPosition !== "absolute" || this.scrollParent[0] !== document && !!e.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent,
                s = /(html|body)/i.test(i[0].tagName);
            return {
                top: n.top + this.offset.relative.top * r + this.offset.parent.top * r - (this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : s ? 0 : i.scrollTop()) * r,
                left: n.left + this.offset.relative.left * r + this.offset.parent.left * r - (this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : s ? 0 : i.scrollLeft()) * r
            }
        },
        _generatePosition: function (t) {
            var n, r, i, s, o = this.options,
                u = this.cssPosition !== "absolute" || this.scrollParent[0] !== document && !!e.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent,
                a = /(html|body)/i.test(u[0].tagName),
                f = t.pageX,
                l = t.pageY;
            return this.originalPosition && (this.containment && (this.relative_container ? (r = this.relative_container.offset(), n = [this.containment[0] + r.left, this.containment[1] + r.top, this.containment[2] + r.left, this.containment[3] + r.top]) : n = this.containment, t.pageX - this.offset.click.left < n[0] && (f = n[0] + this.offset.click.left), t.pageY - this.offset.click.top < n[1] && (l = n[1] + this.offset.click.top), t.pageX - this.offset.click.left > n[2] && (f = n[2] + this.offset.click.left), t.pageY - this.offset.click.top > n[3] && (l = n[3] + this.offset.click.top)), o.grid && (i = o.grid[1] ? this.originalPageY + Math.round((l - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY, l = n ? i - this.offset.click.top >= n[1] || i - this.offset.click.top > n[3] ? i : i - this.offset.click.top >= n[1] ? i - o.grid[1] : i + o.grid[1] : i, s = o.grid[0] ? this.originalPageX + Math.round((f - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX, f = n ? s - this.offset.click.left >= n[0] || s - this.offset.click.left > n[2] ? s : s - this.offset.click.left >= n[0] ? s - o.grid[0] : s + o.grid[0] : s)), {
                top: l - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + (this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : a ? 0 : u.scrollTop()),
                left: f - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + (this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : a ? 0 : u.scrollLeft())
            }
        },
        _clear: function () {
            this.helper.removeClass("ui-draggable-dragging"), this.helper[0] !== this.element[0] && !this.cancelHelperRemoval && this.helper.remove(), this.helper = null, this.cancelHelperRemoval = !1
        },
        _trigger: function (t, n, r) {
            return r = r || this._uiHash(), e.ui.plugin.call(this, t, [n, r]), t === "drag" && (this.positionAbs = this._convertPositionTo("absolute")), e.Widget.prototype._trigger.call(this, t, n, r)
        },
        plugins: {},
        _uiHash: function () {
            return {
                helper: this.helper,
                position: this.position,
                originalPosition: this.originalPosition,
                offset: this.positionAbs
            }
        }
    }), e.ui.plugin.add("draggable", "connectToSortable", {
        start: function (t, n) {
            var r = e(this).data("ui-draggable"),
                i = r.options,
                s = e.extend({}, n, {
                    item: r.element
                });
            r.sortables = [], e(i.connectToSortable).each(function () {
                var n = e.data(this, "ui-sortable");
                n && !n.options.disabled && (r.sortables.push({
                    instance: n,
                    shouldRevert: n.options.revert
                }), n.refreshPositions(), n._trigger("activate", t, s))
            })
        },
        stop: function (t, n) {
            var r = e(this).data("ui-draggable"),
                i = e.extend({}, n, {
                    item: r.element
                });
            e.each(r.sortables, function () {
                this.instance.isOver ? (this.instance.isOver = 0, r.cancelHelperRemoval = !0, this.instance.cancelHelperRemoval = !1, this.shouldRevert && (this.instance.options.revert = !0), this.instance._mouseStop(t), this.instance.options.helper = this.instance.options._helper, r.options.helper === "original" && this.instance.currentItem.css({
                    top: "auto",
                    left: "auto"
                })) : (this.instance.cancelHelperRemoval = !1, this.instance._trigger("deactivate", t, i))
            })
        },
        drag: function (t, n) {
            var r = e(this).data("ui-draggable"),
                i = this;
            e.each(r.sortables, function () {
                var s = !1,
                    o = this;
                this.instance.positionAbs = r.positionAbs, this.instance.helperProportions = r.helperProportions, this.instance.offset.click = r.offset.click, this.instance._intersectsWith(this.instance.containerCache) && (s = !0, e.each(r.sortables, function () {
                    return this.instance.positionAbs = r.positionAbs, this.instance.helperProportions = r.helperProportions, this.instance.offset.click = r.offset.click, this !== o && this.instance._intersectsWith(this.instance.containerCache) && e.ui.contains(o.instance.element[0], this.instance.element[0]) && (s = !1), s
                })), s ? (this.instance.isOver || (this.instance.isOver = 1, this.instance.currentItem = e(i).clone().removeAttr("id").appendTo(this.instance.element).data("ui-sortable-item", !0), this.instance.options._helper = this.instance.options.helper, this.instance.options.helper = function () {
                    return n.helper[0]
                }, t.target = this.instance.currentItem[0], this.instance._mouseCapture(t, !0), this.instance._mouseStart(t, !0, !0), this.instance.offset.click.top = r.offset.click.top, this.instance.offset.click.left = r.offset.click.left, this.instance.offset.parent.left -= r.offset.parent.left - this.instance.offset.parent.left, this.instance.offset.parent.top -= r.offset.parent.top - this.instance.offset.parent.top, r._trigger("toSortable", t), r.dropped = this.instance.element, r.currentItem = r.element, this.instance.fromOutside = r), this.instance.currentItem && this.instance._mouseDrag(t)) : this.instance.isOver && (this.instance.isOver = 0, this.instance.cancelHelperRemoval = !0, this.instance.options.revert = !1, this.instance._trigger("out", t, this.instance._uiHash(this.instance)), this.instance._mouseStop(t, !0), this.instance.options.helper = this.instance.options._helper, this.instance.currentItem.remove(), this.instance.placeholder && this.instance.placeholder.remove(), r._trigger("fromSortable", t), r.dropped = !1)
            })
        }
    }), e.ui.plugin.add("draggable", "cursor", {
        start: function () {
            var t = e("body"),
                n = e(this).data("ui-draggable").options;
            t.css("cursor") && (n._cursor = t.css("cursor")), t.css("cursor", n.cursor)
        },
        stop: function () {
            var t = e(this).data("ui-draggable").options;
            t._cursor && e("body").css("cursor", t._cursor)
        }
    }), e.ui.plugin.add("draggable", "opacity", {
        start: function (t, n) {
            var r = e(n.helper),
                i = e(this).data("ui-draggable").options;
            r.css("opacity") && (i._opacity = r.css("opacity")), r.css("opacity", i.opacity)
        },
        stop: function (t, n) {
            var r = e(this).data("ui-draggable").options;
            r._opacity && e(n.helper).css("opacity", r._opacity)
        }
    }), e.ui.plugin.add("draggable", "scroll", {
        start: function () {
            var t = e(this).data("ui-draggable");
            t.scrollParent[0] !== document && t.scrollParent[0].tagName !== "HTML" && (t.overflowOffset = t.scrollParent.offset())
        },
        drag: function (t) {
            var n = e(this).data("ui-draggable"),
                r = n.options,
                i = !1;
            if (n.scrollParent[0] !== document && n.scrollParent[0].tagName !== "HTML") {
                if (!r.axis || r.axis !== "x") {
                    n.overflowOffset.top + n.scrollParent[0].offsetHeight - t.pageY < r.scrollSensitivity ? n.scrollParent[0].scrollTop = i = n.scrollParent[0].scrollTop + r.scrollSpeed : t.pageY - n.overflowOffset.top < r.scrollSensitivity && (n.scrollParent[0].scrollTop = i = n.scrollParent[0].scrollTop - r.scrollSpeed)
                }
                if (!r.axis || r.axis !== "y") {
                    n.overflowOffset.left + n.scrollParent[0].offsetWidth - t.pageX < r.scrollSensitivity ? n.scrollParent[0].scrollLeft = i = n.scrollParent[0].scrollLeft + r.scrollSpeed : t.pageX - n.overflowOffset.left < r.scrollSensitivity && (n.scrollParent[0].scrollLeft = i = n.scrollParent[0].scrollLeft - r.scrollSpeed)
                }
            } else {
                if (!r.axis || r.axis !== "x") {
                    t.pageY - e(document).scrollTop() < r.scrollSensitivity ? i = e(document).scrollTop(e(document).scrollTop() - r.scrollSpeed) : e(window).height() - (t.pageY - e(document).scrollTop()) < r.scrollSensitivity && (i = e(document).scrollTop(e(document).scrollTop() + r.scrollSpeed))
                }
                if (!r.axis || r.axis !== "y") {
                    t.pageX - e(document).scrollLeft() < r.scrollSensitivity ? i = e(document).scrollLeft(e(document).scrollLeft() - r.scrollSpeed) : e(window).width() - (t.pageX - e(document).scrollLeft()) < r.scrollSensitivity && (i = e(document).scrollLeft(e(document).scrollLeft() + r.scrollSpeed))
                }
            }
            i !== !1 && e.ui.ddmanager && !r.dropBehaviour && e.ui.ddmanager.prepareOffsets(n, t)
        }
    }), e.ui.plugin.add("draggable", "snap", {
        start: function () {
            var t = e(this).data("ui-draggable"),
                n = t.options;
            t.snapElements = [], e(n.snap.constructor !== String ? n.snap.items || ":data(ui-draggable)" : n.snap).each(function () {
                var n = e(this),
                    r = n.offset();
                this !== t.element[0] && t.snapElements.push({
                    item: this,
                    width: n.outerWidth(),
                    height: n.outerHeight(),
                    top: r.top,
                    left: r.left
                })
            })
        },
        drag: function (t, n) {
            var r, i, s, o, u, a, f, l, c, h, p = e(this).data("ui-draggable"),
                d = p.options,
                v = d.snapTolerance,
                m = n.offset.left,
                g = m + p.helperProportions.width,
                y = n.offset.top,
                w = y + p.helperProportions.height;
            for (c = p.snapElements.length - 1; c >= 0; c--) {
                u = p.snapElements[c].left, a = u + p.snapElements[c].width, f = p.snapElements[c].top, l = f + p.snapElements[c].height;
                if (!(u - v < m && m < a + v && f - v < y && y < l + v || u - v < m && m < a + v && f - v < w && w < l + v || u - v < g && g < a + v && f - v < y && y < l + v || u - v < g && g < a + v && f - v < w && w < l + v)) {
                    p.snapElements[c].snapping && p.options.snap.release && p.options.snap.release.call(p.element, t, e.extend(p._uiHash(), {
                        snapItem: p.snapElements[c].item
                    })), p.snapElements[c].snapping = !1;
                    continue
                }
                d.snapMode !== "inner" && (r = Math.abs(f - w) <= v, i = Math.abs(l - y) <= v, s = Math.abs(u - g) <= v, o = Math.abs(a - m) <= v, r && (n.position.top = p._convertPositionTo("relative", {
                    top: f - p.helperProportions.height,
                    left: 0
                }).top - p.margins.top), i && (n.position.top = p._convertPositionTo("relative", {
                    top: l,
                    left: 0
                }).top - p.margins.top), s && (n.position.left = p._convertPositionTo("relative", {
                    top: 0,
                    left: u - p.helperProportions.width
                }).left - p.margins.left), o && (n.position.left = p._convertPositionTo("relative", {
                    top: 0,
                    left: a
                }).left - p.margins.left)), h = r || i || s || o, d.snapMode !== "outer" && (r = Math.abs(f - y) <= v, i = Math.abs(l - w) <= v, s = Math.abs(u - m) <= v, o = Math.abs(a - g) <= v, r && (n.position.top = p._convertPositionTo("relative", {
                    top: f,
                    left: 0
                }).top - p.margins.top), i && (n.position.top = p._convertPositionTo("relative", {
                    top: l - p.helperProportions.height,
                    left: 0
                }).top - p.margins.top), s && (n.position.left = p._convertPositionTo("relative", {
                    top: 0,
                    left: u
                }).left - p.margins.left), o && (n.position.left = p._convertPositionTo("relative", {
                    top: 0,
                    left: a - p.helperProportions.width
                }).left - p.margins.left)), !p.snapElements[c].snapping && (r || i || s || o || h) && p.options.snap.snap && p.options.snap.snap.call(p.element, t, e.extend(p._uiHash(), {
                    snapItem: p.snapElements[c].item
                })), p.snapElements[c].snapping = r || i || s || o || h
            }
        }
    }), e.ui.plugin.add("draggable", "stack", {
        start: function () {
            var t, n = e(this).data("ui-draggable").options,
                r = e.makeArray(e(n.stack)).sort(function (t, n) {
                    return (parseInt(e(t).css("zIndex"), 10) || 0) - (parseInt(e(n).css("zIndex"), 10) || 0)
                });
            if (!r.length) {
                return
            }
            t = parseInt(r[0].style.zIndex, 10) || 0, e(r).each(function (e) {
                this.style.zIndex = t + e
            }), this[0].style.zIndex = t + r.length
        }
    }), e.ui.plugin.add("draggable", "zIndex", {
        start: function (t, n) {
            var r = e(n.helper),
                i = e(this).data("ui-draggable").options;
            r.css("zIndex") && (i._zIndex = r.css("zIndex")), r.css("zIndex", i.zIndex)
        },
        stop: function (t, n) {
            var r = e(this).data("ui-draggable").options;
            r._zIndex && e(n.helper).css("zIndex", r._zIndex)
        }
    })
})(jQuery);
(function (e, t) {
    function n() {
        this._curInst = null, this._keyEvent = !1, this._disabledInputs = [], this._datepickerShowing = !1, this._inDialog = !1, this._mainDivId = "ui-datepicker-div", this._inlineClass = "ui-datepicker-inline", this._appendClass = "ui-datepicker-append", this._triggerClass = "ui-datepicker-trigger", this._dialogClass = "ui-datepicker-dialog", this._disableClass = "ui-datepicker-disabled", this._unselectableClass = "ui-datepicker-unselectable", this._currentClass = "ui-datepicker-current-day", this._dayOverClass = "ui-datepicker-days-cell-over", this.regional = [], this.regional[""] = {
            closeText: "Done",
            prevText: "Prev",
            nextText: "Next",
            currentText: "Today",
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            weekHeader: "Wk",
            dateFormat: "mm/dd/yy",
            firstDay: 0,
            isRTL: !1,
            showMonthAfterYear: !1,
            yearSuffix: ""
        }, this._defaults = {
            showOn: "focus",
            showAnim: "fadeIn",
            showOptions: {},
            defaultDate: null,
            appendText: "",
            buttonText: "...",
            buttonImage: "",
            buttonImageOnly: !1,
            hideIfNoPrevNext: !1,
            navigationAsDateFormat: !1,
            gotoCurrent: !1,
            changeMonth: !1,
            changeYear: !1,
            yearRange: "c-10:c+10",
            showOtherMonths: !1,
            selectOtherMonths: !1,
            showWeek: !1,
            calculateWeek: this.iso8601Week,
            shortYearCutoff: "+10",
            minDate: null,
            maxDate: null,
            duration: "fast",
            beforeShowDay: null,
            beforeShow: null,
            onSelect: null,
            onChangeMonthYear: null,
            onClose: null,
            numberOfMonths: 1,
            showCurrentAtPos: 0,
            stepMonths: 1,
            stepBigMonths: 12,
            altField: "",
            altFormat: "",
            constrainInput: !0,
            showButtonPanel: !1,
            autoSize: !1,
            disabled: !1
        }, e.extend(this._defaults, this.regional[""]), this.dpDiv = r(e("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))
    }

    function r(t) {
        var n = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
        return t.delegate(n, "mouseout", function () {
            e(this).removeClass("ui-state-hover"), this.className.indexOf("ui-datepicker-prev") !== -1 && e(this).removeClass("ui-datepicker-prev-hover"), this.className.indexOf("ui-datepicker-next") !== -1 && e(this).removeClass("ui-datepicker-next-hover")
        }).delegate(n, "mouseover", function () {
            e.datepicker._isDisabledDatepicker(u.inline ? t.parent()[0] : u.input[0]) || (e(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"), e(this).addClass("ui-state-hover"), this.className.indexOf("ui-datepicker-prev") !== -1 && e(this).addClass("ui-datepicker-prev-hover"), this.className.indexOf("ui-datepicker-next") !== -1 && e(this).addClass("ui-datepicker-next-hover"))
        })
    }

    function i(t, n) {
        e.extend(t, n);
        for (var r in n) {
            n[r] == null && (t[r] = n[r])
        }
        return t
    }
    e.extend(e.ui, {
        datepicker: {
            version: "1.10.0"
        }
    });
    var s = "datepicker",
        o = (new Date).getTime(),
        u;
    e.extend(n.prototype, {
        markerClassName: "hasDatepicker",
        maxRows: 4,
        _widgetDatepicker: function () {
            return this.dpDiv
        },
        setDefaults: function (e) {
            return i(this._defaults, e || {}), this
        },
        _attachDatepicker: function (t, n) {
            var r, i, s;
            r = t.nodeName.toLowerCase(), i = r === "div" || r === "span", t.id || (this.uuid += 1, t.id = "dp" + this.uuid), s = this._newInst(e(t), i), s.settings = e.extend({}, n || {}), r === "input" ? this._connectDatepicker(t, s) : i && this._inlineDatepicker(t, s)
        },
        _newInst: function (t, n) {
            var i = t[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1");
            return {
                id: i,
                input: t,
                selectedDay: 0,
                selectedMonth: 0,
                selectedYear: 0,
                drawMonth: 0,
                drawYear: 0,
                inline: n,
                dpDiv: n ? r(e("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")) : this.dpDiv
            }
        },
        _connectDatepicker: function (t, n) {
            var r = e(t);
            n.append = e([]), n.trigger = e([]);
            if (r.hasClass(this.markerClassName)) {
                return
            }
            this._attachments(r, n), r.addClass(this.markerClassName).keydown(this._doKeyDown).keypress(this._doKeyPress).keyup(this._doKeyUp), this._autoSize(n), e.data(t, s, n), n.settings.disabled && this._disableDatepicker(t)
        },
        _attachments: function (t, n) {
            var r, i, s, o = this._get(n, "appendText"),
                u = this._get(n, "isRTL");
            n.append && n.append.remove(), o && (n.append = e("<span class='" + this._appendClass + "'>" + o + "</span>"), t[u ? "before" : "after"](n.append)), t.unbind("focus", this._showDatepicker), n.trigger && n.trigger.remove(), r = this._get(n, "showOn"), (r === "focus" || r === "both") && t.focus(this._showDatepicker);
            if (r === "button" || r === "both") {
                i = this._get(n, "buttonText"), s = this._get(n, "buttonImage"), n.trigger = e(this._get(n, "buttonImageOnly") ? e("<img/>").addClass(this._triggerClass).attr({
                    src: s,
                    alt: i,
                    title: i
                }) : e("<button type='button'></button>").addClass(this._triggerClass).html(s ? e("<img/>").attr({
                    src: s,
                    alt: i,
                    title: i
                }) : i)), t[u ? "before" : "after"](n.trigger), n.trigger.click(function () {
                    return e.datepicker._datepickerShowing && e.datepicker._lastInput === t[0] ? e.datepicker._hideDatepicker() : e.datepicker._datepickerShowing && e.datepicker._lastInput !== t[0] ? (e.datepicker._hideDatepicker(), e.datepicker._showDatepicker(t[0])) : e.datepicker._showDatepicker(t[0]), !1
                })
            }
        },
        _autoSize: function (e) {
            if (this._get(e, "autoSize") && !e.inline) {
                var t, n, r, i, s = new Date(2009, 11, 20),
                    o = this._get(e, "dateFormat");
                o.match(/[DM]/) && (t = function (e) {
                    n = 0, r = 0;
                    for (i = 0; i < e.length; i++) {
                        e[i].length > n && (n = e[i].length, r = i)
                    }
                    return r
                }, s.setMonth(t(this._get(e, o.match(/MM/) ? "monthNames" : "monthNamesShort"))), s.setDate(t(this._get(e, o.match(/DD/) ? "dayNames" : "dayNamesShort")) + 20 - s.getDay())), e.input.attr("size", this._formatDate(e, s).length)
            }
        },
        _inlineDatepicker: function (t, n) {
            var r = e(t);
            if (r.hasClass(this.markerClassName)) {
                return
            }
            r.addClass(this.markerClassName).append(n.dpDiv), e.data(t, s, n), this._setDate(n, this._getDefaultDate(n), !0), this._updateDatepicker(n), this._updateAlternate(n), n.settings.disabled && this._disableDatepicker(t), n.dpDiv.css("display", "block")
        },
        _dialogDatepicker: function (t, n, r, o, u) {
            var f, l, c, h, p, d = this._dialogInst;
            return d || (this.uuid += 1, f = "dp" + this.uuid, this._dialogInput = e("<input type='text' id='" + f + "' style='position: absolute; top: -100px; width: 0px;'/>"), this._dialogInput.keydown(this._doKeyDown), e("body").append(this._dialogInput), d = this._dialogInst = this._newInst(this._dialogInput, !1), d.settings = {}, e.data(this._dialogInput[0], s, d)), i(d.settings, o || {}), n = n && n.constructor === Date ? this._formatDate(d, n) : n, this._dialogInput.val(n), this._pos = u ? u.length ? u : [u.pageX, u.pageY] : null, this._pos || (l = document.documentElement.clientWidth, c = document.documentElement.clientHeight, h = document.documentElement.scrollLeft || document.body.scrollLeft, p = document.documentElement.scrollTop || document.body.scrollTop, this._pos = [l / 2 - 100 + h, c / 2 - 150 + p]), this._dialogInput.css("left", this._pos[0] + 20 + "px").css("top", this._pos[1] + "px"), d.settings.onSelect = r, this._inDialog = !0, this.dpDiv.addClass(this._dialogClass), this._showDatepicker(this._dialogInput[0]), e.blockUI && e.blockUI(this.dpDiv), e.data(this._dialogInput[0], s, d), this
        },
        _destroyDatepicker: function (t) {
            var n, r = e(t),
                i = e.data(t, s);
            if (!r.hasClass(this.markerClassName)) {
                return
            }
            n = t.nodeName.toLowerCase(), e.removeData(t, s), n === "input" ? (i.append.remove(), i.trigger.remove(), r.removeClass(this.markerClassName).unbind("focus", this._showDatepicker).unbind("keydown", this._doKeyDown).unbind("keypress", this._doKeyPress).unbind("keyup", this._doKeyUp)) : (n === "div" || n === "span") && r.removeClass(this.markerClassName).empty()
        },
        _enableDatepicker: function (t) {
            var n, r, i = e(t),
                o = e.data(t, s);
            if (!i.hasClass(this.markerClassName)) {
                return
            }
            n = t.nodeName.toLowerCase();
            if (n === "input") {
                t.disabled = !1, o.trigger.filter("button").each(function () {
                    this.disabled = !1
                }).end().filter("img").css({
                    opacity: "1.0",
                    cursor: ""
                })
            } else {
                if (n === "div" || n === "span") {
                    r = i.children("." + this._inlineClass), r.children().removeClass("ui-state-disabled"), r.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", !1)
                }
            }
            this._disabledInputs = e.map(this._disabledInputs, function (e) {
                return e === t ? null : e
            })
        },
        _disableDatepicker: function (t) {
            var n, r, i = e(t),
                o = e.data(t, s);
            if (!i.hasClass(this.markerClassName)) {
                return
            }
            n = t.nodeName.toLowerCase();
            if (n === "input") {
                t.disabled = !0, o.trigger.filter("button").each(function () {
                    this.disabled = !0
                }).end().filter("img").css({
                    opacity: "0.5",
                    cursor: "default"
                })
            } else {
                if (n === "div" || n === "span") {
                    r = i.children("." + this._inlineClass), r.children().addClass("ui-state-disabled"), r.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", !0)
                }
            }
            this._disabledInputs = e.map(this._disabledInputs, function (e) {
                return e === t ? null : e
            }), this._disabledInputs[this._disabledInputs.length] = t
        },
        _isDisabledDatepicker: function (e) {
            if (!e) {
                return !1
            }
            for (var t = 0; t < this._disabledInputs.length; t++) {
                if (this._disabledInputs[t] === e) {
                    return !0
                }
            }
            return !1
        },
        _getInst: function (t) {
            try {
                return e.data(t, s)
            } catch (n) {
                throw "Missing instance data for this datepicker"
            }
        },
        _optionDatepicker: function (n, r, s) {
            var o, u, f, l, h = this._getInst(n);
            if (arguments.length === 2 && typeof r == "string") {
                return r === "defaults" ? e.extend({}, e.datepicker._defaults) : h ? r === "all" ? e.extend({}, h.settings) : this._get(h, r) : null
            }
            o = r || {}, typeof r == "string" && (o = {}, o[r] = s), h && (this._curInst === h && this._hideDatepicker(), u = this._getDateDatepicker(n, !0), f = this._getMinMaxDate(h, "min"), l = this._getMinMaxDate(h, "max"), i(h.settings, o), f !== null && o.dateFormat !== t && o.minDate === t && (h.settings.minDate = this._formatDate(h, f)), l !== null && o.dateFormat !== t && o.maxDate === t && (h.settings.maxDate = this._formatDate(h, l)), "disabled" in o && (o.disabled ? this._disableDatepicker(n) : this._enableDatepicker(n)), this._attachments(e(n), h), this._autoSize(h), this._setDate(h, u), this._updateAlternate(h), this._updateDatepicker(h))
        },
        _changeDatepicker: function (e, t, n) {
            this._optionDatepicker(e, t, n)
        },
        _refreshDatepicker: function (e) {
            var t = this._getInst(e);
            t && this._updateDatepicker(t)
        },
        _setDateDatepicker: function (e, t) {
            var n = this._getInst(e);
            n && (this._setDate(n, t), this._updateDatepicker(n), this._updateAlternate(n))
        },
        _getDateDatepicker: function (e, t) {
            var n = this._getInst(e);
            return n && !n.inline && this._setDateFromField(n, t), n ? this._getDate(n) : null
        },
        _doKeyDown: function (t) {
            var n, r, i, s = e.datepicker._getInst(t.target),
                o = !0,
                u = s.dpDiv.is(".ui-datepicker-rtl");
            s._keyEvent = !0;
            if (e.datepicker._datepickerShowing) {
                switch (t.keyCode) {
                case 9:
                    e.datepicker._hideDatepicker(), o = !1;
                    break;
                case 13:
                    return i = e("td." + e.datepicker._dayOverClass + ":not(." + e.datepicker._currentClass + ")", s.dpDiv), i[0] && e.datepicker._selectDay(t.target, s.selectedMonth, s.selectedYear, i[0]), n = e.datepicker._get(s, "onSelect"), n ? (r = e.datepicker._formatDate(s), n.apply(s.input ? s.input[0] : null, [r, s])) : e.datepicker._hideDatepicker(), !1;
                case 27:
                    e.datepicker._hideDatepicker();
                    break;
                case 33:
                    e.datepicker._adjustDate(t.target, t.ctrlKey ? -e.datepicker._get(s, "stepBigMonths") : -e.datepicker._get(s, "stepMonths"), "M");
                    break;
                case 34:
                    e.datepicker._adjustDate(t.target, t.ctrlKey ? +e.datepicker._get(s, "stepBigMonths") : +e.datepicker._get(s, "stepMonths"), "M");
                    break;
                case 35:
                    (t.ctrlKey || t.metaKey) && e.datepicker._clearDate(t.target), o = t.ctrlKey || t.metaKey;
                    break;
                case 36:
                    (t.ctrlKey || t.metaKey) && e.datepicker._gotoToday(t.target), o = t.ctrlKey || t.metaKey;
                    break;
                case 37:
                    (t.ctrlKey || t.metaKey) && e.datepicker._adjustDate(t.target, u ? 1 : -1, "D"), o = t.ctrlKey || t.metaKey, t.originalEvent.altKey && e.datepicker._adjustDate(t.target, t.ctrlKey ? -e.datepicker._get(s, "stepBigMonths") : -e.datepicker._get(s, "stepMonths"), "M");
                    break;
                case 38:
                    (t.ctrlKey || t.metaKey) && e.datepicker._adjustDate(t.target, -7, "D"), o = t.ctrlKey || t.metaKey;
                    break;
                case 39:
                    (t.ctrlKey || t.metaKey) && e.datepicker._adjustDate(t.target, u ? -1 : 1, "D"), o = t.ctrlKey || t.metaKey, t.originalEvent.altKey && e.datepicker._adjustDate(t.target, t.ctrlKey ? +e.datepicker._get(s, "stepBigMonths") : +e.datepicker._get(s, "stepMonths"), "M");
                    break;
                case 40:
                    (t.ctrlKey || t.metaKey) && e.datepicker._adjustDate(t.target, 7, "D"), o = t.ctrlKey || t.metaKey;
                    break;
                default:
                    o = !1
                }
            } else {
                t.keyCode === 36 && t.ctrlKey ? e.datepicker._showDatepicker(this) : o = !1
            }
            o && (t.preventDefault(), t.stopPropagation())
        },
        _doKeyPress: function (t) {
            var n, r, i = e.datepicker._getInst(t.target);
            if (e.datepicker._get(i, "constrainInput")) {
                return n = e.datepicker._possibleChars(e.datepicker._get(i, "dateFormat")), r = String.fromCharCode(t.charCode == null ? t.keyCode : t.charCode), t.ctrlKey || t.metaKey || r < " " || !n || n.indexOf(r) > -1
            }
        },
        _doKeyUp: function (t) {
            var n, r = e.datepicker._getInst(t.target);
            if (r.input.val() !== r.lastVal) {
                try {
                    n = e.datepicker.parseDate(e.datepicker._get(r, "dateFormat"), r.input ? r.input.val() : null, e.datepicker._getFormatConfig(r)), n && (e.datepicker._setDateFromField(r), e.datepicker._updateAlternate(r), e.datepicker._updateDatepicker(r))
                } catch (i) {}
            }
            return !0
        },
        _showDatepicker: function (t) {
            t = t.target || t, t.nodeName.toLowerCase() !== "input" && (t = e("input", t.parentNode)[0]);
            if (e.datepicker._isDisabledDatepicker(t) || e.datepicker._lastInput === t) {
                return
            }
            var n, r, s, o, u, f, l;
            n = e.datepicker._getInst(t), e.datepicker._curInst && e.datepicker._curInst !== n && (e.datepicker._curInst.dpDiv.stop(!0, !0), n && e.datepicker._datepickerShowing && e.datepicker._hideDatepicker(e.datepicker._curInst.input[0])), r = e.datepicker._get(n, "beforeShow"), s = r ? r.apply(t, [t, n]) : {};
            if (s === !1) {
                return
            }
            i(n.settings, s), n.lastVal = null, e.datepicker._lastInput = t, e.datepicker._setDateFromField(n), e.datepicker._inDialog && (t.value = ""), e.datepicker._pos || (e.datepicker._pos = e.datepicker._findPos(t), e.datepicker._pos[1] += t.offsetHeight), o = !1, e(t).parents().each(function () {
                return o |= e(this).css("position") === "fixed", !o
            }), u = {
                left: e.datepicker._pos[0],
                top: e.datepicker._pos[1]
            }, e.datepicker._pos = null, n.dpDiv.empty(), n.dpDiv.css({
                position: "absolute",
                display: "block",
                top: "-1000px"
            }), e.datepicker._updateDatepicker(n), u = e.datepicker._checkOffset(n, u, o), n.dpDiv.css({
                position: e.datepicker._inDialog && e.blockUI ? "static" : o ? "fixed" : "absolute",
                display: "none",
                left: u.left + "px",
                top: u.top + "px"
            }), n.inline || (f = e.datepicker._get(n, "showAnim"), l = e.datepicker._get(n, "duration"), n.dpDiv.zIndex(e(t).zIndex() + 1), e.datepicker._datepickerShowing = !0, e.effects && e.effects.effect[f] ? n.dpDiv.show(f, e.datepicker._get(n, "showOptions"), l) : n.dpDiv[f || "show"](f ? l : null), n.input.is(":visible") && !n.input.is(":disabled") && n.input.focus(), e.datepicker._curInst = n)
        },
        _updateDatepicker: function (t) {
            this.maxRows = 4, u = t, t.dpDiv.empty().append(this._generateHTML(t)), this._attachHandlers(t), t.dpDiv.find("." + this._dayOverClass + " a").mouseover();
            var n, r = this._getNumberOfMonths(t),
                i = r[1],
                s = 17;
            t.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""), i > 1 && t.dpDiv.addClass("ui-datepicker-multi-" + i).css("width", s * i + "em"), t.dpDiv[(r[0] !== 1 || r[1] !== 1 ? "add" : "remove") + "Class"]("ui-datepicker-multi"), t.dpDiv[(this._get(t, "isRTL") ? "add" : "remove") + "Class"]("ui-datepicker-rtl"), t === e.datepicker._curInst && e.datepicker._datepickerShowing && t.input && t.input.is(":visible") && !t.input.is(":disabled") && t.input[0] !== document.activeElement && t.input.focus(), t.yearshtml && (n = t.yearshtml, setTimeout(function () {
                n === t.yearshtml && t.yearshtml && t.dpDiv.find("select.ui-datepicker-year:first").replaceWith(t.yearshtml), n = t.yearshtml = null
            }, 0))
        },
        _getBorders: function (e) {
            var t = function (e) {
                return {
                    thin: 1,
                    medium: 2,
                    thick: 3
                }[e] || e
            };
            return [parseFloat(t(e.css("border-left-width"))), parseFloat(t(e.css("border-top-width")))]
        },
        _checkOffset: function (t, n, r) {
            var i = t.dpDiv.outerWidth(),
                s = t.dpDiv.outerHeight(),
                o = t.input ? t.input.outerWidth() : 0,
                u = t.input ? t.input.outerHeight() : 0,
                a = document.documentElement.clientWidth + (r ? 0 : e(document).scrollLeft()),
                f = document.documentElement.clientHeight + (r ? 0 : e(document).scrollTop());
            return n.left -= this._get(t, "isRTL") ? i - o : 0, n.left -= r && n.left === t.input.offset().left ? e(document).scrollLeft() : 0, n.top -= r && n.top === t.input.offset().top + u ? e(document).scrollTop() : 0, n.left -= Math.min(n.left, n.left + i > a && a > i ? Math.abs(n.left + i - a) : 0), n.top -= Math.min(n.top, n.top + s > f && f > s ? Math.abs(s + u) : 0), n
        },
        _findPos: function (t) {
            var n, r = this._getInst(t),
                i = this._get(r, "isRTL");
            while (t && (t.type === "hidden" || t.nodeType !== 1 || e.expr.filters.hidden(t))) {
                t = t[i ? "previousSibling" : "nextSibling"]
            }
            return n = e(t).offset(), [n.left, n.top]
        },
        _hideDatepicker: function (t) {
            var n, r, i, o, u = this._curInst;
            if (!u || t && u !== e.data(t, s)) {
                return
            }
            this._datepickerShowing && (n = this._get(u, "showAnim"), r = this._get(u, "duration"), i = function () {
                e.datepicker._tidyDialog(u)
            }, e.effects && (e.effects.effect[n] || e.effects[n]) ? u.dpDiv.hide(n, e.datepicker._get(u, "showOptions"), r, i) : u.dpDiv[n === "slideDown" ? "slideUp" : n === "fadeIn" ? "fadeOut" : "hide"](n ? r : null, i), n || i(), this._datepickerShowing = !1, o = this._get(u, "onClose"), o && o.apply(u.input ? u.input[0] : null, [u.input ? u.input.val() : "", u]), this._lastInput = null, this._inDialog && (this._dialogInput.css({
                position: "absolute",
                left: "0",
                top: "-100px"
            }), e.blockUI && (e.unblockUI(), e("body").append(this.dpDiv))), this._inDialog = !1)
        },
        _tidyDialog: function (e) {
            e.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar")
        },
        _checkExternalClick: function (t) {
            if (!e.datepicker._curInst) {
                return
            }
            var n = e(t.target),
                r = e.datepicker._getInst(n[0]);
            (n[0].id !== e.datepicker._mainDivId && n.parents("#" + e.datepicker._mainDivId).length === 0 && !n.hasClass(e.datepicker.markerClassName) && !n.closest("." + e.datepicker._triggerClass).length && e.datepicker._datepickerShowing && (!e.datepicker._inDialog || !e.blockUI) || n.hasClass(e.datepicker.markerClassName) && e.datepicker._curInst !== r) && e.datepicker._hideDatepicker()
        },
        _adjustDate: function (t, n, r) {
            var i = e(t),
                s = this._getInst(i[0]);
            if (this._isDisabledDatepicker(i[0])) {
                return
            }
            this._adjustInstDate(s, n + (r === "M" ? this._get(s, "showCurrentAtPos") : 0), r), this._updateDatepicker(s)
        },
        _gotoToday: function (t) {
            var n, r = e(t),
                i = this._getInst(r[0]);
            this._get(i, "gotoCurrent") && i.currentDay ? (i.selectedDay = i.currentDay, i.drawMonth = i.selectedMonth = i.currentMonth, i.drawYear = i.selectedYear = i.currentYear) : (n = new Date, i.selectedDay = n.getDate(), i.drawMonth = i.selectedMonth = n.getMonth(), i.drawYear = i.selectedYear = n.getFullYear()), this._notifyChange(i), this._adjustDate(r)
        },
        _selectMonthYear: function (t, n, r) {
            var i = e(t),
                s = this._getInst(i[0]);
            s["selected" + (r === "M" ? "Month" : "Year")] = s["draw" + (r === "M" ? "Month" : "Year")] = parseInt(n.options[n.selectedIndex].value, 10), this._notifyChange(s), this._adjustDate(i)
        },
        _selectDay: function (t, n, r, i) {
            var s, o = e(t);
            if (e(i).hasClass(this._unselectableClass) || this._isDisabledDatepicker(o[0])) {
                return
            }
            s = this._getInst(o[0]), s.selectedDay = s.currentDay = e("a", i).html(), s.selectedMonth = s.currentMonth = n, s.selectedYear = s.currentYear = r, this._selectDate(t, this._formatDate(s, s.currentDay, s.currentMonth, s.currentYear))
        },
        _clearDate: function (t) {
            var n = e(t);
            this._selectDate(n, "")
        },
        _selectDate: function (t, n) {
            var r, i = e(t),
                s = this._getInst(i[0]);
            n = n != null ? n : this._formatDate(s), s.input && s.input.val(n), this._updateAlternate(s), r = this._get(s, "onSelect"), r ? r.apply(s.input ? s.input[0] : null, [n, s]) : s.input && s.input.trigger("change"), s.inline ? this._updateDatepicker(s) : (this._hideDatepicker(), this._lastInput = s.input[0], typeof s.input[0] != "object" && s.input.focus(), this._lastInput = null)
        },
        _updateAlternate: function (t) {
            var n, r, i, s = this._get(t, "altField");
            s && (n = this._get(t, "altFormat") || this._get(t, "dateFormat"), r = this._getDate(t), i = this.formatDate(n, r, this._getFormatConfig(t)), e(s).each(function () {
                e(this).val(i)
            }))
        },
        noWeekends: function (e) {
            var t = e.getDay();
            return [t > 0 && t < 6, ""]
        },
        iso8601Week: function (e) {
            var t, n = new Date(e.getTime());
            return n.setDate(n.getDate() + 4 - (n.getDay() || 7)), t = n.getTime(), n.setMonth(0), n.setDate(1), Math.floor(Math.round((t - n) / 864e5) / 7) + 1
        },
        parseDate: function (t, n, r) {
            if (t == null || n == null) {
                throw "Invalid arguments"
            }
            n = typeof n == "object" ? n.toString() : n + "";
            if (n === "") {
                return null
            }
            var i, s, o, u = 0,
                a = (r ? r.shortYearCutoff : null) || this._defaults.shortYearCutoff,
                f = typeof a != "string" ? a : (new Date).getFullYear() % 100 + parseInt(a, 10),
                l = (r ? r.dayNamesShort : null) || this._defaults.dayNamesShort,
                c = (r ? r.dayNames : null) || this._defaults.dayNames,
                h = (r ? r.monthNamesShort : null) || this._defaults.monthNamesShort,
                p = (r ? r.monthNames : null) || this._defaults.monthNames,
                d = -1,
                v = -1,
                m = -1,
                y = -1,
                b = !1,
                w, E = function (e) {
                    var n = i + 1 < t.length && t.charAt(i + 1) === e;
                    return n && i++, n
                },
                S = function (e) {
                    var t = E(e),
                        r = e === "@" ? 14 : e === "!" ? 20 : e === "y" && t ? 4 : e === "o" ? 3 : 2,
                        i = new RegExp("^\\d{1," + r + "}"),
                        s = n.substring(u).match(i);
                    if (!s) {
                        throw "Missing number at position " + u
                    }
                    return u += s[0].length, parseInt(s[0], 10)
                },
                x = function (t, r, i) {
                    var s = -1,
                        o = e.map(E(t) ? i : r, function (e, t) {
                            return [
                                [t, e]
                            ]
                        }).sort(function (e, t) {
                            return -(e[1].length - t[1].length)
                        });
                    e.each(o, function (e, t) {
                        var r = t[1];
                        if (n.substr(u, r.length).toLowerCase() === r.toLowerCase()) {
                            return s = t[0], u += r.length, !1
                        }
                    });
                    if (s !== -1) {
                        return s + 1
                    }
                    throw "Unknown name at position " + u
                },
                T = function () {
                    if (n.charAt(u) !== t.charAt(i)) {
                        throw "Unexpected literal at position " + u
                    }
                    u++
                };
            for (i = 0; i < t.length; i++) {
                if (b) {
                    t.charAt(i) === "'" && !E("'") ? b = !1 : T()
                } else {
                    switch (t.charAt(i)) {
                    case "d":
                        m = S("d");
                        break;
                    case "D":
                        x("D", l, c);
                        break;
                    case "o":
                        y = S("o");
                        break;
                    case "m":
                        v = S("m");
                        break;
                    case "M":
                        v = x("M", h, p);
                        break;
                    case "y":
                        d = S("y");
                        break;
                    case "@":
                        w = new Date(S("@")), d = w.getFullYear(), v = w.getMonth() + 1, m = w.getDate();
                        break;
                    case "!":
                        w = new Date((S("!") - this._ticksTo1970) / 1e4), d = w.getFullYear(), v = w.getMonth() + 1, m = w.getDate();
                        break;
                    case "'":
                        E("'") ? T() : b = !0;
                        break;
                    default:
                        T()
                    }
                }
            }
            if (u < n.length) {
                o = n.substr(u);
                if (!/^\s+/.test(o)) {
                    throw "Extra/unparsed characters found in date: " + o
                }
            }
            d === -1 ? d = (new Date).getFullYear() : d < 100 && (d += (new Date).getFullYear() - (new Date).getFullYear() % 100 + (d <= f ? 0 : -100));
            if (y > -1) {
                v = 1, m = y;
                do {
                    s = this._getDaysInMonth(d, v - 1);
                    if (m <= s) {
                        break
                    }
                    v++, m -= s
                } while (!0)
            }
            w = this._daylightSavingAdjust(new Date(d, v - 1, m));
            if (w.getFullYear() !== d || w.getMonth() + 1 !== v || w.getDate() !== m) {
                throw "Invalid date"
            }
            return w
        },
        ATOM: "yy-mm-dd",
        COOKIE: "D, dd M yy",
        ISO_8601: "yy-mm-dd",
        RFC_822: "D, d M y",
        RFC_850: "DD, dd-M-y",
        RFC_1036: "D, d M y",
        RFC_1123: "D, d M yy",
        RFC_2822: "D, d M yy",
        RSS: "D, d M y",
        TICKS: "!",
        TIMESTAMP: "@",
        W3C: "yy-mm-dd",
        _ticksTo1970: (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)) * 24 * 60 * 60 * 1e7,
        formatDate: function (e, t, n) {
            if (!t) {
                return ""
            }
            var r, i = (n ? n.dayNamesShort : null) || this._defaults.dayNamesShort,
                s = (n ? n.dayNames : null) || this._defaults.dayNames,
                o = (n ? n.monthNamesShort : null) || this._defaults.monthNamesShort,
                u = (n ? n.monthNames : null) || this._defaults.monthNames,
                a = function (t) {
                    var n = r + 1 < e.length && e.charAt(r + 1) === t;
                    return n && r++, n
                },
                f = function (e, t, n) {
                    var r = "" + t;
                    if (a(e)) {
                        while (r.length < n) {
                            r = "0" + r
                        }
                    }
                    return r
                },
                l = function (e, t, n, r) {
                    return a(e) ? r[t] : n[t]
                },
                c = "",
                h = !1;
            if (t) {
                for (r = 0; r < e.length; r++) {
                    if (h) {
                        e.charAt(r) === "'" && !a("'") ? h = !1 : c += e.charAt(r)
                    } else {
                        switch (e.charAt(r)) {
                        case "d":
                            c += f("d", t.getDate(), 2);
                            break;
                        case "D":
                            c += l("D", t.getDay(), i, s);
                            break;
                        case "o":
                            c += f("o", Math.round(((new Date(t.getFullYear(), t.getMonth(), t.getDate())).getTime() - (new Date(t.getFullYear(), 0, 0)).getTime()) / 864e5), 3);
                            break;
                        case "m":
                            c += f("m", t.getMonth() + 1, 2);
                            break;
                        case "M":
                            c += l("M", t.getMonth(), o, u);
                            break;
                        case "y":
                            c += a("y") ? t.getFullYear() : (t.getYear() % 100 < 10 ? "0" : "") + t.getYear() % 100;
                            break;
                        case "@":
                            c += t.getTime();
                            break;
                        case "!":
                            c += t.getTime() * 1e4 + this._ticksTo1970;
                            break;
                        case "'":
                            a("'") ? c += "'" : h = !0;
                            break;
                        default:
                            c += e.charAt(r)
                        }
                    }
                }
            }
            return c
        },
        _possibleChars: function (e) {
            var t, n = "",
                r = !1,
                i = function (n) {
                    var r = t + 1 < e.length && e.charAt(t + 1) === n;
                    return r && t++, r
                };
            for (t = 0; t < e.length; t++) {
                if (r) {
                    e.charAt(t) === "'" && !i("'") ? r = !1 : n += e.charAt(t)
                } else {
                    switch (e.charAt(t)) {
                    case "d":
                    case "m":
                    case "y":
                    case "@":
                        n += "0123456789";
                        break;
                    case "D":
                    case "M":
                        return null;
                    case "'":
                        i("'") ? n += "'" : r = !0;
                        break;
                    default:
                        n += e.charAt(t)
                    }
                }
            }
            return n
        },
        _get: function (e, n) {
            return e.settings[n] !== t ? e.settings[n] : this._defaults[n]
        },
        _setDateFromField: function (e, t) {
            if (e.input.val() === e.lastVal) {
                return
            }
            var n = this._get(e, "dateFormat"),
                r = e.lastVal = e.input ? e.input.val() : null,
                i = this._getDefaultDate(e),
                s = i,
                o = this._getFormatConfig(e);
            try {
                s = this.parseDate(n, r, o) || i
            } catch (u) {
                r = t ? "" : r
            }
            e.selectedDay = s.getDate(), e.drawMonth = e.selectedMonth = s.getMonth(), e.drawYear = e.selectedYear = s.getFullYear(), e.currentDay = r ? s.getDate() : 0, e.currentMonth = r ? s.getMonth() : 0, e.currentYear = r ? s.getFullYear() : 0, this._adjustInstDate(e)
        },
        _getDefaultDate: function (e) {
            return this._restrictMinMax(e, this._determineDate(e, this._get(e, "defaultDate"), new Date))
        },
        _determineDate: function (t, n, r) {
            var i = function (e) {
                    var t = new Date;
                    return t.setDate(t.getDate() + e), t
                },
                s = function (n) {
                    try {
                        return e.datepicker.parseDate(e.datepicker._get(t, "dateFormat"), n, e.datepicker._getFormatConfig(t))
                    } catch (r) {}
                    var i = (n.toLowerCase().match(/^c/) ? e.datepicker._getDate(t) : null) || new Date,
                        s = i.getFullYear(),
                        o = i.getMonth(),
                        u = i.getDate(),
                        a = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
                        f = a.exec(n);
                    while (f) {
                        switch (f[2] || "d") {
                        case "d":
                        case "D":
                            u += parseInt(f[1], 10);
                            break;
                        case "w":
                        case "W":
                            u += parseInt(f[1], 10) * 7;
                            break;
                        case "m":
                        case "M":
                            o += parseInt(f[1], 10), u = Math.min(u, e.datepicker._getDaysInMonth(s, o));
                            break;
                        case "y":
                        case "Y":
                            s += parseInt(f[1], 10), u = Math.min(u, e.datepicker._getDaysInMonth(s, o))
                        }
                        f = a.exec(n)
                    }
                    return new Date(s, o, u)
                },
                o = n == null || n === "" ? r : typeof n == "string" ? s(n) : typeof n == "number" ? isNaN(n) ? r : i(n) : new Date(n.getTime());
            return o = o && o.toString() === "Invalid Date" ? r : o, o && (o.setHours(0), o.setMinutes(0), o.setSeconds(0), o.setMilliseconds(0)), this._daylightSavingAdjust(o)
        },
        _daylightSavingAdjust: function (e) {
            return e ? (e.setHours(e.getHours() > 12 ? e.getHours() + 2 : 0), e) : null
        },
        _setDate: function (e, t, n) {
            var r = !t,
                i = e.selectedMonth,
                s = e.selectedYear,
                o = this._restrictMinMax(e, this._determineDate(e, t, new Date));
            e.selectedDay = e.currentDay = o.getDate(), e.drawMonth = e.selectedMonth = e.currentMonth = o.getMonth(), e.drawYear = e.selectedYear = e.currentYear = o.getFullYear(), (i !== e.selectedMonth || s !== e.selectedYear) && !n && this._notifyChange(e), this._adjustInstDate(e), e.input && e.input.val(r ? "" : this._formatDate(e))
        },
        _getDate: function (e) {
            var t = !e.currentYear || e.input && e.input.val() === "" ? null : this._daylightSavingAdjust(new Date(e.currentYear, e.currentMonth, e.currentDay));
            return t
        },
        _attachHandlers: function (t) {
            var n = this._get(t, "stepMonths"),
                r = "#" + t.id.replace(/\\\\/g, "\\");
            t.dpDiv.find("[data-handler]").map(function () {
                var t = {
                    prev: function () {
                        window["DP_jQuery_" + o].datepicker._adjustDate(r, -n, "M")
                    },
                    next: function () {
                        window["DP_jQuery_" + o].datepicker._adjustDate(r, +n, "M")
                    },
                    hide: function () {
                        window["DP_jQuery_" + o].datepicker._hideDatepicker()
                    },
                    today: function () {
                        window["DP_jQuery_" + o].datepicker._gotoToday(r)
                    },
                    selectDay: function () {
                        return window["DP_jQuery_" + o].datepicker._selectDay(r, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this), !1
                    },
                    selectMonth: function () {
                        return window["DP_jQuery_" + o].datepicker._selectMonthYear(r, this, "M"), !1
                    },
                    selectYear: function () {
                        return window["DP_jQuery_" + o].datepicker._selectMonthYear(r, this, "Y"), !1
                    }
                };
                e(this).bind(this.getAttribute("data-event"), t[this.getAttribute("data-handler")])
            })
        },
        _generateHTML: function (e) {
            var t, n, r, i, s, o, u, a, f, l, c, h, p, d, v, m, g, y, b, w, E, S, x, T, N, C, k, L, A, O, M, _, D, P, H, B, j, F, I, q = new Date,
                R = this._daylightSavingAdjust(new Date(q.getFullYear(), q.getMonth(), q.getDate())),
                U = this._get(e, "isRTL"),
                z = this._get(e, "showButtonPanel"),
                W = this._get(e, "hideIfNoPrevNext"),
                X = this._get(e, "navigationAsDateFormat"),
                V = this._getNumberOfMonths(e),
                $ = this._get(e, "showCurrentAtPos"),
                J = this._get(e, "stepMonths"),
                K = V[0] !== 1 || V[1] !== 1,
                Q = this._daylightSavingAdjust(e.currentDay ? new Date(e.currentYear, e.currentMonth, e.currentDay) : new Date(9999, 9, 9)),
                G = this._getMinMaxDate(e, "min"),
                Y = this._getMinMaxDate(e, "max"),
                Z = e.drawMonth - $,
                et = e.drawYear;
            Z < 0 && (Z += 12, et--);
            if (Y) {
                t = this._daylightSavingAdjust(new Date(Y.getFullYear(), Y.getMonth() - V[0] * V[1] + 1, Y.getDate())), t = G && t < G ? G : t;
                while (this._daylightSavingAdjust(new Date(et, Z, 1)) > t) {
                    Z--, Z < 0 && (Z = 11, et--)
                }
            }
            e.drawMonth = Z, e.drawYear = et, n = this._get(e, "prevText"), n = X ? this.formatDate(n, this._daylightSavingAdjust(new Date(et, Z - J, 1)), this._getFormatConfig(e)) : n, r = this._canAdjustMonth(e, -1, et, Z) ? "<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='" + n + "'><span class='ui-icon ui-icon-circle-triangle-" + (U ? "e" : "w") + "'>" + n + "</span></a>" : W ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + n + "'><span class='ui-icon ui-icon-circle-triangle-" + (U ? "e" : "w") + "'>" + n + "</span></a>", i = this._get(e, "nextText"), i = X ? this.formatDate(i, this._daylightSavingAdjust(new Date(et, Z + J, 1)), this._getFormatConfig(e)) : i, s = this._canAdjustMonth(e, 1, et, Z) ? "<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='" + i + "'><span class='ui-icon ui-icon-circle-triangle-" + (U ? "w" : "e") + "'>" + i + "</span></a>" : W ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + i + "'><span class='ui-icon ui-icon-circle-triangle-" + (U ? "w" : "e") + "'>" + i + "</span></a>", o = this._get(e, "currentText"), u = this._get(e, "gotoCurrent") && e.currentDay ? Q : R, o = X ? this.formatDate(o, u, this._getFormatConfig(e)) : o, a = e.inline ? "" : "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" + this._get(e, "closeText") + "</button>", f = z ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (U ? a : "") + (this._isInRange(e, u) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>" + o + "</button>" : "") + (U ? "" : a) + "</div>" : "", l = parseInt(this._get(e, "firstDay"), 10), l = isNaN(l) ? 0 : l, c = this._get(e, "showWeek"), h = this._get(e, "dayNames"), p = this._get(e, "dayNamesMin"), d = this._get(e, "monthNames"), v = this._get(e, "monthNamesShort"), m = this._get(e, "beforeShowDay"), g = this._get(e, "showOtherMonths"), y = this._get(e, "selectOtherMonths"), b = this._getDefaultDate(e), w = "", E;
            for (S = 0; S < V[0]; S++) {
                x = "", this.maxRows = 4;
                for (T = 0; T < V[1]; T++) {
                    N = this._daylightSavingAdjust(new Date(et, Z, e.selectedDay)), C = " ui-corner-all", k = "";
                    if (K) {
                        k += "<div class='ui-datepicker-group";
                        if (V[1] > 1) {
                            switch (T) {
                            case 0:
                                k += " ui-datepicker-group-first", C = " ui-corner-" + (U ? "right" : "left");
                                break;
                            case V[1] - 1:
                                k += " ui-datepicker-group-last", C = " ui-corner-" + (U ? "left" : "right");
                                break;
                            default:
                                k += " ui-datepicker-group-middle", C = ""
                            }
                        }
                        k += "'>"
                    }
                    k += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + C + "'>" + (/all|left/.test(C) && S === 0 ? U ? s : r : "") + (/all|right/.test(C) && S === 0 ? U ? r : s : "") + this._generateMonthYearHeader(e, Z, et, G, Y, S > 0 || T > 0, d, v) + "</div><table class='ui-datepicker-calendar'><thead><tr>", L = c ? "<th class='ui-datepicker-week-col'>" + this._get(e, "weekHeader") + "</th>" : "";
                    for (E = 0; E < 7; E++) {
                        A = (E + l) % 7, L += "<th" + ((E + l + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + "><span title='" + h[A] + "'>" + p[A] + "</span></th>"
                    }
                    k += L + "</tr></thead><tbody>", O = this._getDaysInMonth(et, Z), et === e.selectedYear && Z === e.selectedMonth && (e.selectedDay = Math.min(e.selectedDay, O)), M = (this._getFirstDayOfMonth(et, Z) - l + 7) % 7, _ = Math.ceil((M + O) / 7), D = K ? this.maxRows > _ ? this.maxRows : _ : _, this.maxRows = D, P = this._daylightSavingAdjust(new Date(et, Z, 1 - M));
                    for (H = 0; H < D; H++) {
                        k += "<tr>", B = c ? "<td class='ui-datepicker-week-col'>" + this._get(e, "calculateWeek")(P) + "</td>" : "";
                        for (E = 0; E < 7; E++) {
                            j = m ? m.apply(e.input ? e.input[0] : null, [P]) : [!0, ""], F = P.getMonth() !== Z, I = F && !y || !j[0] || G && P < G || Y && P > Y, B += "<td class='" + ((E + l + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + (F ? " ui-datepicker-other-month" : "") + (P.getTime() === N.getTime() && Z === e.selectedMonth && e._keyEvent || b.getTime() === P.getTime() && b.getTime() === N.getTime() ? " " + this._dayOverClass : "") + (I ? " " + this._unselectableClass + " ui-state-disabled" : "") + (F && !g ? "" : " " + j[1] + (P.getTime() === Q.getTime() ? " " + this._currentClass : "") + (P.getTime() === R.getTime() ? " ui-datepicker-today" : "")) + "'" + ((!F || g) && j[2] ? " title='" + j[2] + "'" : "") + (I ? "" : " data-handler='selectDay' data-event='click' data-month='" + P.getMonth() + "' data-year='" + P.getFullYear() + "'") + ">" + (F && !g ? "&#xa0;" : I ? "<span class='ui-state-default'>" + P.getDate() + "</span>" : "<a class='ui-state-default" + (P.getTime() === R.getTime() ? " ui-state-highlight" : "") + (P.getTime() === Q.getTime() ? " ui-state-active" : "") + (F ? " ui-priority-secondary" : "") + "' href='#'>" + P.getDate() + "</a>") + "</td>", P.setDate(P.getDate() + 1), P = this._daylightSavingAdjust(P)
                        }
                        k += B + "</tr>"
                    }
                    Z++, Z > 11 && (Z = 0, et++), k += "</tbody></table>" + (K ? "</div>" + (V[0] > 0 && T === V[1] - 1 ? "<div class='ui-datepicker-row-break'></div>" : "") : ""), x += k
                }
                w += x
            }
            return w += f, e._keyEvent = !1, w
        },
        _generateMonthYearHeader: function (e, t, n, r, i, s, o, u) {
            var a, f, l, c, h, p, d, v, m = this._get(e, "changeMonth"),
                g = this._get(e, "changeYear"),
                y = this._get(e, "showMonthAfterYear"),
                b = "<div class='ui-datepicker-title'>",
                w = "";
            if (s || !m) {
                w += "<span class='ui-datepicker-month'>" + o[t] + "</span>"
            } else {
                a = r && r.getFullYear() === n, f = i && i.getFullYear() === n, w += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
                for (l = 0; l < 12; l++) {
                    (!a || l >= r.getMonth()) && (!f || l <= i.getMonth()) && (w += "<option value='" + l + "'" + (l === t ? " selected='selected'" : "") + ">" + u[l] + "</option>")
                }
                w += "</select>"
            }
            y || (b += w + (s || !m || !g ? "&#xa0;" : ""));
            if (!e.yearshtml) {
                e.yearshtml = "";
                if (s || !g) {
                    b += "<span class='ui-datepicker-year'>" + n + "</span>"
                } else {
                    c = this._get(e, "yearRange").split(":"), h = (new Date).getFullYear(), p = function (e) {
                        var t = e.match(/c[+\-].*/) ? n + parseInt(e.substring(1), 10) : e.match(/[+\-].*/) ? h + parseInt(e, 10) : parseInt(e, 10);
                        return isNaN(t) ? h : t
                    }, d = p(c[0]), v = Math.max(d, p(c[1] || "")), d = r ? Math.max(d, r.getFullYear()) : d, v = i ? Math.min(v, i.getFullYear()) : v, e.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
                    for (; d <= v; d++) {
                        e.yearshtml += "<option value='" + d + "'" + (d === n ? " selected='selected'" : "") + ">" + d + "</option>"
                    }
                    e.yearshtml += "</select>", b += e.yearshtml, e.yearshtml = null
                }
            }
            return b += this._get(e, "yearSuffix"), y && (b += (s || !m || !g ? "&#xa0;" : "") + w), b += "</div>", b
        },
        _adjustInstDate: function (e, t, n) {
            var r = e.drawYear + (n === "Y" ? t : 0),
                i = e.drawMonth + (n === "M" ? t : 0),
                s = Math.min(e.selectedDay, this._getDaysInMonth(r, i)) + (n === "D" ? t : 0),
                o = this._restrictMinMax(e, this._daylightSavingAdjust(new Date(r, i, s)));
            e.selectedDay = o.getDate(), e.drawMonth = e.selectedMonth = o.getMonth(), e.drawYear = e.selectedYear = o.getFullYear(), (n === "M" || n === "Y") && this._notifyChange(e)
        },
        _restrictMinMax: function (e, t) {
            var n = this._getMinMaxDate(e, "min"),
                r = this._getMinMaxDate(e, "max"),
                i = n && t < n ? n : t;
            return r && i > r ? r : i
        },
        _notifyChange: function (e) {
            var t = this._get(e, "onChangeMonthYear");
            t && t.apply(e.input ? e.input[0] : null, [e.selectedYear, e.selectedMonth + 1, e])
        },
        _getNumberOfMonths: function (e) {
            var t = this._get(e, "numberOfMonths");
            return t == null ? [1, 1] : typeof t == "number" ? [1, t] : t
        },
        _getMinMaxDate: function (e, t) {
            return this._determineDate(e, this._get(e, t + "Date"), null)
        },
        _getDaysInMonth: function (e, t) {
            return 32 - this._daylightSavingAdjust(new Date(e, t, 32)).getDate()
        },
        _getFirstDayOfMonth: function (e, t) {
            return (new Date(e, t, 1)).getDay()
        },
        _canAdjustMonth: function (e, t, n, r) {
            var i = this._getNumberOfMonths(e),
                s = this._daylightSavingAdjust(new Date(n, r + (t < 0 ? t : i[0] * i[1]), 1));
            return t < 0 && s.setDate(this._getDaysInMonth(s.getFullYear(), s.getMonth())), this._isInRange(e, s)
        },
        _isInRange: function (e, t) {
            var n, r, i = this._getMinMaxDate(e, "min"),
                s = this._getMinMaxDate(e, "max"),
                o = null,
                u = null,
                a = this._get(e, "yearRange");
            return a && (n = a.split(":"), r = (new Date).getFullYear(), o = parseInt(n[0], 10) + r, u = parseInt(n[1], 10) + r), (!i || t.getTime() >= i.getTime()) && (!s || t.getTime() <= s.getTime()) && (!o || t.getFullYear() >= o) && (!u || t.getFullYear() <= u)
        },
        _getFormatConfig: function (e) {
            var t = this._get(e, "shortYearCutoff");
            return t = typeof t != "string" ? t : (new Date).getFullYear() % 100 + parseInt(t, 10), {
                shortYearCutoff: t,
                dayNamesShort: this._get(e, "dayNamesShort"),
                dayNames: this._get(e, "dayNames"),
                monthNamesShort: this._get(e, "monthNamesShort"),
                monthNames: this._get(e, "monthNames")
            }
        },
        _formatDate: function (e, t, n, r) {
            t || (e.currentDay = e.selectedDay, e.currentMonth = e.selectedMonth, e.currentYear = e.selectedYear);
            var i = t ? typeof t == "object" ? t : this._daylightSavingAdjust(new Date(r, n, t)) : this._daylightSavingAdjust(new Date(e.currentYear, e.currentMonth, e.currentDay));
            return this.formatDate(this._get(e, "dateFormat"), i, this._getFormatConfig(e))
        }
    }), e.fn.datepicker = function (t) {
        if (!this.length) {
            return this
        }
        e.datepicker.initialized || (e(document).mousedown(e.datepicker._checkExternalClick), e.datepicker.initialized = !0), e("#" + e.datepicker._mainDivId).length === 0 && e("body").append(e.datepicker.dpDiv);
        var n = Array.prototype.slice.call(arguments, 1);
        return typeof t != "string" || t !== "isDisabled" && t !== "getDate" && t !== "widget" ? t === "option" && arguments.length === 2 && typeof arguments[1] == "string" ? e.datepicker["_" + t + "Datepicker"].apply(e.datepicker, [this[0]].concat(n)) : this.each(function () {
            typeof t == "string" ? e.datepicker["_" + t + "Datepicker"].apply(e.datepicker, [this].concat(n)) : e.datepicker._attachDatepicker(this, t)
        }) : e.datepicker["_" + t + "Datepicker"].apply(e.datepicker, [this[0]].concat(n))
    }, e.datepicker = new n, e.datepicker.initialized = !1, e.datepicker.uuid = (new Date).getTime(), e.datepicker.version = "1.10.0", window["DP_jQuery_" + o] = e
})(jQuery);
jQuery.effects || function (e, t) {
    var n = "ui-effects-";
    e.effects = {
            effect: {}
        },
        function (e, t) {
            function n(e, t, n) {
                var r = l[t.type] || {};
                return e == null ? n || !t.def ? null : t.def : (e = r.floor ? ~~e : parseFloat(e), isNaN(e) ? t.def : r.mod ? (e + r.mod) % r.mod : 0 > e ? 0 : r.max < e ? r.max : e)
            }

            function r(t) {
                var n = a(),
                    r = n._rgba = [];
                return t = t.toLowerCase(), d(u, function (e, i) {
                    var s, o = i.re.exec(t),
                        u = o && i.parse(o),
                        a = i.space || "rgba";
                    if (u) {
                        return s = n[a](u), n[f[a].cache] = s[f[a].cache], r = n._rgba = s._rgba, !1
                    }
                }), r.length ? (r.join() === "0,0,0,0" && e.extend(r, p.transparent), n) : p[t]
            }

            function i(e, t, n) {
                return n = (n + 1) % 1, n * 6 < 1 ? e + (t - e) * n * 6 : n * 2 < 1 ? t : n * 3 < 2 ? e + (t - e) * (2 / 3 - n) * 6 : e
            }
            var s = "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",
                o = /^([\-+])=\s*(\d+\.?\d*)/,
                u = [{
                    re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
                    parse: function (e) {
                        return [e[1], e[2], e[3], e[4]]
                    }
                }, {
                    re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
                    parse: function (e) {
                        return [e[1] * 2.55, e[2] * 2.55, e[3] * 2.55, e[4]]
                    }
                }, {
                    re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
                    parse: function (e) {
                        return [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16)]
                    }
                }, {
                    re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
                    parse: function (e) {
                        return [parseInt(e[1] + e[1], 16), parseInt(e[2] + e[2], 16), parseInt(e[3] + e[3], 16)]
                    }
                }, {
                    re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
                    space: "hsla",
                    parse: function (e) {
                        return [e[1], e[2] / 100, e[3] / 100, e[4]]
                    }
                }],
                a = e.Color = function (t, n, r, i) {
                    return new e.Color.fn.parse(t, n, r, i)
                },
                f = {
                    rgba: {
                        props: {
                            red: {
                                idx: 0,
                                type: "byte"
                            },
                            green: {
                                idx: 1,
                                type: "byte"
                            },
                            blue: {
                                idx: 2,
                                type: "byte"
                            }
                        }
                    },
                    hsla: {
                        props: {
                            hue: {
                                idx: 0,
                                type: "degrees"
                            },
                            saturation: {
                                idx: 1,
                                type: "percent"
                            },
                            lightness: {
                                idx: 2,
                                type: "percent"
                            }
                        }
                    }
                },
                l = {
                    "byte": {
                        floor: !0,
                        max: 255
                    },
                    percent: {
                        max: 1
                    },
                    degrees: {
                        mod: 360,
                        floor: !0
                    }
                },
                c = a.support = {},
                h = e("<p>")[0],
                p, d = e.each;
            h.style.cssText = "background-color:rgba(1,1,1,.5)", c.rgba = h.style.backgroundColor.indexOf("rgba") > -1, d(f, function (e, t) {
                t.cache = "_" + e, t.props.alpha = {
                    idx: 3,
                    type: "percent",
                    def: 1
                }
            }), a.fn = e.extend(a.prototype, {
                parse: function (i, s, o, u) {
                    if (i === t) {
                        return this._rgba = [null, null, null, null], this
                    }
                    if (i.jquery || i.nodeType) {
                        i = e(i).css(s), s = t
                    }
                    var l = this,
                        c = e.type(i),
                        h = this._rgba = [];
                    s !== t && (i = [i, s, o, u], c = "array");
                    if (c === "string") {
                        return this.parse(r(i) || p._default)
                    }
                    if (c === "array") {
                        return d(f.rgba.props, function (e, t) {
                            h[t.idx] = n(i[t.idx], t)
                        }), this
                    }
                    if (c === "object") {
                        return i instanceof a ? d(f, function (e, t) {
                            i[t.cache] && (l[t.cache] = i[t.cache].slice())
                        }) : d(f, function (t, r) {
                            var s = r.cache;
                            d(r.props, function (e, t) {
                                if (!l[s] && r.to) {
                                    if (e === "alpha" || i[e] == null) {
                                        return
                                    }
                                    l[s] = r.to(l._rgba)
                                }
                                l[s][t.idx] = n(i[e], t, !0)
                            }), l[s] && e.inArray(null, l[s].slice(0, 3)) < 0 && (l[s][3] = 1, r.from && (l._rgba = r.from(l[s])))
                        }), this
                    }
                },
                is: function (e) {
                    var t = a(e),
                        n = !0,
                        r = this;
                    return d(f, function (e, i) {
                        var s, o = t[i.cache];
                        return o && (s = r[i.cache] || i.to && i.to(r._rgba) || [], d(i.props, function (e, t) {
                            if (o[t.idx] != null) {
                                return n = o[t.idx] === s[t.idx], n
                            }
                        })), n
                    }), n
                },
                _space: function () {
                    var e = [],
                        t = this;
                    return d(f, function (n, r) {
                        t[r.cache] && e.push(n)
                    }), e.pop()
                },
                transition: function (e, t) {
                    var r = a(e),
                        i = r._space(),
                        s = f[i],
                        o = this.alpha() === 0 ? a("transparent") : this,
                        u = o[s.cache] || s.to(o._rgba),
                        c = u.slice();
                    return r = r[s.cache], d(s.props, function (e, i) {
                        var s = i.idx,
                            o = u[s],
                            a = r[s],
                            f = l[i.type] || {};
                        if (a === null) {
                            return
                        }
                        o === null ? c[s] = a : (f.mod && (a - o > f.mod / 2 ? o += f.mod : o - a > f.mod / 2 && (o -= f.mod)), c[s] = n((a - o) * t + o, i))
                    }), this[i](c)
                },
                blend: function (t) {
                    if (this._rgba[3] === 1) {
                        return this
                    }
                    var n = this._rgba.slice(),
                        r = n.pop(),
                        i = a(t)._rgba;
                    return a(e.map(n, function (e, t) {
                        return (1 - r) * i[t] + r * e
                    }))
                },
                toRgbaString: function () {
                    var t = "rgba(",
                        n = e.map(this._rgba, function (e, t) {
                            return e == null ? t > 2 ? 1 : 0 : e
                        });
                    return n[3] === 1 && (n.pop(), t = "rgb("), t + n.join() + ")"
                },
                toHslaString: function () {
                    var t = "hsla(",
                        n = e.map(this.hsla(), function (e, t) {
                            return e == null && (e = t > 2 ? 1 : 0), t && t < 3 && (e = Math.round(e * 100) + "%"), e
                        });
                    return n[3] === 1 && (n.pop(), t = "hsl("), t + n.join() + ")"
                },
                toHexString: function (t) {
                    var n = this._rgba.slice(),
                        r = n.pop();
                    return t && n.push(~~(r * 255)), "#" + e.map(n, function (e) {
                        return e = (e || 0).toString(16), e.length === 1 ? "0" + e : e
                    }).join("")
                },
                toString: function () {
                    return this._rgba[3] === 0 ? "transparent" : this.toRgbaString()
                }
            }), a.fn.parse.prototype = a.fn, f.hsla.to = function (e) {
                if (e[0] == null || e[1] == null || e[2] == null) {
                    return [null, null, null, e[3]]
                }
                var t = e[0] / 255,
                    n = e[1] / 255,
                    r = e[2] / 255,
                    i = e[3],
                    s = Math.max(t, n, r),
                    o = Math.min(t, n, r),
                    u = s - o,
                    a = s + o,
                    f = a * .5,
                    l, c;
                return o === s ? l = 0 : t === s ? l = 60 * (n - r) / u + 360 : n === s ? l = 60 * (r - t) / u + 120 : l = 60 * (t - n) / u + 240, u === 0 ? c = 0 : f <= .5 ? c = u / a : c = u / (2 - a), [Math.round(l) % 360, c, f, i == null ? 1 : i]
            }, f.hsla.from = function (e) {
                if (e[0] == null || e[1] == null || e[2] == null) {
                    return [null, null, null, e[3]]
                }
                var t = e[0] / 360,
                    n = e[1],
                    r = e[2],
                    s = e[3],
                    o = r <= .5 ? r * (1 + n) : r + n - r * n,
                    u = 2 * r - o;
                return [Math.round(i(u, o, t + 1 / 3) * 255), Math.round(i(u, o, t) * 255), Math.round(i(u, o, t - 1 / 3) * 255), s]
            }, d(f, function (r, i) {
                var s = i.props,
                    u = i.cache,
                    f = i.to,
                    l = i.from;
                a.fn[r] = function (r) {
                    f && !this[u] && (this[u] = f(this._rgba));
                    if (r === t) {
                        return this[u].slice()
                    }
                    var i, o = e.type(r),
                        c = o === "array" || o === "object" ? r : arguments,
                        h = this[u].slice();
                    return d(s, function (e, t) {
                        var r = c[o === "object" ? e : t.idx];
                        r == null && (r = h[t.idx]), h[t.idx] = n(r, t)
                    }), l ? (i = a(l(h)), i[u] = h, i) : a(h)
                }, d(s, function (t, n) {
                    if (a.fn[t]) {
                        return
                    }
                    a.fn[t] = function (i) {
                        var s = e.type(i),
                            u = t === "alpha" ? this._hsla ? "hsla" : "rgba" : r,
                            a = this[u](),
                            f = a[n.idx],
                            l;
                        return s === "undefined" ? f : (s === "function" && (i = i.call(this, f), s = e.type(i)), i == null && n.empty ? this : (s === "string" && (l = o.exec(i), l && (i = f + parseFloat(l[2]) * (l[1] === "+" ? 1 : -1))), a[n.idx] = i, this[u](a)))
                    }
                })
            }), a.hook = function (t) {
                var n = t.split(" ");
                d(n, function (t, n) {
                    e.cssHooks[n] = {
                        set: function (t, i) {
                            var s, o, u = "";
                            if (i !== "transparent" && (e.type(i) !== "string" || (s = r(i)))) {
                                i = a(s || i);
                                if (!c.rgba && i._rgba[3] !== 1) {
                                    o = n === "backgroundColor" ? t.parentNode : t;
                                    while ((u === "" || u === "transparent") && o && o.style) {
                                        try {
                                            u = e.css(o, "backgroundColor"), o = o.parentNode
                                        } catch (f) {}
                                    }
                                    i = i.blend(u && u !== "transparent" ? u : "_default")
                                }
                                i = i.toRgbaString()
                            }
                            try {
                                t.style[n] = i
                            } catch (f) {}
                        }
                    }, e.fx.step[n] = function (t) {
                        t.colorInit || (t.start = a(t.elem, n), t.end = a(t.end), t.colorInit = !0), e.cssHooks[n].set(t.elem, t.start.transition(t.end, t.pos))
                    }
                })
            }, a.hook(s), e.cssHooks.borderColor = {
                expand: function (e) {
                    var t = {};
                    return d(["Top", "Right", "Bottom", "Left"], function (n, r) {
                        t["border" + r + "Color"] = e
                    }), t
                }
            }, p = e.Color.names = {
                aqua: "#00ffff",
                black: "#000000",
                blue: "#0000ff",
                fuchsia: "#ff00ff",
                gray: "#808080",
                green: "#008000",
                lime: "#00ff00",
                maroon: "#800000",
                navy: "#000080",
                olive: "#808000",
                purple: "#800080",
                red: "#ff0000",
                silver: "#c0c0c0",
                teal: "#008080",
                white: "#ffffff",
                yellow: "#ffff00",
                transparent: [null, null, null, 0],
                _default: "#ffffff"
            }
        }(jQuery),
        function () {
            function n(t) {
                var n, r, i = t.ownerDocument.defaultView ? t.ownerDocument.defaultView.getComputedStyle(t, null) : t.currentStyle,
                    s = {};
                if (i && i.length && i[0] && i[i[0]]) {
                    r = i.length;
                    while (r--) {
                        n = i[r], typeof i[n] == "string" && (s[e.camelCase(n)] = i[n])
                    }
                } else {
                    for (n in i) {
                        typeof i[n] == "string" && (s[n] = i[n])
                    }
                }
                return s
            }

            function r(t, n) {
                var r = {},
                    i, o;
                for (i in n) {
                    o = n[i], t[i] !== o && !s[i] && (e.fx.step[i] || !isNaN(parseFloat(o))) && (r[i] = o)
                }
                return r
            }
            var i = ["add", "remove", "toggle"],
                s = {
                    border: 1,
                    borderBottom: 1,
                    borderColor: 1,
                    borderLeft: 1,
                    borderRight: 1,
                    borderTop: 1,
                    borderWidth: 1,
                    margin: 1,
                    padding: 1
                };
            e.each(["borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle"], function (t, n) {
                e.fx.step[n] = function (e) {
                    if (e.end !== "none" && !e.setAttr || e.pos === 1 && !e.setAttr) {
                        jQuery.style(e.elem, n, e.end), e.setAttr = !0
                    }
                }
            }), e.fn.addBack || (e.fn.addBack = function (e) {
                return this.add(e == null ? this.prevObject : this.prevObject.filter(e))
            }), e.effects.animateClass = function (t, s, o, u) {
                var a = e.speed(s, o, u);
                return this.queue(function () {
                    var s = e(this),
                        o = s.attr("class") || "",
                        u, f = a.children ? s.find("*").addBack() : s;
                    f = f.map(function () {
                        var t = e(this);
                        return {
                            el: t,
                            start: n(this)
                        }
                    }), u = function () {
                        e.each(i, function (e, n) {
                            t[n] && s[n + "Class"](t[n])
                        })
                    }, u(), f = f.map(function () {
                        return this.end = n(this.el[0]), this.diff = r(this.start, this.end), this
                    }), s.attr("class", o), f = f.map(function () {
                        var t = this,
                            n = e.Deferred(),
                            r = e.extend({}, a, {
                                queue: !1,
                                complete: function () {
                                    n.resolve(t)
                                }
                            });
                        return this.el.animate(this.diff, r), n.promise()
                    }), e.when.apply(e, f.get()).done(function () {
                        u(), e.each(arguments, function () {
                            var t = this.el;
                            e.each(this.diff, function (e) {
                                t.css(e, "")
                            })
                        }), a.complete.call(s[0])
                    })
                })
            }, e.fn.extend({
                _addClass: e.fn.addClass,
                addClass: function (t, n, r, i) {
                    return n ? e.effects.animateClass.call(this, {
                        add: t
                    }, n, r, i) : this._addClass(t)
                },
                _removeClass: e.fn.removeClass,
                removeClass: function (t, n, r, i) {
                    return n ? e.effects.animateClass.call(this, {
                        remove: t
                    }, n, r, i) : this._removeClass(t)
                },
                _toggleClass: e.fn.toggleClass,
                toggleClass: function (n, r, i, s, o) {
                    return typeof r == "boolean" || r === t ? i ? e.effects.animateClass.call(this, r ? {
                        add: n
                    } : {
                        remove: n
                    }, i, s, o) : this._toggleClass(n, r) : e.effects.animateClass.call(this, {
                        toggle: n
                    }, r, i, s)
                },
                switchClass: function (t, n, r, i, s) {
                    return e.effects.animateClass.call(this, {
                        add: n,
                        remove: t
                    }, r, i, s)
                }
            })
        }(),
        function () {
            function r(t, n, r, i) {
                e.isPlainObject(t) && (n = t, t = t.effect), t = {
                    effect: t
                }, n == null && (n = {}), e.isFunction(n) && (i = n, r = null, n = {});
                if (typeof n == "number" || e.fx.speeds[n]) {
                    i = r, r = n, n = {}
                }
                return e.isFunction(r) && (i = r, r = null), n && e.extend(t, n), r = r || n.duration, t.duration = e.fx.off ? 0 : typeof r == "number" ? r : r in e.fx.speeds ? e.fx.speeds[r] : e.fx.speeds._default, t.complete = i || n.complete, t
            }

            function i(t) {
                return !t || typeof t == "number" || e.fx.speeds[t] ? !0 : typeof t == "string" && !e.effects.effect[t]
            }
            e.extend(e.effects, {
                version: "1.10.0",
                save: function (e, t) {
                    for (var r = 0; r < t.length; r++) {
                        t[r] !== null && e.data(n + t[r], e[0].style[t[r]])
                    }
                },
                restore: function (e, r) {
                    var i, s;
                    for (s = 0; s < r.length; s++) {
                        r[s] !== null && (i = e.data(n + r[s]), i === t && (i = ""), e.css(r[s], i))
                    }
                },
                setMode: function (e, t) {
                    return t === "toggle" && (t = e.is(":hidden") ? "show" : "hide"), t
                },
                getBaseline: function (e, t) {
                    var n, r;
                    switch (e[0]) {
                    case "top":
                        n = 0;
                        break;
                    case "middle":
                        n = .5;
                        break;
                    case "bottom":
                        n = 1;
                        break;
                    default:
                        n = e[0] / t.height
                    }
                    switch (e[1]) {
                    case "left":
                        r = 0;
                        break;
                    case "center":
                        r = .5;
                        break;
                    case "right":
                        r = 1;
                        break;
                    default:
                        r = e[1] / t.width
                    }
                    return {
                        x: r,
                        y: n
                    }
                },
                createWrapper: function (t) {
                    if (t.parent().is(".ui-effects-wrapper")) {
                        return t.parent()
                    }
                    var n = {
                            width: t.outerWidth(!0),
                            height: t.outerHeight(!0),
                            "float": t.css("float")
                        },
                        r = e("<div></div>").addClass("ui-effects-wrapper").css({
                            fontSize: "100%",
                            background: "transparent",
                            border: "none",
                            margin: 0,
                            padding: 0
                        }),
                        i = {
                            width: t.width(),
                            height: t.height()
                        },
                        s = document.activeElement;
                    try {
                        s.id
                    } catch (o) {
                        s = document.body
                    }
                    return t.wrap(r), (t[0] === s || e.contains(t[0], s)) && e(s).focus(), r = t.parent(), t.css("position") === "static" ? (r.css({
                        position: "relative"
                    }), t.css({
                        position: "relative"
                    })) : (e.extend(n, {
                        position: t.css("position"),
                        zIndex: t.css("z-index")
                    }), e.each(["top", "left", "bottom", "right"], function (e, r) {
                        n[r] = t.css(r), isNaN(parseInt(n[r], 10)) && (n[r] = "auto")
                    }), t.css({
                        position: "relative",
                        top: 0,
                        left: 0,
                        right: "auto",
                        bottom: "auto"
                    })), t.css(i), r.css(n).show()
                },
                removeWrapper: function (t) {
                    var n = document.activeElement;
                    return t.parent().is(".ui-effects-wrapper") && (t.parent().replaceWith(t), (t[0] === n || e.contains(t[0], n)) && e(n).focus()), t
                },
                setTransition: function (t, n, r, i) {
                    return i = i || {}, e.each(n, function (e, n) {
                        var s = t.cssUnit(n);
                        s[0] > 0 && (i[n] = s[0] * r + s[1])
                    }), i
                }
            }), e.fn.extend({
                effect: function () {
                    function t(t) {
                        function r() {
                            e.isFunction(s) && s.call(i[0]), e.isFunction(t) && t()
                        }
                        var i = e(this),
                            s = n.complete,
                            u = n.mode;
                        (i.is(":hidden") ? u === "hide" : u === "show") ? r(): o.call(i[0], n, r)
                    }
                    var n = r.apply(this, arguments),
                        i = n.mode,
                        s = n.queue,
                        o = e.effects.effect[n.effect];
                    return e.fx.off || !o ? i ? this[i](n.duration, n.complete) : this.each(function () {
                        n.complete && n.complete.call(this)
                    }) : s === !1 ? this.each(t) : this.queue(s || "fx", t)
                },
                _show: e.fn.show,
                show: function (e) {
                    if (i(e)) {
                        return this._show.apply(this, arguments)
                    }
                    var t = r.apply(this, arguments);
                    return t.mode = "show", this.effect.call(this, t)
                },
                _hide: e.fn.hide,
                hide: function (e) {
                    if (i(e)) {
                        return this._hide.apply(this, arguments)
                    }
                    var t = r.apply(this, arguments);
                    return t.mode = "hide", this.effect.call(this, t)
                },
                __toggle: e.fn.toggle,
                toggle: function (t) {
                    if (i(t) || typeof t == "boolean" || e.isFunction(t)) {
                        return this.__toggle.apply(this, arguments)
                    }
                    var n = r.apply(this, arguments);
                    return n.mode = "toggle", this.effect.call(this, n)
                },
                cssUnit: function (t) {
                    var n = this.css(t),
                        r = [];
                    return e.each(["em", "px", "%", "pt"], function (e, t) {
                        n.indexOf(t) > 0 && (r = [parseFloat(n), t])
                    }), r
                }
            })
        }(),
        function () {
            var t = {};
            e.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function (e, n) {
                t[n] = function (t) {
                    return Math.pow(t, e + 2)
                }
            }), e.extend(t, {
                Sine: function (e) {
                    return 1 - Math.cos(e * Math.PI / 2)
                },
                Circ: function (e) {
                    return 1 - Math.sqrt(1 - e * e)
                },
                Elastic: function (e) {
                    return e === 0 || e === 1 ? e : -Math.pow(2, 8 * (e - 1)) * Math.sin(((e - 1) * 80 - 7.5) * Math.PI / 15)
                },
                Back: function (e) {
                    return e * e * (3 * e - 2)
                },
                Bounce: function (e) {
                    var t, n = 4;
                    while (e < ((t = Math.pow(2, --n)) - 1) / 11) {}
                    return 1 / Math.pow(4, 3 - n) - 7.5625 * Math.pow((t * 3 - 2) / 22 - e, 2)
                }
            }), e.each(t, function (t, n) {
                e.easing["easeIn" + t] = n, e.easing["easeOut" + t] = function (e) {
                    return 1 - n(1 - e)
                }, e.easing["easeInOut" + t] = function (e) {
                    return e < .5 ? n(e * 2) / 2 : 1 - n(e * -2 + 2) / 2
                }
            })
        }()
}(jQuery);
(function (e, t) {
    e.effects.effect.slide = function (t, n) {
        var r = e(this),
            i = ["position", "top", "bottom", "left", "right", "width", "height"],
            s = e.effects.setMode(r, t.mode || "show"),
            o = s === "show",
            u = t.direction || "left",
            a = u === "up" || u === "down" ? "top" : "left",
            f = u === "up" || u === "left",
            l, c = {};
        e.effects.save(r, i), r.show(), l = t.distance || r[a === "top" ? "outerHeight" : "outerWidth"](!0), e.effects.createWrapper(r).css({
            overflow: "hidden"
        }), o && r.css(a, f ? isNaN(l) ? "-" + l : -l : l), c[a] = (o ? f ? "+=" : "-=" : f ? "-=" : "+=") + l, r.animate(c, {
            queue: !1,
            duration: t.duration,
            easing: t.easing,
            complete: function () {
                s === "hide" && r.hide(), e.effects.restore(r, i), e.effects.removeWrapper(r), n()
            }
        })
    }
})(jQuery);
jQuery.cookie = function (e, t, n) {
    if (arguments.length > 1 && String(t) !== "[object Object]") {
        n = jQuery.extend({}, n);
        if (t === null || t === undefined) {
            n.expires = -1
        }
        if (typeof n.expires === "number") {
            var r = n.expires,
                i = n.expires = new Date;
            i.setDate(i.getDate() + r)
        }
        t = String(t);
        return document.cookie = [encodeURIComponent(e), "=", n.raw ? t : encodeURIComponent(t), n.expires ? "; expires=" + n.expires.toUTCString() : "", n.path ? "; path=" + n.path : "", n.domain ? "; domain=" + n.domain : "", n.secure ? "; secure" : ""].join("")
    }
    n = t || {};
    var s, o = n.raw ? function (e) {
        return e
    } : decodeURIComponent;
    return (s = (new RegExp("(?:^|; )" + encodeURIComponent(e) + "=([^;]*)")).exec(document.cookie)) ? o(s[1]) : null
};
(function (e) {
    e.fn.extend({
        outerHTML: function (t) {
            if (!this.length) {
                return null
            } else {
                if (t === undefined) {
                    var n = this.length ? this[0] : this,
                        r;
                    if (n.outerHTML) {
                        r = n.outerHTML
                    } else {
                        r = e(document.createElement("div")).append(e(n).clone()).html()
                    } if (typeof r === "string") {
                        r = e.trim(r)
                    }
                    return r
                } else {
                    if (e.isFunction(t)) {
                        this.each(function (n) {
                            var r = e(this);
                            r.outerHTML(t.call(this, n, r.outerHTML()))
                        })
                    } else {
                        var i = e(this),
                            s = [],
                            o = e(t),
                            u;
                        for (var f = 0; f < i.length; f++) {
                            u = o.clone(true);
                            i.eq(f).replaceWith(u);
                            for (var l = 0; l < u.length; l++) {
                                s.push(u[l])
                            }
                        }
                        return s.length ? e(s) : null
                    }
                }
            }
        }
    })
})(jQuery);
jQuery.fn.showLoading = function (e) {
    var t;
    var n = {
        addClass: "",
        beforeShow: "",
        afterShow: "",
        hPos: "center",
        vPos: "center",
        indicatorZIndex: 10001,
        overlayZIndex: 1e4,
        parent: "",
        marginTop: 0,
        marginLeft: 0,
        overlayWidth: null,
        overlayHeight: null
    };
    jQuery.extend(n, e);
    var r = jQuery("<div></div>");
    var i = jQuery("<div></div>");
    if (n.indicatorID) {
        t = n.indicatorID
    } else {
        t = jQuery(this).attr("id")
    }
    jQuery(r).attr("id", "loading-indicator-" + t);
    jQuery(r).addClass("loading-indicator");
    if (n.addClass) {
        jQuery(r).addClass(n.addClass)
    }
    jQuery(i).css("display", "none");
    jQuery(document.body).append(i);
    jQuery(i).attr("id", "loading-indicator-" + t + "-overlay");
    jQuery(i).addClass("loading-indicator-overlay");
    if (n.addClass) {
        jQuery(i).addClass(n.addClass + "-overlay")
    }
    var s;
    var o;
    var u = jQuery(this).css("border-top-width");
    var a = jQuery(this).css("border-left-width");
    u = isNaN(parseInt(u)) ? 0 : u;
    a = isNaN(parseInt(a)) ? 0 : a;
    var f = jQuery(this).offset().left + parseInt(a);
    var l = jQuery(this).offset().top + parseInt(u);
    if (n.overlayWidth !== null) {
        s = n.overlayWidth
    } else {
        s = parseInt(jQuery(this).width()) + parseInt(jQuery(this).css("padding-right")) + parseInt(jQuery(this).css("padding-left"))
    } if (n.overlayHeight !== null) {
        o = n.overlayWidth
    } else {
        o = parseInt(jQuery(this).height()) + parseInt(jQuery(this).css("padding-top")) + parseInt(jQuery(this).css("padding-bottom"))
    } if (o > 500) {
        n.vPos = "top";
        n.marginTop = 100
    }
    jQuery(i).css("width", s.toString() + "px");
    jQuery(i).css("height", o.toString() + "px");
    jQuery(i).css("left", f.toString() + "px");
    jQuery(i).css("position", "absolute");
    jQuery(i).css("top", l.toString() + "px");
    jQuery(i).css("z-index", n.overlayZIndex);
    if (n.overlayCSS) {
        jQuery(i).css(n.overlayCSS)
    }
    jQuery(r).css("display", "none");
    jQuery(document.body).append(r);
    jQuery(r).css("position", "absolute");
    jQuery(r).css("z-index", n.indicatorZIndex);
    var c = l;
    if (n.marginTop) {
        c += parseInt(n.marginTop)
    }
    var h = f;
    if (n.marginLeft) {
        h += parseInt(n.marginTop)
    }
    if (n.hPos.toString().toLowerCase() == "center") {
        jQuery(r).css("left", (h + (jQuery(i).width() - parseInt(jQuery(r).width())) / 2).toString() + "px")
    } else {
        if (n.hPos.toString().toLowerCase() == "left") {
            jQuery(r).css("left", (h + parseInt(jQuery(i).css("margin-left"))).toString() + "px")
        } else {
            if (n.hPos.toString().toLowerCase() == "right") {
                jQuery(r).css("left", (h + (jQuery(i).width() - parseInt(jQuery(r).width()))).toString() + "px")
            } else {
                jQuery(r).css("left", (h + parseInt(n.hPos)).toString() + "px")
            }
        }
    } if (n.vPos.toString().toLowerCase() == "center") {
        jQuery(r).css("top", (c + (jQuery(i).height() - parseInt(jQuery(r).height())) / 2).toString() + "px")
    } else {
        if (n.vPos.toString().toLowerCase() == "top") {
            jQuery(r).css("top", c.toString() + "px")
        } else {
            if (n.vPos.toString().toLowerCase() == "bottom") {
                jQuery(r).css("top", (c + (jQuery(i).height() - parseInt(jQuery(r).height()))).toString() + "px")
            } else {
                jQuery(r).css("top", (c + parseInt(n.vPos)).toString() + "px")
            }
        }
    } if (n.css) {
        jQuery(r).css(n.css)
    }
    var p = {
        overlay: i,
        indicator: r,
        element: this
    };
    if (typeof n.beforeShow == "function") {
        n.beforeShow(p)
    }
    jQuery(i).show();
    jQuery(r).show();
    if (typeof n.afterShow == "function") {
        n.afterShow(p)
    }
    return this
};
jQuery.fn.hideLoading = function (e) {
    var t = {};
    jQuery.extend(t, e);
    if (t.indicatorID) {
        indicatorID = t.indicatorID
    } else {
        indicatorID = jQuery(this).attr("id")
    }
    jQuery(document.body).find("#loading-indicator-" + indicatorID).remove();
    jQuery(document.body).find("#loading-indicator-" + indicatorID + "-overlay").remove();
    return this
};
jQuery.extend({
    stringify: function (t) {
        if ("JSON" in window) {
            return JSON.stringify(t)
        }
        var n = typeof t;
        if (n != "object" || t === null) {
            if (n == "string") {
                t = '"' + t + '"'
            }
            return String(t)
        } else {
            var r, i, s = [],
                o = t && t.constructor == Array;
            for (r in t) {
                i = t[r];
                n = typeof i;
                if (t.hasOwnProperty(r)) {
                    if (n == "string") {
                        i = '"' + i + '"'
                    } else {
                        if (n == "object" && i !== null) {
                            i = jQuery.stringify(i)
                        }
                    }
                    s.push((o ? "" : '"' + r + '":') + String(i))
                }
            }
            return (o ? "[" : "{") + String(s) + (o ? "]" : "}")
        }
    }
});
$(function () {
    if ($("#side-nav-container li.active")) {
        var e = $("#side-nav-container li.active").parent().closest("li");
        e.addClass("selected");
        e.children("ul").slideDown()
    }
});
PAMH.CurrencyCodes = {
    __default__: {
        symbol: "$"
    },
    GBP: "£",
    CAD: "$",
    USD: "$",
    NZD: "$",
    AUD: "$",
    EUR: "€",
    TRY: "TRY",
    ILS: "₪"
};
PAMH.Currencies = {
    __default__: {
        symbol: "$",
        code: "USD"
    },
    GB: {
        symbol: "£",
        code: "GBP"
    },
    CA: {
        symbol: "CA$",
        code: "CAD"
    },
    US: {
        symbol: "$",
        code: "USD"
    },
    NZ: {
        symbol: "NZ$",
        code: "NZD"
    },
    AU: {
        symbol: "AU$",
        code: "AUD"
    },
    IE: {
        symbol: "€",
        code: "EUR"
    },
    FR: {
        symbol: "€",
        code: "EUR"
    },
    DE: {
        symbol: "€",
        code: "EUR"
    },
    TR: {
        symbol: "TRY",
        code: "TRY"
    },
    IT: {
        symbol: "€",
        code: "EUR"
    },
    NL: {
        symbol: "€",
        code: "EUR"
    },
    IL: {
        symbol: "₪",
        code: "ILS"
    },
    ES: {
        symbol: "€",
        code: "EUR"
    }
};
PAMH.CountryCoords = {
    __default__: {
        lat: 51.501476,
        lng: -.13183
    },
    GB: {
        lat: 51.501476,
        lng: -.13183
    },
    TR: {
        lat: 41.0168,
        lng: 28.9478
    },
    CA: {
        lat: 56.704506,
        lng: -99.228516
    },
    US: {
        lat: 40.513799,
        lng: -96.328125
    },
    NZ: {
        lat: -41.004775,
        lng: 174.25415
    },
    AU: {
        lat: -33.045508,
        lng: 148.864746
    },
    IE: {
        lat: 53.363665,
        lng: -6.306152
    },
    FR: {
        lat: 48.866667,
        lng: 2.333056
    },
    DE: {
        lat: 52.516667,
        lng: 13.416667
    },
    ES: {
        lat: 40.4,
        lng: -3.683333
    },
    DK: {
        lat: 55.716667,
        lng: 12.566667
    },
    IT: {
        lat: 41.9,
        lng: 12.5
    },
    NO: {
        lat: 59.933333,
        lng: 10.683333
    },
    SE: {
        lat: 59.35,
        lng: 18.066667
    },
    FI: {
        lat: 60.166667,
        lng: 24.933333
    },
    IL: {
        lat: 32.068902,
        lng: 34.779282
    },
    NL: {
        lat: 52.368892,
        lng: 4.817505
    }
};
$(function () {
    $("#navbar-activity").one("click.update", function (e) {
        var t = $(this).attr("data-url");
        var n = $(this);
        $.ajax({
            type: "POST",
            url: t,
            dataType: "json",
            beforeSend: function () {
                n.find(".notification-alert").remove()
            }
        })
    });
    $("#activity-feed a").on("click.link", function (e) {
        $("body").click();
        return true
    });
    $("#notifications-feed button").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var t = $(this).attr("data-dismiss");
        var n = $(this).attr("data-url");
        var r = $(this);
        $.ajax({
            type: "POST",
            url: n,
            dataType: "json",
            data: {
                name: t
            },
            beforeSend: function () {
                r.closest("li").fadeOut()
            }
        })
    })
});
if (PAMH.MapsAvailable) {
    var place_result;
    (function (e) {
        e.searchAutocomplete = function (t) {
            var n = t;
            var form = t.closest("form");
            n.settings = {
                container: t,
                place_result: null,
                original_url: form.attr("data-url") ? form.attr("data-url") : form.attr("action")
            };
            n.init = function () {
                var worldBounds = null;

                n.settings.container.keyup(function () {
                    if (n.settings.container.val()=="") {
                        e("input.autocomplete").val("")
                    }

                    if (e(".ac_coords").val()) {
                        e("input.autocomplete").val("")
                    }
                });

                  worldBounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(-90, -180),
                    new google.maps.LatLng(90,180)
                  );

                autocomplete = new google.maps.places.Autocomplete(n.settings.container.get(0), {
                  bounds: worldBounds
                });

                n.settings.container.on("keydown", function(e) {
                    if (e.which == 13) {
                        e.preventDefault();

                        if (n.settings.container.val() && n.settings.container.hasClass("search-form-reveal")) {
                            n.settings.container.closest("form").addClass("form-open");
                            $("#search-form-reveal").animate({'opacity':'1'}, 500);
                        }

                        if (n.settings.container.val()) {
                            n.settings.container.closest("form").find("[name='start_date']").focus();
                        }

                    }

                    var form = n.settings.container.closest("form");
                    form.attr("action", n.settings.original_url);
                });

                e("<input />", {
                    type: "hidden",
                    name: "coords",
                    "class": "autocomplete ac_coords",
                    value: PAMH.InitialCoords ? PAMH.InitialCoords.join(",") : ""
                }).insertAfter(n.settings.container);
                e("<input />", {
                    type: "hidden",
                    name: "source",
                    "class": "autocomplete ac_source",
                    value: "none"
                }).insertAfter(n.settings.container);
                e("<input />", {
                    type: "hidden",
                    name: "location_name",
                    "class": "autocomplete ac_location_name",
                    value: PAMH.InitialLocationName ? PAMH.InitialLocationName : ""
                }).insertAfter(n.settings.container);
                e("<input />", {
                    type: "hidden",
                    name: "place_id",
                    "class": "autocomplete ac_place_id",
                    value: PAMH.placeId ? PAMH.placeId : ""
                }).insertAfter(n.settings.container);
                e("<input />", {
                    type: "hidden",
                    name: "ac_country",
                    "class": "autocomplete ac_country",
                    value: PAMH.localCountry ? PAMH.localCountry : ""
                }).insertAfter(n.settings.container);
                e("<input />", {
                    type: "hidden",
                    "class": "autocomplete places_attribution"
                }).insertAfter(n.settings.container);

                autocomplete.addListener("place_changed", function () {
                    place_result = autocomplete.getPlace();
                    var form = n.settings.container.closest("form");
                    if (place_result.geometry) {
                        e(".ac_coords").val(place_result.geometry.location.lat() + "," + place_result.geometry.location.lng()).change();
                        e(".ac_location_name").val(place_result.name);
                        e(".ac_place_id").val(place_result.place_id);
                        e(".ac_source").val("autocomplete");
                        e(place_result.address_components).each(function () {
                            if (this.types.indexOf("country") > -1) {
                                e(".ac_country").val(this.short_name);
                                return false
                            }
                        });
                        if (n.settings.container.hasClass("auto-submit")) {
                            form.submit()
                        }

                        if (n.settings.container.hasClass("search-form-reveal")) {
                            form.addClass("form-open");
                            $("#search-form-reveal").animate({'opacity':'1'}, 500);
                        }

                        analytics.track("click:search-results:autocomplete", {platform: window.PLATFORM});

                        $.ajax({
                          method: "POST",
                          url: "/search/lookup/",
                          data: form.serialize()
                        }).always(function( data, textStatus, jqXHR ) {
                            if (data.url && !form.hasClass("independent-search")){
                                form.attr("action", data.url);
                            } else {
                                form.attr("action", n.settings.original_url);
                            }
                        });
                    }
                });
            };
            n.init();
            return n;
        };
        e.fn.searchAutocomplete = function () {
            return new e.searchAutocomplete(this)
        }
    })(jQuery);
    $(function () {
        $(".places-autocomplete").each(function (e, t) {
            $(t).searchAutocomplete().click(function () {
                $(this).select()
            })
        });
        $("body").one("click", ".overlay .places-autocomplete", function () {
            $(this).searchAutocomplete()
        })
    })
}
$(function () {
    $("body").on("click", ".modal a.cancel", function (e) {
        $("#pamh_modal").modal("hide");
        return false
    });
    $("body").on("click", "input.selectable", function (e) {
        $(this).select()
    });
    $("body").on("submit.disabled", "form", function (e) {
        $(this).find("button[type='submit']").attr("disabled", "disabled");
        return true
    });
    $("body").on("click.add-input", "form button[name][type='submit']", function (e) {
        $this = $(this);
        if ($this.attr("name")) {
            $this.after($("<input />", {
                name: $this.attr("name"),
                value: $this.attr("value"),
                type: "hidden"
            }))
        }
    });
    return true
});
$(window).load(function () {
    $("a[rel='help']").live("click", function (e) {
        e.preventDefault();
        window.open(this.href);
        return false
    });
    $("a[rel='help-dropbox']").live("click", function (e) {
        if (window.Zenbox) {
            e.preventDefault();
            Zenbox.show();
            return false
        }
        return true
    })
});
$(document).ready(function () {
    $("body").on("click", "#checkbox_select_all", function () {
        if (this.checked) {
            $(this).closest("table").find("td input[type=checkbox]").prop("checked", true)
        } else {
            $(this).closest("table").find("td input[type=checkbox]").prop("checked", false)
        }
        return true
    })
});
$(function () {
    $('.collapsible a[href="#"]').click(function (e) {
        e.preventDefault();
        $(this).parent().next("ul").slideToggle("fast");
        $(this).closest("li").toggleClass("selected")
    })
});
$(document).ready(function () {
    $("body").on("click.confirm", ".confirm", function (e) {
        if (!confirm($(this).attr("data-text") || "Are you sure?")) {
            e.stopImmediatePropagation();
            return false
        }
        return true
    })
});
$(function () {
    $("body").on("click.link", "a[rel~=external], a[rel~=new-window]", function () {
        window.open(this.href);
        return false
    });
    if ($("body").hasClass("press-pages")) {
        $.each($("a[data-url]"), function (e, t) {
            var n = $(this).attr("data-url");
            $(this).attr("href", n)
        })
    }
});
$(function () {
    if ($("body").hasClass("listing-form") || $("body").hasClass("thread-amend") || $("body").hasClass("admin")) {
        $("input[data-prepended]").each(function (e, t) {
            var n = $(t).attr("data-prepended");
            $(t).wrap('<div class="input-prepend" />');
            $(t).before('<span class="add-on" data-type="currency-symbol">' + n + "</span>")
        });
        $("input[data-appended]").each(function (e, t) {
            var n = $(t).attr("data-appended");
            $(t).wrap('<div class="input-append" />');
            $(t).before('<span class="add-on" data-type="currency-symbol">' + n + "</span>")
        })
    }
});
$(window).load(function () {
    $("#alerts div.alert").each(function (e, t) {
        $(t).slideDown(500)
    })
});
$(function () {
    $("a[rel=toggle-display]").click(function (e) {
        e.preventDefault();
        var t = $($(this).attr("href"));
        t.slideToggle()
    })
});
$(function () {
    $("body").on("click", "a[rel=overlay], a.overlayed", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $this = $(this);

        $modal = $("#pamh_modal");

        $modal.on("shown", function () {
            if ($this.attr("data-action") == "leave-feedback") {

                // Manually load content, instead of using jQuery modal 'remote'
                // option.
                $modal.load($this.attr('href'), function() {

                    // Load rating meter for each form field
                    $(".modal input.rating-meter").each(function (e, t) {
                        $(t).ratingInput();
                    });
                });
            }
        });

        $modal.modal({
          remote: $this.attr('href')
        });
    }).attr("target", "_blank");
    $("a[rel='image-detail']").on("click", function (e) {
        e.preventDefault();
        var t = $(this);
        $("div.modal-content").html('<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button><h3 id="myModalLabel">Photo</h3></div><div class="modal-body" style="max-height:700px; text-align:center;"><img src="' + t.attr("data-url") + '" /></div><div class="modal-footer"><button class="btn o-btn" data-dismiss="modal" aria-hidden="true">Close</button></div>');
        $("#pamh_modal").modal({
            show: true
        })
    }).attr("target", "_blank");
    $("a[rel='video-detail']").on("click", function (e) {
        e.preventDefault();
        var t = $(this);
        $("div.modal-content").html('<div class="modal-body" style="max-height:340px; text-align:center;"><iframe width="' + t.attr("data-width") + '" height="' + t.attr("data-height") + '" src="' + t.attr("href") + '" frameborder="0" allowfullscreen></iframe></div><div class="modal-footer"><button class="btn" data-dismiss="modal" aria-hidden="true">Close</button></div>');
        $("#pamh_modal").modal({
            show: true
        })
    }).attr("target", "_blank");
    $("#pamh_modal").on("hidden", function () {
        $(this).removeData("modal");
        $(this).removeAttr("style");
        $(this).find(".modal-body").html("");
    })
});

require('./extensions/placeholder.js');
$(function () {
    if ($.browser.msie || $.browser.mozilla) {
        $("input[placeholder]").each(function (e, t) {
            $(t).placeholder()
        })
    }
});
require('./extensions/form_selection_groups.js');

$(function () {
    $("input.selection-chooser[type=radio]").formSelectionGroups()
});

$(document).ready(function () {

    PAMH.datePickerMinDateOptions = {
        minDate: null
    };
    PAMH.datePickerOptions = {
        firstDay: 1,
        defaultDate: new Date,
        minDate: new Date,
        showAnim: "slideDown",
        selectDefaultDate: true,
        dateFormat: "dd M yy",
        showOtherMonths: true,
        selectOtherMonths: true,
        onSelect: function (e) {
            if ($(this).is('[name^="start_"]')) {
                $('input.datepicker[name^="end_"]').datepicker("option", "minDate", e || 0);

                if ($('input.datepicker[name^="end_"]').first().val()==""){
                    $('input.datepicker[name^="end_"]').first().val($(this).val());
                }

            }
            $(this).blur();
            $(this).trigger("dateChange");
            $(this).trigger("change");

            return;
        }
    };
    $("input.datepicker").each(function (e, t) {
        if ($(t).hasClass("noMinDate") || $(t).attr("id") == "id_new_end_date_0" || $(t).attr("id") == "id_new_start_date_0") {
            $.extend(PAMH.datePickerOptions, PAMH.datePickerMinDateOptions)
        }
        $(t).attr("autocomplete", "off").datepicker(PAMH.datePickerOptions);
        if ($('input.datepicker[name^="start_"]').val() && $(t).is('[name^="end_"]')) {
            $(t).datepicker("option", "minDate", $('input.datepicker[name^="start_"]').datepicker("getDate") || 0)
        }
    });
    $("body").on("click", "input.datepicker, input.new_datepicker, duplicate-specific-dates input.datepicker", function () {
        if (!$(this).hasClass("hasDatepicker")) {
            PAMH.datePickerCustomOptions = {
                showOn: "focus"
            };
            if ($(this).hasClass("noMinDate") || $(this).attr("id") == "id_new_end_date_0" || $(this).attr("id") == "id_new_start_date_0") {
                $.extend(PAMH.datePickerOptions, PAMH.datePickerMinDateOptions, PAMH.datePickerCustomOptions)
            } else {
                $.extend(PAMH.datePickerOptions, PAMH.datePickerCustomOptions)
            }
            $(this).attr("autocomplete", "off").datepicker(PAMH.datePickerOptions).focus()
        }
    })
});

require('./extensions/credit_card_fields.js');

$(function () {
    if ($("input.cardnum")) {
        $("input.cardnum").creditCardFields()
    }
});
if (PAMH.MapsAvailable) {
    PAMH.mapUtils.getDefaultCenter = function () {
        var e = [PAMH.CountryCoords.__default__.lat, PAMH.CountryCoords.__default__.lng];
        var t = PAMH.ListingCountry ? PAMH.ListingCountry : $.cookie("locale");
        if (PAMH.CountryCoords[t]) {
            e = [PAMH.CountryCoords[t].lat, PAMH.CountryCoords[t].lng]
        }
        return e
    };
    PAMH.mapUtils.largeColouredMarkerIcon = function (e) {
        var t = 0;
        switch (e) {
        case "green":
            t = 0;
            break;
        case "orange":
            t = 50;
            break;
        case "red":
            t = 100;
            break;
        default:
        case "blue":
            t = 150;
            break;
        case "grey":
            t = 200;
            break
        }
        var n = new google.maps.MarkerImage("/media/img/icons/map-markers/coloured/map-marker-sprite.png", new google.maps.Size(32, 50), new google.maps.Point(t, 0), new google.maps.Point(16, 25), new google.maps.Size(232, 50));
        if (window.devicePixelRatio > 1) {
            n = new google.maps.MarkerImage("/media/img/icons/map-markers/coloured/map-marker-sprite@2x.png", new google.maps.Size(32, 50), new google.maps.Point(t, 0), new google.maps.Point(16, 25), new google.maps.Size(232, 50));
        }
        var r = new google.maps.MarkerImage("/media/img/icons/map-markers/coloured/map-marker-shadow.png", new google.maps.Point(0, 0));
        return [n, r]
    };
    PAMH.mapUtils.smallColouredMarkerIcon = function (e) {
        var t = 0;
        switch (e) {
        case "green":
            t = 0;
            break;
        case "orange":
            t = 31;
            break;
        case "red":
            t = 62;
            break;
        case "blue":
            t = 93;
            break;
        default:
        case "grey":
            t = 124;
            break
        }
        var n = new google.maps.MarkerImage("/media/img/icons/map-markers/coloured/map-marker-sprite-small.png", new google.maps.Size(21, 32), new google.maps.Point(t, 0), new google.maps.Point(11, 16), new google.maps.Size(146, 32));
        if (window.devicePixelRatio > 1) {
            n = new google.maps.MarkerImage("/media/img/icons/map-markers/coloured/map-marker-sprite-small@2x.png", new google.maps.Size(21, 32), new google.maps.Point(t, 0), new google.maps.Point(11, 16), new google.maps.Size(146, 32));
        }
        return [n, null]
    };
    PAMH.mapUtils.colourMapping = {
        __default__: "/media/img/icons/amenity-markers/general.png",
        "transport:nationalrail": "/media/img/icons/amenity-markers/natrail.png",
        "transport:lul": "/media/img/icons/amenity-markers/lul.png",
        "transport:overground": "/media/img/icons/amenity-markers/overground.png",
        "transport:dlr": "/media/img/icons/amenity-markers/dlr.png",
        "transport:airport": "/media/img/icons/amenity-markers/airport.png",
        transport: "/media/img/icons/amenity-markers/transport.png",
        restaurant: "/media/img/icons/amenity-markers/dining.png",
        "stadium:olympics": "/media/img/icons/amenity-markers/olympics.png",
        "stadium:football": "/media/img/icons/amenity-markers/football.png",
        "stadium:cricket": "/media/img/icons/amenity-markers/cricket.png",
        "stadium:rugbyleague": "/media/img/icons/amenity-markers/rugby.png",
        "stadium:rugbyunion": "/media/img/icons/amenity-markers/rugby.png"
    };
    PAMH.mapUtils.largeMarkerIcon = function () {
        var e = new google.maps.MarkerImage("/media/img/icons/map-markers/large/map-marker-sprite-flat.png", new google.maps.Size(26, 36), new google.maps.Point(0, 2610), new google.maps.Point(13, 35), new google.maps.Size(30, 2646));
        if (window.devicePixelRatio > 1) {
           e = new google.maps.MarkerImage("/media/img/icons/map-markers/large/map-marker-sprite-flat@2x.png", new google.maps.Size(26, 36), new google.maps.Point(0, 2610), new google.maps.Point(13, 35), new google.maps.Size(30, 2646));
        }
        var t = new google.maps.MarkerImage("/media/img/icons/map-markers/large/map-marker-shadow.png", new google.maps.Size(43, 36), new google.maps.Point(0, 0));
        return [e, t]
    };
    PAMH.mapUtils.smallMarkerIcon = function () {
        var e = new google.maps.MarkerImage("/media/img/icons/map-markers/small/map-marker-flat.png", new google.maps.Size(17, 22), new google.maps.Point(0, 0), new google.maps.Point(8, 22));
        if (window.devicePixelRatio > 1) {
            e = new google.maps.MarkerImage("/media/img/icons/map-markers/small/map-marker-flat@2x.png", new google.maps.Size(17, 22), new google.maps.Point(0, 0), new google.maps.Point(8, 22), new google.maps.Size(17, 22));
        }
        var t = new google.maps.MarkerImage("/media/img/icons/map-markers/small/map-marker-shadow.png", new google.maps.Size(27, 24), new google.maps.Point(0, 0));
        return [e, t]
    };
    PAMH.mapUtils.currentLocationMarkerIcon = function () {
        if (PAMH.CenterMarkerIcon) {
            return PAMH.CenterMarkerIcon
        }
        var e = new google.maps.MarkerImage("/media/img/icons/map-markers/current-location.png", new google.maps.Size(22, 32), new google.maps.Point(0, 0), new google.maps.Point(0, 32));
        return [e, null]
    };
    PAMH.mapUtils.amenityMarkerIcon = function (e) {
        var t = new google.maps.MarkerImage(e, new google.maps.Size(21, 26), new google.maps.Point(0, 0), new google.maps.Point(10, 22), new google.maps.Size(21, 26));
        return [t, null]
    };

    PAMH.mapUtils.amenityMarkerUrls = {
        __default__: "/media/img/icons/amenity-markers/general.png",
        "transport:nationalrail": "/media/img/icons/amenity-markers/natrail.png",
        "transport:lul": "/media/img/icons/amenity-markers/lul.png",
        "transport:overground": "/media/img/icons/amenity-markers/overground.png",
        "transport:dlr": "/media/img/icons/amenity-markers/dlr.png",
        "transport:airport": "/media/img/icons/amenity-markers/airport.png",
        transport: "/media/img/icons/amenity-markers/transport.png",
        restaurant: "/media/img/icons/amenity-markers/dining.png",
        "stadium:olympics": "/media/img/icons/amenity-markers/olympics.png",
        "stadium:football": "/media/img/icons/amenity-markers/football.png",
        "stadium:cricket": "/media/img/icons/amenity-markers/cricket.png",
        "stadium:rugbyleague": "/media/img/icons/amenity-markers/rugby.png",
        "stadium:rugbyunion": "/media/img/icons/amenity-markers/rugby.png"
    };

    if (window.devicePixelRatio > 1) {
        PAMH.mapUtils.amenityMarkerUrls = {
            __default__: "/media/img/icons/amenity-markers/general@2x.png",
            "transport:nationalrail": "/media/img/icons/amenity-markers/natrail@2x.png",
            "transport:lul": "/media/img/icons/amenity-markers/lul@2x.png",
            "transport:overground": "/media/img/icons/amenity-markers/overground@2x.png",
            "transport:dlr": "/media/img/icons/amenity-markers/dlr@2x.png",
            "transport:airport": "/media/img/icons/amenity-markers/airport@2x.png",
            transport: "/media/img/icons/amenity-markers/transport@2x.png",
            restaurant: "/media/img/icons/amenity-markers/dining@2x.png",
            "stadium:olympics": "/media/img/icons/amenity-markers/olympics.png",
            "stadium:football": "/media/img/icons/amenity-markers/football@2x.png",
            "stadium:cricket": "/media/img/icons/amenity-markers/cricket@2x.png",
            "stadium:rugbyleague": "/media/img/icons/amenity-markers/rugby@2x.png",
            "stadium:rugbyunion": "/media/img/icons/amenity-markers/rugby@2x.png"
        };
    }
    PAMH.mapUtils.markerForAmenity = function (e, t) {
        var n = e + ":" + t;
        var r = e;
        var i;
        if (PAMH.mapUtils.amenityMarkerUrls[n] != undefined) {
            i = PAMH.mapUtils.amenityMarkerUrls[n]
        } else {
            if (PAMH.mapUtils.amenityMarkerUrls[r] != undefined) {
                i = PAMH.mapUtils.amenityMarkerUrls[r]
            } else {
                i = PAMH.mapUtils.amenityMarkerUrls.__default__
            }
        }
        return PAMH.mapUtils.amenityMarkerIcon(i)
    };
    PAMH.mapUtils.indexedMarkerIcon = function (e, t) {
        var n = PAMH.mapUtils.largeMarkerIcon();

        /**
         * We need to remove 1 since the listing ids were indexed from 1, and
         * the sprites are indexed from 0
         */
        var r = 90 * (e-1);

        if (!t) {
          r = r + 270;
        }

        n[0] = new google.maps.MarkerImage("/media/img/icons/map-markers/large/map-marker-sprite-flat.png", new google.maps.Size(320, 40), new google.maps.Point(0, r), new google.maps.Point(13, 35), new google.maps.Size(30, 2646));
        if (window.devicePixelRatio > 1) {
            n[0] = new google.maps.MarkerImage("/media/img/icons/map-markers/large/map-marker-sprite-flat@2x.png", new google.maps.Size(320, 40), new google.maps.Point(0, r), new google.maps.Point(13, 35), new google.maps.Size(30, 2646));
        }
        return n
    }
}
if (PAMH.MapsAvailable) {
    (function (e) {
        e.newMap = function (t, n) {
            var r = {
                markerClickAction: "modal",
                defaultCenter: PAMH.mapUtils.getDefaultCenter(),
                defaultIconFactory: PAMH.mapUtils.largeMarkerIcon,
                defaultZoom: 15,
                defaultTypeId: google.maps.MapTypeId.ROADMAP,
                showMarkerAtCenter: false,
                pillButtons: false,
                constructorOptions: {
                    styles: [{
                        featureType: "poi",
                                stylers: [
                                  { visibility: "off" }
                                ]
                        }
                    ],
                    disableDefaultUI: true,
                    scaleControl: false,
                    clickableIcons: false,
                    scrollwheel: false,
                    panControl: false,
                    zoomControl: true,
                    mapTypeControl: false,
                    streetViewControl: false,
                    overviewMapControl: false,
                    zoomControlOptions: {
                        style: google.maps.ZoomControlStyle.SMALL
                    }
                },
                requestParams: {}
            };
            var i = this;
            i.settings = e.extend({}, r, n);
            i.init = function () {
                i.infowindow;
                i.loadedListings = [];
                i.loadedListingsContent = [];
                i.additions = [];
                i.markers = [];
                i.loadedListingMarkers = [];
                i.amenityMarkers = [];
                i.infoWindowVisible = false;
                i.canvas = e('<div class="map-canvas" />');
                i.canvas.prependTo(t);
                i.center = new google.maps.LatLng(i.settings.defaultCenter[0], i.settings.defaultCenter[1]);
                i.locationCenter = i.center;
                i.mapOptions = {
                    mapTypeId: i.settings.defaultTypeId,
                    zoom: i.settings.defaultZoom,
                    center: i.center
                };
                if (PAMH.ListingId) {
                    i.nearbyListener = null;
                    i.loadedListings.push(PAMH.ListingId)
                }
            }, i.draw = function () {
                i.map = new google.maps.Map(i.canvas.get(0), e.extend(i.mapOptions, i.settings.constructorOptions));
                if (i.settings.showMarkerAtCenter) {
                    i.addMarker(i.center)
                }
                if (i.settings.browsableMap) {
                    google.maps.event.addListener(i.map, "idle", i.loadListings);
                    google.maps.event.addListener(i.map, "resize", i.loadListings)
                }
                if (i.settings.extraMarkers) {
                    google.maps.event.addListener(i.map, "tilesloaded", i.loadListings)
                }
                i.cc_bounds = new google.maps.LatLngBounds(new google.maps.LatLng(51.45, -.163), new google.maps.LatLng(51.54, -.07));
            }, i.destroy = function () {
                i.additions.each(function (e, t) {
                    t.destroy()
                });
                i.canvas.remove()
            }, i.loadListings = function () {
                i.bounds = i.map.getBounds();
                var t = i.bounds.getSouthWest();
                var n = i.bounds.getNorthEast();
                i.pendingRequest = e.ajax({
                    type: "GET",
                    url: "/search/bounding-box/",
                    dataType: "json",
                    data: e.merge({
                        nw_lat: n.lat(),
                        nw_lng: t.lng(),
                        se_lat: t.lat(),
                        se_lng: n.lng(),
                        start_date: $("#id_start_date").val(),
                        end_date: $("#id_end_date").val(),
                        start_time: $("#id_start_time").val(),
                        end_time: $("#id_end_time").val()
                    }, i.settings.requestParams),
                    success: i.renderMarkers
                })
            }, i.showNearbyListings = function () {
                i.markers = i.loadedListingMarkers || [];
                i.nearbyListener = google.maps.event.addListener(i.map, "idle", i.loadListings);
                e.each(i.markers, function (e, t) {
                    t.setVisible(true)
                });
                i.loadListings()
            }, i.hideNearbyListings = function () {
                if (i.pendingRequest) {
                    i.pendingRequest.abort();
                    i.pendingRequest = null
                }
                if (i.nearbyListener) {
                    google.maps.event.removeListener(i.nearbyListener);
                    i.nearbyListener = false;
                    e.each(i.loadedListingMarkers || [], function (e, t) {
                        t.setVisible(false)
                    })
                }
            }, i.addMarker = function (t, n, r) {
                n = n ? n : i.settings.defaultIconFactory();
                r = r ? r : {};
                e.extend(r, {
                    icon: n[0],
                    shadow: n[1],
                    position: t,
                    map: i.map
                });
                var s = new google.maps.Marker(r);
                i.markers.push(s);
                return s
            }, i.showCallout = function (t, n, r) {
                e("#pamh_modal").modal({
                    remote: n
                }).on("shown", function () {})
            }, i.showInfoWindow = function (e, t, n) {
                if (i.infowindow){
                    i.infowindow.close();
                }

                var window_content = '<div class="infowindow"><div class="info-bubble"><h4 class="title"><a href="'+t.url+'" target="_blank">'+t.title+'</a></h4>';

                if (t.reviews > 0){
                    window_content += '<span class="stars rating-meter"><span class="stars_empty"></span><span class="stars_full" style="width: '+ (t.rating*20) +' %" title="'+t.rating+' out of 5 stars"></span></span> based on '+t.reviews+' review(s)';
                }

                window_content += '<p class="price">'+t.price+'</p></div></div>';

                i.infowindow = new google.maps.InfoWindow({
                    content: window_content,
                    maxWidth: 300,
                    maxHeight: 200
                });
                i.infowindow.open(i.map, e)
            }, i.setType = function (e) {
                i.map.setMapTypeId(e)
            }, i.zoomTo = function (e, t) {
                i.map.setCenter(e);
                if (t) {
                    i.map.setZoom(t)
                }
            }, i.zoomToBounds = function (e) {
                i.map.fitBounds(e);
                i.map.setCenter(i.locationCenter)
            }, i.decodeGeoJsonPolygon = function (e, t) {
                var n = e.coordinates.map(function (e) {
                    return e.map(function (e) {
                        return new google.maps.LatLng(e[0], e[1])
                    })
                });
                i.map.addOverlay(polygon);
                return polygon
            }, i.renderMarkers = function (t) {
                i.pendingRequest = null;
                e.each(t.extra, function (t, n) {
                    if (e.inArray(n.id, i.loadedListings) == -1) {
                        var r = new google.maps.LatLng(n.lat, n.lng);
                        var s = i.addMarker(r, i.settings.ajaxLoadedMarkerFactory(), {
                            zIndex: 1,
                            title: n.price
                        });

                        var o = i.loadedListingsContent.length;
                        google.maps.event.addListener(s, "click", function () {
                            if (i.settings.markerClickAction == "infowindow"){
                                i.showInfoWindow(s, n);
                            } else {
                                i.showCallout(o, n.callout_url);
                            }

                            eventTracking.trackMapPinClickEvent({
                              listing: {
                                lat: parseFloat(n.lat),
                                lng: parseFloat(n.lng)
                              },
                              isSmall: true
                            });
                        });

                        if ((i.loadedListings.length == 0) && (i.settings.markerClickAction == "infowindow")){
                            google.maps.event.trigger(s, 'click');
                        }

                        i.loadedListingMarkers.push(s);
                        i.loadedListings.push(n.id);
                    }
                })
            }, i.addBounds = function (e) {
                var t = new google.maps.Polygon({
                    clickable: false,
                    fillColor: "#004de8",
                    fillOpacity: .075,
                    geodesic: true,
                    map: i.map,
                    paths: e,
                    strokeColor: "#004de8",
                    strokeWeight: 1,
                    strokeOpacity: .3
                });
                return t
            }, i.addAmenityMarker = function (t, n, r, s, o) {
                if (e("#" + t).data("active")) {
                    return e("#" + t).data("active")
                } else {
                    var u = PAMH.mapUtils.markerForAmenity(r, s);
                    var f = i.addMarker(n, u, o);
                    e("#" + t).data("active", f);
                    return f
                }
            };
            i.init();
            i.draw();
            return i
        };
        e.fn.newMap = function (t) {
            return new e.newMap(this, t)
        }
    })(jQuery);
    (function (e) {
        e.smallMap = function (t, n) {
            var r = {
                showMarkerAtCenter: true
            };
            var i = this;
            i.settings = e.extend({}, r, n);
            i = e(t).newMap(i.settings);
            return i
        };
        e.fn.smallMap = function (t) {
            return new e.smallMap(this, t)
        }
    })(jQuery)
}
if (PAMH.MapsAvailable) {
    (function (e) {
        e.locationSuggester = function (t, n) {
            if (!n.query) {
                return
            }
            var r = {
                targetCountry: e.cookie("locale") ? e.cookie("locale") : PAMH.localCountry,
                query: "london"
            };
            var i = new google.maps.Geocoder;
            var s = this;
            s.settings = e.extend({}, r, n);
            s.container = t;
            s.init = function () {
                i.geocode({
                    address: s.settings.query + ", " + s.settings.targetCountry,
                    region: s.settings.targetCountry
                }, s.displayResults)
            }, s.draw = function () {
                s.holderLabel = e("<h4 />", {
                    text: "Did you mean?",
                    "class": "alert-heading"
                });
                s.holderList = e("<ol />")
            }, s.displayResults = function (t, n) {
                if (n != google.maps.GeocoderStatus.OK) {} else {
                    s.draw();
                    var r = 0;
                    e.each(t, function (e) {
                        if (Math.round(Math.abs(t[e].geometry.location.lat()) * 10) / 10 != Math.round(Math.abs(PAMH.SearchInfo.locationCenter[0]) * 10) / 10 && Math.round(Math.abs(t[e].geometry.location.lng()) * 10) / 10 != Math.round(Math.abs(PAMH.SearchInfo.locationCenter[1]) * 10) / 10) {
                            var n = "/search/?q=" + t[e].formatted_address + "&location_name=" + t[e].formatted_address + "&coords=" + t[e].geometry.location.lat() + "," + t[e].geometry.location.lng() + "&source=location-suggest&ac_reference=null";
                            var i = '<li><a href="' + encodeURI(n) + '">' + t[e].formatted_address + "</a></li>";
                            s.holderList.append(i);
                            r++
                        }
                    })
                } if (r > 0) {
                    s.container.attr("class", "location-suggestion clearfix");
                    s.container.append(s.holderLabel, s.holderList);
                    s.container.wrapInner(e("<div />", {
                        "class": "alert alert-info"
                    }))
                }
                if (r > 2) {
                    var i = e("#location-suggestion ul li:gt(1)");
                    i.hide();
                    e("<a />", {
                        text: "Show all " + r + " suggested locations",
                        href: "#"
                    }).click(function (t) {
                        t.preventDefault();
                        i.slideDown();
                        e(this).remove()
                    }).insertAfter(e("#location-suggestion ul"))
                }
            };
            s.init();
            return s
        };
        e.fn.locationSuggester = function (t) {
            return new e.locationSuggester(this, t)
        }
    })(jQuery)
}
if (PAMH.MapsAvailable) {
    (function (e) {
        e.mapField = function (t, n) {
            var r = {
                markerClickAction: "infowindow",
                defaultCenter: [PAMH.ListingCoords[0], PAMH.ListingCoords[1]],
                defaultIconFactory: PAMH.mapUtils.largeMarkerIcon,
                defaultZoom: 5,
                defaultTypeId: google.maps.MapTypeId.ROADMAP,
                addressFieldCandidates: ["house_no", "address1", "address2", "address3", "city", "state", "postal_code", "country"],
                mandatoryFields: ["address1", "city", "country"],
                constructorOptions: {
                    disableDefaultUI: true,
                    clickableIcons: false,
                    scaleControl: false,
                    scrollwheel: false,
                    panControl: false,
                    zoomControl: true,
                    mapTypeControl: false,
                    streetViewControl: false,
                    overviewMapControl: false,
                    zoomControlOptions: {
                        style: google.maps.ZoomControlStyle.SMALL
                    }
                },
                showMap: true,
                showPanorama: true,
                panoramaOptions: {
                    addressControl: false,
                    linksControl: true,
                    pov: {
                        heading: 0,
                        pitch: 0,
                        zoom: 0
                    }
                }
            };
            var i = this;
            var s;
            var o = null;
            i.streetViewLoaded = false;
            i.settings = e.extend({}, r, n);
            i.init = function () {
                i.inputField = t;
                i.panorama = {};
                i.streetview = {};
                var n = i.inputField.val();
                i.markerPositionedManually = false;
                i.markers = [];
                s = new google.maps.Geocoder;
                try {
                    if (!n) {
                        throw true
                    }
                    n = n.split(",", 2);
                    if (n.length != 2) {
                        throw true
                    }
                    n = [parseFloat(e.trim(n[0])), parseFloat(e.trim(n[1]))];
                    if (isNaN(n[0]) || isNaN(n[1])) {
                        throw true
                    }
                    if (n != r.defaultCenter) {
                        i.settings.defaultZoom = 15
                    }
                } catch (o) {
                    n = r.defaultCenter
                }
                i.center = new google.maps.LatLng(n[0], n[1]);
                var u = i.inputField.parents("form");
                var l = [];
                e.each(r.addressFieldCandidates, function (t, n) {
                    l = e.merge(l, u.find("input[name=" + n + "], select[name=" + n + "]"))
                });
                i.addressFields = l;
                l = [];
                e.each(i.settings.mandatoryFields, function (t, n) {
                    l = e.merge(l, u.find("input[name=" + n + "], select[name=" + n + "]"))
                });
                i.mandatoryFields = l;
                e("#id_streetview_active").click(function () {
                    return i.checkPanorama()
                })
            }, i.draw = function () {
                e.each(i.addressFields, function (t, n) {
                    e(n).blur(i.addressUpdateHandler)
                });
                if (i.settings.showMap) {
                    i.canvas = e('<div class="map-holder" style="height:200px;" />');
                    i.canvas.prependTo(i.inputField.parent());
                    i.inputField.hide();
                    i.mapOptions = {
                        mapTypeId: i.settings.defaultTypeId,
                        zoom: i.settings.defaultZoom,
                        center: i.center
                    };
                    i.map = new google.maps.Map(i.canvas.get(0), e.extend(i.mapOptions, i.settings.constructorOptions));
                    i.centerMarker = i.addMarker(i.center, undefined, {
                        draggable: true
                    });
                    google.maps.event.addListener(i.centerMarker, "dragend", function (e) {
                        i.markerPositionedManually = true;
                        i.updateInput(e.latLng)
                    });
                    google.maps.event.addListener(i.map, "dblclick", i.mapDoubleClickHandler);
                    i.updateInput(i.center);
                    i.addUpdateButton()
                }
                if (i.settings.showPanorama) {
                    i.drawPanorama()
                }
            }, i.addUpdateButton = function () {
                var t = e("<div />", {
                    "class": "control-button",
                    css: {
                        padding: "5px"
                    }
                });
                var n = e("<div />", {
                    "class": "control-ui",
                    title: "Update map location from your address",
                    css: {
                        textAlign: "center",
                        cursor: "pointer",
                        borderWidth: "2px",
                        borderStyle: "solid",
                        backgroundColor: "#FFF"
                    }
                }).appendTo(t);
                var r = e("<div />", {
                    "class": "control-text",
                    text: "Update Location",
                    css: {
                        fontFamily: "Arial, sans-serif",
                        fontSize: "12px",
                        padding: "0 4px"
                    }
                }).appendTo(n);
                google.maps.event.addDomListener(n.get(0), "click", function () {
                    i.addressUpdateHandler(true)
                });
                t.index = 1;
                i.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(t.get(0))
            }, i.drawPanorama = function () {
                i.panorama.inputField = e("#id_streetview_data").hide();
                if (e("#id_streetview_data").val()) {
                    var t = e.parseJSON(e("#id_streetview_data").val());
                    i.settings.panoramaOptions.position = new google.maps.LatLng(parseFloat(t.lat), parseFloat(t.lng)), i.settings.panoramaOptions.pov = {
                        heading: parseFloat(t.heading),
                        pitch: parseFloat(t.pitch),
                        zoom: parseInt(t.zoom)
                    }
                } else {
                    if (i.settings.showMap) {
                        i.settings.panoramaOptions.position = i.centerMarker.getPosition()
                    } else {
                        i.settings.panoramaOptions.position = new google.maps.LatLng(PAMH.ListingCoords[0], PAMH.ListingCoords[1])
                    }
                }
                i.panorama.inputField.closest("li").hide();
                i.panorama.holder = e('<div class="streetview-holder" />').css("margin-top", "0").insertAfter(i.panorama.inputField);
                i.panorama.canvas = e('<div class="streetview-canvas" />').appendTo(i.panorama.holder);
                if (e("#id_streetview_active").prop("checked")) {
                    i.checkPanorama()
                } else {
                    e("#id_streetview_data").closest(".control-group").hide()
                }
            }, i.checkPanorama = function () {
                if (!e("#id_streetview_active").prop("checked")) {
                    i.panorama.inputField.closest(".control-group").hide()
                } else {
                    i.panorama.inputField.closest(".control-group").show();
                    if (!i.streetViewLoaded) {
                        if (!o) {
                            o = new google.maps.StreetViewService
                        }
                        o.getPanoramaByLocation(i.settings.panoramaOptions.position, 50, i.executePanorama);
                        i.streetViewLoaded = true
                    }
                }
            }, i.executePanorama = function (t, n) {
                if (n != google.maps.StreetViewStatus.OK) {
                    alert("Sorry, but Streetview is not available at the location shown above.");
                    e("#id_streetview_active").prop("checked", false);
                    i.panorama.inputField.closest(".control-group").hide();
                    i.streetViewLoaded = false;
                    return false
                } else {
                    if (!i.panorama.inputField.closest(".control-group").is(":visible")) {
                        i.panorama.inputField.closest(".control-group").show()
                    }
                    var r = i.settings.panoramaOptions;
                    r.pano = t.location.pano;
                    i.streetview = new google.maps.StreetViewPanorama(i.panorama.canvas.get(0), r);
                    i.streetview.setVisible(true);
                    google.maps.event.addListener(i.streetview, "position_changed", function () {
                        i.settings.panoramaOptions.position = i.streetview.getPosition();
                        i.updateStreetviewInput()
                    });
                    google.maps.event.addListener(i.streetview, "pov_changed", function () {
                        i.settings.panoramaOptions.pov = i.streetview.getPov();
                        i.updateStreetviewInput()
                    });
                    if (i.settings.showMap) {
                        i.inputField.bind("marker_position_change", function () {
                            i.settings.panoramaOptions.position = i.centerMarker.getPosition();
                            i.streetview.setPosition(i.centerMarker.getPosition())
                        })
                    }
                    i.updateStreetviewInput();
                    return true
                }
            }, i.updateStreetviewInput = function () {
                i.panorama.inputField.val('{"lat": ' + i.settings.panoramaOptions.position.lat() + ', "heading": ' + i.settings.panoramaOptions.pov.heading + ', "zoom": ' + i.settings.panoramaOptions.pov.zoom + ', "lng": ' + i.settings.panoramaOptions.position.lng() + ', "pitch": ' + i.settings.panoramaOptions.pov.pitch + "}")
            }, i.addMarker = function (t, n, r) {
                n = n ? n : i.settings.defaultIconFactory();
                r = r ? r : {};
                e.extend(r, {
                    icon: n[0],
                    shadow: n[1],
                    position: t,
                    map: i.map
                });
                var s = new google.maps.Marker(r);
                i.markers.push(s);
                return s
            }, i.updateInput = function (e) {
                coords = [e.lat(), e.lng()];
                i.inputField.val(coords.join(","));
                if (i.settings.showPanorama) {
                    i.inputField.trigger("marker_position_change");
                    i.settings.panoramaOptions.position = e
                }
                if (i.inputField.val()) {
                    i.inputField.trigger("change")
                }
            }, i.mapDoubleClickHandler = function (e) {
                i.centerMarker.setPosition(e.latLng);
                i.updateInput(e.latLng)
            }, i.addressUpdateHandler = function (t) {
                if (i.markerPositionedManually && !t) {
                    return
                }

                var n = [];
                var r = [];
                e.each(i.addressFields, function (t, s) {
                    if (e(s).get(0).tagName == "select") {
                        var o = e(s).children("option[selected]").html()
                    } else {
                        var o = e(s).val()
                    } if (o) {
                        n.push(o);
                        if (e.inArray(s, i.mandatoryFields) != -1) {
                            r.push(o)
                        }
                    }
                });
                n = n.join(", ");
                if (!i.geocoding && (n != i.previousAddress || t)) {
                    i.geocoding = true;
                    i.previousAddress = n;
                    i.canvas.showLoading();
                    s.geocode({
                        address: n
                    }, function (e, t) {
                        if (t == google.maps.GeocoderStatus.OK) {
                            var n = e[0].geometry.location;
                            i.map.setCenter(n);
                            i.centerMarker.setPosition(n);
                            i.map.setZoom(15);
                            i.updateInput(n)
                        }
                        i.geocoding = false;
                        i.checkPanorama();
                        i.canvas.hideLoading()
                    })
                }
            };
            i.init();
            i.draw();
            return i
        };
        e.fn.mapField = function (t) {
            return new e.mapField(this, t)
        }
    })(jQuery)
}

require('./extensions/rating_input.js');

$(function () {
    $("input.rating-meter").each(function (e, t) {
        $(t).ratingInput()
    });
    $(".rating-bars").mouseleave(function () {
        $(this).children("li").css("opacity", 1)
    });
    $(".rating-bars li").mouseenter(function () {
        $(this).css("opacity", 1);
        $(this).siblings("li").css("opacity", .4)
    })
});
if (PAMH.MapsAvailable) {
    (function (e) {
        e.listingMap = function (t, n) {
            var r = {
                defaultIconFactory: PAMH.mapUtils.largeMarkerIcon,
                browsableMap: true,
                ajaxLoadedMarkerFactory: PAMH.mapUtils.smallMarkerIcon,
                requestParams: {}
            };
            var i = this;
            i.settings = e.extend({}, r, n);
            i = e(t).newMap(i.settings);
            return i
        };
        e.fn.listingMap = function (t) {
            return new e.listingMap(this, t)
        }
    })(jQuery)
}
$(function () {
    $("table.linked tr:not(.unclickable) td:not(.unclickable)").each(function (e, t) {
        $(t).click(function (e) {
            $link = $(this).parent("tr").find("td a").eq(0);
            if (!$link.length) {
                return false;
            }
            if ($link.attr("rel") == "overlay") {
                $("#pamh_modal").modal({
                    remote: $link.attr("href")
                }).on("shown", function () {
                    if ($link.attr("data-action") == "leave-feedback") {
                        $(".modal input.rating-meter").each(function (e, t) {
                            $(t).ratingInput();
                        })
                    }
                })
            } else {
                window.location.href = $link.attr("href")
            }
        }).addClass("clickable");
    })
});

$(function () {
    $('a[href*="#"][href!="#"]').not(".nav-tabs a, table.ui-datepicker-calendar a, .carousel a").click(function (e) {
        if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
            e.preventDefault();
            var t;
            if (this.hash.indexOf('/') !== -1) {
              t = $('a[name="'+this.hash.slice(1)+'"]');
            } else {
              t = $(this.hash);
              t = t.length && t || $("[id=" + this.hash.slice(1) + "]");
            }

            if (t.length) {
                var n = t.offset().top - 40;
                $("html,body").animate({
                    scrollTop: n
                }, 1e3);
                return false
            }
        }
    })
});
if ($(".availability-calendar").length) {
    $(document).ready(function () {
        PAMH.datePickerCustomOptions = {
            showOtherMonths: false,
            selectOtherMonths: false
        }
    })
}

require('./extensions/availability_calendar.js')(jQuery, PAMH);

if (PAMH.MapsAvailable) {
    (function (e) {
        e.streetView = function (t, n, r, i) {
            var s = this;
            s.streetViewData = {};
            s.streetViewData.container = t;
            s.streetViewData.location = n;
            s.init = function () {
                s.streetViewData.root = e("<div />", {
                    "class": "streetview-canvas"
                });
                s.streetViewData.container.prepend(s.streetViewData.root);
                var t = {
                    addressControl: false,
                    linksControl: false,
                    panControl: false,
                    scrollwheel: false,
                    position: s.streetViewData.location,
                    pov: r ? r : null
                };
                s.streetViewData.pano = new google.maps.StreetViewPanorama(s.streetViewData.root.get(0), t)
            };
            s.init();
            return s
        };
        e.fn.streetView = function (t, n, r) {
            return new e.streetView(this, t, n, r)
        }
    })(jQuery)
}
$(function () {
    $("#choose-country").click(function (e) {
        e.preventDefault();
        $("#pamh_modal").modal({
            remote: $("body").hasClass("home") ? "#country-inline" : $(this).attr("href")
        })
    })
});
$(function () {
    $("#logout_link").click(function (e) {
        e.preventDefault();
        $this = $(this);
        $.post($this.attr("href"), "json").always(function () {
            window.location.href = $this.data("postLogoutUrl");
        });
    })
});
$(function () {
    $("button[rel=print]").click(function (e) {
        e.preventDefault();
        window.print()
    })
});
$(function () {
    if ($("form div.error")) {
        $("form div.error:eq(0) input").focus()
    }
});
$(function () {
    $("#toggle-price").change(function () {
        $currency = $(this).val();
        $("span[data-price-" + $currency + "]").each(function (e, t) {
            var n = $(this);
            n.text(n.attr("data-price-" + $currency))
        })
    })
});
$(document).ready(function () {
    $(".profile-image input[name=photo]").change(function () {
        $(this).closest("form").submit();
        $(this).parent().showLoading()
    });
    $(".profile-image button.file-handler").click(function (e) {
        e.preventDefault();
        $(this).next("input[name=photo]").trigger("click")
    })
});
$(function () {
    $(".toggle-element").click(function (e) {
        e.preventDefault();
        $this = $(this);
        $element = $($this.attr("data-show"));
        $element.slideToggle("fast", function () {
            if ($(this).is(":visible")) {
                $this.children("i").attr("class", "icon-chevron-up")
            } else {
                $this.children("i").attr("class", "icon-chevron-down")
            }
        })
    })
});
$(document).ready(function () {
    $('button[data-option="delete-item"]').live("click", function (e) {
        e.preventDefault();
        $this = $(this);
        if (!confirm("Are you sure you want to remove this " + $this.attr("data-type") + "?")) {
            return false
        }
        $.ajax({
            url: $this.attr("data-url"),
            dataType: "json",
            type: "POST",
            headers: {
                "X-OVERLAY": "1"
            }
        }).done(function () {
            var e = $this.closest("table");
            $this.closest("tr").remove();
            if (!e.find("tr").length) {
                e.addClass("hidden");
                $("#item-container div.alert").slideDown()
            }
        }).fail(function (data) {
            jsonResponse = JSON.parse(data.responseText)
            if (jsonResponse.hasOwnProperty('errors')) {
                console.log(jsonResponse["errors"]);
                alert(jsonResponse["errors"])
            } else {
                alert(["We seem to be having a problem removing this ", $this.attr("data-type"), ".\n", "Please try again later."].join(""))
            }
        })
    })
});
$(function () {
    $("select.change-country").change(function () {
        var e = $(this).val();
        var t = PAMH.Currencies.__default__;
        if (PAMH.Currencies[e]) {
            t = PAMH.Currencies[e]
        }
        $("[data-type='currency-symbol']").text(t.symbol);
        $("input[data-prepended]").attr("data-prepended", t.symbol);
        PAMH.ListingCurrency = t.symbol
    }).change()
});
$(function () {
    if ($("ul.detailed-ratings").length) {
        $(".average-rating").each(function (e) {
            $this = $(this);
            if ($this.siblings("ul.detailed-ratings").length) {
                $this.popover({
                    title: "Detailed ratings",
                    content: function () {
                        return $this.siblings("ul.detailed-ratings").outerHTML()
                    }
                })
            }
        })
    }
});
$(function () {});
$(document).ready(function () {
    $(".post-request").click(function () {
        var e = document.createElement("form");
        e.setAttribute("method", "post");
        e.setAttribute("action", $(this).attr("href"));
        e.style.display = "hidden";
        document.body.appendChild(e);
        e.submit()
    })
});

$(window).load(function () {
  var $addressLookup = $('#btn-lookup-address');

  if ($addressLookup.length) {
    var $form     = $addressLookup.closest('form');
    var $postcode = $('.js-input-postcode');

    // When the post code address field has focus we rebind the
    // function of the ENTER key to initiate the address lookup as
    // opposed to submitting the form. This should reduce the number
    // of occurrences of incomplete addresses.
    $postcode.keypress(function (event) {
      if (event.which == 13) {
        event.preventDefault();
        $addressLookup.trigger('click');
        return false;
      }
    });
  }

  $("body").on("change", "#id_country", function () {
    if ($("#id_address_lookup_container").length) {
      if ($(this).val() === "GB") {
        $("#address-display").hide();
        $("#btn-lookup-address").show();
        $("#id_postal_code").closest(".input-appended").attr("class", "input-append");
      } else {
        $("#address-display").show();
        $("#btn-lookup-address").hide();
        $("#id_postal_code").closest(".input-append").attr("class", "input-appended");
      }
    }
  });

  if ($("#id_city").val() === "") {
    $("#id_country").change();
  }
});

$(function () {
    if ($(document.body).hasClass("listing-form")) {
        PAMH.ListingForm = {};
        $("#id_title").on("change", function () {
            if (!PAMH.ListingForm.Title) {
                PAMH.ListingForm.Title = true;
            }
        });
        $("#id_address1").on("change", function () {
            if (!PAMH.ListingForm.Address) {
                PAMH.ListingForm.Address = true;
            }
        });
        $("#pricing-section input").on("change", function () {
            if (!PAMH.ListingForm.Pricing) {
                PAMH.ListingForm.Pricing = true;
            }
        });
        $("#id_country").change(function () {
            if (PAMH.Currencies[$(this).val()]) {
                PAMH.CurrencySymbol = PAMH.Currencies[$(this).val()].symbol
            } else {
                PAMH.CurrencySymbol = PAMH.Currencies.__default__.symbol
            }
            $("span.add-on[data-type='currency-symbol']").html(PAMH.CurrencySymbol)
        }).change();


        $("#delete-attachment").click(function (e) {
            e.preventDefault();
            $this = $(this);
            if (confirm("Are you sure you want to remove this attachment from your listing?")) {
                $.ajax({
                    url: $this.attr("href"),
                    type: "DELETE",
                    dataType: "json"
                }).done(function () {
                    $this.closest(".control-group").hide();
                    $("#show-booking-attachment").show()
                }).fail(function () {
                    alert("Unable to remove the attachment. Please try again later")
                })
            }
        });
        $("#id_description").closest("form").submit(function () {
            $textarea = $(this).find("#id_description");
            if ($textarea.length && !PAMH.fraud_check) {
                if (PAMH.emailRegex.test($textarea.val()) || PAMH.websiteRegex.test($textarea.val()) || PAMH.phoneRegex.test($textarea.val())) {
                    alert("It appears as though you entered a website, phone number or email address within your parking space description. For your own security and privacy, please remove these.\n\nScams can only occur if you communicate outside of our system. Please edit your message and try again.");
                    PAMH.fraud_check = true;
                    return false
                }
            }
            return true
        });
        $("textarea").characterCounter(function () {
            return $(this).attr("maxlength") ? $(this).attr("maxlength") : 800
        });
        $("#id_location").mapField()
    }
});
$(function () {
    if ($(document.body).hasClass("category-listings")) {
        if (PAMH.MapsAvailable) {
            var e = PAMH.mapUtils.smallMarkerIcon();
            var t = new google.maps.LatLngBounds;
            var n = [];
            var r = $("#map-holder").smallMap({
                showMarkerAtCenter: false,
                defaultIconFactory: PAMH.mapUtils.smallMarkerIcon
            });
            var i = new google.maps.InfoWindow({
                maxWidth: 120
            });
            $.each($("ul.amenity-list li"), function (e, s) {
                var o = $(s).html();
                var u = $(s).attr("coords").split(",");
                var a = new google.maps.LatLng(u[0], u[1]);
                t.extend(a);
                var l = PAMH.mapUtils.markerForAmenity($(s).attr("category"), $(s).attr("subcategory"));
                var h = r.addMarker(a, l);
                n.push(h);
                google.maps.event.addListener(h, "click", function () {
                    i.setContent(o + "<p>View parking spaces for rent in and around this location.</p>");
                    i.open(r.map, h)
                })
            });
            var s = $("ul.amenity-list li").length;
            if (s > 75) {
                var o = new MarkerClusterer(r.map, n)
            }
            if (s > 0) {
                r.zoomToBounds(t)
            }
        }
    }
});
if ($("body").hasClass("listings-availability")) {
    $(document).ready(function () {
        $("#availability-changes").on("click", "a.delete", function (e) {
            e.preventDefault();
            if (!confirm("Are you sure?")) {
                return
            }
            var t = $(this).closest("tr");
            var n = t.data("explicitId");
            $.ajax({
                url: "/availability/delete/explicit/",
                type: "POST",
                dataType: "json",
                mimeType: "application/json",
                data: {
                    explicit_id: n
                },
                beforeSend: function (e) {
                    t.addClass("error")
                },
                success: function () {
                    if ($("#availability-changes table tbody tr").length == 1) {
                        $("#availability-changes table").hide()
                    }
                    t.fadeOut("fast", function () {
                        $("#status-explicit-date-add").trigger("new_explicit_date");
                        $(this).remove()
                    })
                }
            })
        });
        $("input[name^='weekdays']").change(function () {
            if (!$("input[name^='weekdays']:checked").length) {
                alert("Warning: you must deactivate your space if you no longer wish to rent it out. Removing all days by tickbox will not deactivate the space.")
            }
            var e = $(this).closest("form");
            $.ajax({
                url: "/dashboard/parking-spaces/" + PAMH.ListingId + "/availability/update-general/",
                type: "POST",
                dataType: "json",
                data: e.serialize(),
                beforeSend: function (t) {
                    e.showLoading()
                },
                success: function () {
                    $("#status-explicit-date-add").trigger("new_explicit_date");
                    setTimeout(function () {
                        e.hideLoading()
                    }, 500)
                }
            })
        });
        $("#update-general").submit(function (e) {
            return false
        });
        $("#update-explicit").submit(function (e) {
            var t = $(this);
            var n = t.serializeJSON();
            $.ajax({
                url: t.attr("action"),
                type: "POST",
                dataType: "json",
                data: t.serialize(),
                beforeSend: function (e) {
                    t.showLoading()
                },
                error: function (e) {
                    alert("Please make sure all fields are completed");
                    t.hideLoading()
                },
                success: function (e) {
                    $("#status-explicit-date-add").fadeIn();
                    t.hideLoading();
                    t.find("button[type=reset]").click();
                    $("#status-explicit-date-add").trigger("new_explicit_date");
                    if (!$("#availability-changes").is(":visible")) {
                        $("#availability-changes").slideDown()
                    }
                    if (!$("#availability-changes table").is(":visible")) {
                        $("#availability-changes table").show()
                    }
                    $("#availability-changes table tbody").prepend($("<tr />", {
                        id: "definition-" + e.availability.id,
                        "class": "success"
                    }).append("<td>" + e.availability.status + "</td><td>" + e.availability.start_date + "</td><td>" + e.availability.end_date + "</td><td>" + e.availability.change + "</td><td><strong>" + e.availability.total + ' space(s)</strong></td><td><a class="btn btn-mini btn-danger delete" href=#">Delete</a></td>'))
                }
            });
            return false
        });
        $.extend(PAMH.datePickerOptions, PAMH.datePickerCustomOptions);
        $("#large-calendar").each(function (e, t) {
            $(t).datepicker(PAMH.datePickerOptions);
            $(t).availabilityCalendar({
                cache: false
            })
        })
    })
}
$(function () {
    $("body").on("change", "#id_payment_sources", function () {
        if ($(this).val()) {
            $("#payment-source-submit").show();
            $("#update-payment-method").slideUp("slow")
        } else {
            $("#payment-source-submit").hide();
            $("#update-payment-method").fadeIn()
        }
    });
    $("#show-promo-code").click(function (e) {
        e.preventDefault();
        $("#promo-code").show();
        $(this).hide();
        analyticsTrack('click:checkout-step-2:promo-code');
        return false
    });
    $("#hide-promo-code").click(function (e) {
        e.preventDefault();
        $("#promo-code").hide();
        $("#show-promo-code").show();
        return false
    });
    $("body").on("change", "#id_infinite", function () {
        if ($("#id_infinite").is(":checked")) {
            $("#enddate-container").slideUp()
        } else {
            $("#enddate-container").slideDown()
        }
    });
    if ($("#id_infinite").is(":checked")) {
        $("#enddate-container").hide();
        $("#id_end_date").val("");
        $("#id_end_time").val("")
    } else {
        $("#enddate-container").show()
    }
    $("#different-source-link").click(function (e) {
        e.preventDefault();
        $("#payment-details").slideDown();
        $("#id_sources option:first-child").attr("selected", "selected")
    });
    $("#id_sources").change(function (e) {
        if ($(this).val() > 0) {
            $("#payment-details").slideUp()
        }
    });
    $("#update-payment-method .nav-tabs li a").click(function (e) {
        e.preventDefault();
        $("#payment_method").val($(this).attr("data-value"))
    });
    $("#update-payment-method a:eq(0)").click();
    $("body").on("submit", ".booking-message form", function () {
        $textarea = $(this).find("textarea");
        if ($textarea.length && !PAMH.fraud_check) {
            if (PAMH.emailRegex.test($textarea.val()) || PAMH.websiteRegex.test($textarea.val()) || PAMH.phoneRegex.test($textarea.val())) {
                alert("It appears as though you entered a website, phone number or email address. This information cannot be exchanged until after your enquiry has been answered.\n\nThis is to protect you from scams that can only occur if you communicate or exchange money outside of the justpark website. Please edit your message and try again.");
                PAMH.fraud_check = true;
                return false
            }
        }
        return true
    });

  PAMH.specific_dates_container = $(".duplicate-specific-dates").first().outerHTML();
  $(".duplicate-specific-dates").first().addClass("no-delete");
  PAMH.specific_date_count = $(".duplicate-specific-dates").length;

  $("body").on("click", "#add-specific-dates", function (e) {
    e.preventDefault();
    return addSpecificDate()
  });

  $("body").on("click", ".delete-specific-date", function () {
    event.preventDefault();
    $(this).closest(".duplicate-specific-dates").remove();
    $("select.specific_dates_from").eq(0).change();

    return false;
  });

  $("body").on("dateChange", "input.specific_dates_date", function () {
    $("select.specific_dates_from").eq(0).change()
  });

  // Handle the change on the multi-date booking selector by
  // repopulating the hidden specific_dates input field with the data
  // in the form.
  $("body").on("change", "select.specific_dates_from, select.specific_dates_until", function () {
    var dates = {};

    $("input.specific_dates_date").each(function (index, n) {
      var $this = $(this);
      if ($this.val()) {
        dates[index] = {};

        dates[index].date = $this.val();
        dates[index].from = $this.siblings("select.specific_dates_from").val()
          ? $this.siblings("select.specific_dates_from").val()
          : "00:00:00";

        dates[index].until = $this.siblings("select.specific_dates_until").val()
          ? $this.siblings("select.specific_dates_until").val()
          : "23:59:59";

        if ($this.data('fixture-id')) {
          dates[index].fixture_id = $this.data('fixture-id');
        }
      }
    });

    // Updates the overall state of the multi-date selector by
    // collecting all the date values currently in the component by
    // serializing the state of each input into a hidden input.
    $("#id_specific_dates").val(JSON.stringify(dates)).change();
  });

  // Initializes the specific/multi date component with the json value
  // passed by the backend. The input JSON is treated as an array of
  // {from, until} objects.
  //
  // For sports events we'll also add the fixture_id property, which
  // we'll store as a data attribute on each hidden date input.
  //
  // This enables us to pull the fixture ids from the DOM when a
  // change event is fired, so we can serialize them to the form state
  // and we ultimately have access to them once the form is submitted.
  var inputDates = jQuery.parseJSON($("#id_specific_dates").val());

  for (var index in inputDates) {
    if (index > 0) {
      addSpecificDate();
    }
    // @todo improve dom manipulation
    $("input.specific_dates_date").eq(index).val(inputDates[index].date);
    $("select.specific_dates_from").eq(index).val(inputDates[index].from);
    $("select.specific_dates_until").eq(index).val(inputDates[index].until)
    $(".duplicate-specific-dates .date").eq(index).html(inputDates[index].date);

    if (typeof inputDates[index].fixture_id !== "undefined") {
      $("input.specific_dates_date").eq(index).data('fixture-id', inputDates[index].fixture_id);
    }
  }

    if ($(".duplicate-specific-dates").length) {
        $("select.specific_dates_from").eq(0).change()
    }
    if ($("#availability-status").length) {
        $("#id_start_date, #id_end_date").on("dateChange", function () {
            $("#id_end_time").change()
        });
        $("body").on("change.PAMH", "input[name^=weekdays], #id_specific_dates, #id_infinite, #id_start_time, #id_end_time", function () {
            if ($("#id_infinite").is(":checked")) {
                $("#weekday-container").slideDown()
            } else {
                if ($("#id_start_date").val() && $("#id_end_date").val()) {
                    var e = $.datepicker.parseDate("dd M yy", $("#id_start_date").val());
                    var t = $.datepicker.parseDate("dd M yy", $("#id_end_date").val());
                    var n = Math.ceil((t.getTime() - e.getTime()) / 864e5);
                    if (n >= 7) {
                        $("#weekday-container").slideDown()
                    } else {
                        $("#weekday-container").slideUp()
                    }
                } else {
                    $("#weekday-container").slideUp()
                }
            }
            var r = $(this).closest("form");
            var i = r.serialize();
            $.ajax({
                url: "/availability/check-availability/" + $("#id_pid").val() + "/",
                type: "POST",
                dataType: "json",
                data: i,
                beforeSend: function (e) {
                    $("#availability-status").addClass("ajax-loader").html("")
                },
                success: function (e, t) {
                    if (e.availability.status == "limited") {
                        var n = $("<div />", {
                            "class": "alert alert-error",
                            text: "Sorry but there is only enough room for " + e.availability.max_availability + " vehicle(s)"
                        });
                        r.find("button[type='submit']").attr("disabled", "disabled")
                    } else {
                        if (e.availability.status == "none" || e.availability.status == "not_available") {
                            if (e.availability.message == 'OPENING_CLOSING_TIME'){
                                var status_message = "The parking space is only open between "
                                    + e.availability.opening_time
                                    + " and "
                                    + e.availability.closing_time
                                    + ". Your booking cannot start or end outside of these times.";
                            } else if (e.availability.message == 'SAME_DAY') {
                                var status_message = "Same day bookings are not allowed at this parking space. Please try an alternative space.";
                            } else if (e.availability.message == 'DELAYED_START' && e.availability.delayed_start > 0) {
                                var status_message = e.availability.delayed_start + " hours notice is required to book this parking space. Please adjust your times or try a different space.";
                            } else if (e.availability.message == 'MAX_BOOKING_LENGTH') {
                              var status_message = "This listing has a maximum booking length of "
                                                 + e.availability.max_booking_length
                                                 + " hours.";
                            } else if (e.availability.message == 'OVERNIGHT_DISABLED') {
                                var status_message = "The parking space is only open between "
                                    + e.availability.opening_time
                                    + " and "
                                    + e.availability.closing_time
                                    + ", and does not allow overnight stays. Your booking cannot start or end outside of these times.";
                            } else {
                                var status_message = "Sorry, but we're all out of room. Please adjust your dates or try booking an alternative parking space.";
                            }


                            var n = $("<div />", {
                                "class": "alert alert-error",
                                html: status_message
                            });
                            r.find("button[type='submit']").attr("disabled", "disabled")
                        } else {
                            if (e.availability.status == "none-selected") {
                                var n = $("<div />", {
                                    "class": "alert alert-error",
                                    text: "You have not selected any dates. Please select a valid parking period"
                                });
                                r.find("button[type='submit']").attr("disabled", "disabled")
                            } else {
                                var n = $("<div />", {
                                    "class": "alert alert-success",
                                    text: "This space is available for your chosen parking period"
                                });
                                if (e.pricing.infinite) {
                                    $("#amended-price").html(formatted_total(e.pricing.calculated_price, e.pricing.currency, 2, false) + " per " + e.pricing.recurring_frequency)
                                } else {
                                    if (e.pricing.recurring_frequency != "total") {
                                        $("#amended-price").html(formatted_total(e.pricing.calculated_price, e.pricing.currency, 2, false) + " per " + e.pricing.recurring_frequency + " <strong>(Total: " + formatted_total(e.pricing.total_payment.total, e.pricing.currency) + ")</strong>")
                                    } else {
                                        $("#amended-price").html(formatted_total(e.pricing.total_payment.total, e.pricing.currency))
                                    }
                                }
                                r.find("button[type='submit']").removeAttr("disabled")
                            }
                        }
                    }
                    $("#availability-status").html("");
                    $("#availability-status").prepend(n)
                },
                complete: function () {
                    $("#availability-status").removeClass("ajax-loader")
                }
            });
            return true
        });
        if ($("#large-calendar").length) {
            $.extend(PAMH.datePickerOptions, PAMH.datePickerCustomOptions);
            $("#large-calendar").datepicker(PAMH.datePickerOptions);
            $("#large-calendar").availabilityCalendar({
                startDate: $("#id_start_date").length ? $("#id_start_date").val() : null
            })
        }
    }
});

$(function () {
    if ($(document.body).hasClass("cancellations")) {
        $("#id_never_parked").click(function () {
            if ($(this).is(":checked")) {
                $("#never-parked-container").slideUp()
            } else {
                $("#never-parked-container").slideDown()
            }
        })
    }
});
$(function () {
    if ($("body").hasClass("dashboard-home")) {
        $("#dashboard-contact-details li").hover(function () {
            $(this).addClass("show-hidden")
        }, function () {
            $(this).removeClass("show-hidden")
        })
    }
});
$(function () {
  $('.google-login').click(function(e) {
    e.preventDefault();
    window.location.href = $(this).attr("data-href");
  });
});

$(function () {
    $(".link-to-us textarea.auto-select").click(function (e) {
        e.stopPropagation();
        $(this).select()
    })
});
if (PAMH.MapsAvailable) {
    var amenityMap;
    if ($("body").hasClass("listing-detail") || $("body").hasClass("booking-detail")) {
        (function (e) {
            e.listingDetailsMap = function (t, n) {
                var r = this;
                var i = {
                    defaultIconFactory: PAMH.mapUtils.largeMarkerIcon,
                    ajaxLoadedMarkerFactory: PAMH.mapUtils.smallColouredMarkerIcon,
                    showMarkerAtCenter: true,
                    defaultZoom: 15,
                    browsableMap: true,
                    requestParams: {
                        max_results: 50
                    }
                };
                r.settings = e.extend({}, i, n);
                r = e(t).smallMap(r.settings);
                return r
            };
            e.fn.listingDetailsMap = function (t) {
                return new e.listingDetailsMap(this, t)
            }
        })(jQuery);
        $(function () {
            $("#price-change a").click(function (e) {
                e.preventDefault();
                var t = $("#price-change-icon");
                var n = $(this).attr("data-vehicle");
                if (!$("#listing-price-" + n).length) {
                    alert("This type of vehicle cannot be parked at this location");
                    $(this).closest(".btn-group").removeClass("open");
                    return false
                }
                if (n == "bike") {
                    t.attr("class", "glyphicons icon-bicycle")
                } else {
                    if (n == "large-vehicle") {
                        t.attr("class", "glyphicons icon-bus")
                    } else {
                        t.attr("class", "glyphicons icon-car")
                    }
                }
                $("#id2_vehicle_type").val(n);
                $(".booking-box .listing-prices").hide();
                $("#listing-price-" + n).fadeIn("slow")
            });
            $("#load-reviews").click(function () {
                var e = $(this);
                $.ajax({
                    type: "GET",
                    url: e.attr("data-href"),
                    dataType: "html",
                    data: {
                        start: e.attr("data-start")
                    },
                    beforeSend: function () {
                        e.attr("disabled", "disabled")
                    },
                    success: function (e, t) {
                        $("#reviews-list").append(e)
                    },
                    error: function () {
                        e.before('<div class="alert alert-info">We have no more reviews to show you</div>');
                        e.remove()
                    },
                    complete: function () {
                        var t = parseInt(e.attr("data-start")) + parseInt(e.attr("data-rows"));
                        e.attr("data-start", t);
                        e.removeAttr("disabled");
                        analytics.track('click:listing-details:load-more-reviews', {platform: 'DESKTOP'});
                    }
                });

                return true;
            });
            if (PAMH.MapsAvailable) {
                PAMH.mainMap = $("#main-map").listingDetailsMap({
                    defaultCenter: PAMH.ListingOrigin
                });
                if (PAMH.StreetViewData) {
                    PAMH.StreetViewMap = $("#streetview-holder").streetView(new google.maps.LatLng(PAMH.StreetViewData.lat, PAMH.StreetViewData.lng), {
                        heading: parseFloat(PAMH.StreetViewData.heading),
                        pitch: parseFloat(PAMH.StreetViewData.pitch),
                        zoom: parseInt(PAMH.StreetViewData.zoom)
                    })
                }
                $("ul.amenities li").each(function (e, t) {
                    var n = $(t).attr("coords").split(",");
                    var r = new google.maps.LatLng(n[0], n[1]);
                    var i = PAMH.mainMap.addAmenityMarker(e, r, $(t).attr("category"), $(t).attr("subcategory"), {
                        title: $.trim($(t).children("a").text())
                    });
                    $(t).on("click.bounce mouseenter", function (e) {
                        e.preventDefault();
                        i.setAnimation(google.maps.Animation.BOUNCE);
                        setTimeout(function () {
                            i.setAnimation(null)
                        }, 1400)
                    });
                    $(t).on("click.zoom", function (e) {
                        e.preventDefault();
                        PAMH.mainMap.map.setCenter(i.position)
                    })
                })
            }
            if ($("body").hasClass("private-listing")) {
                $(".booking-box input, .booking-box select, .booking-box button, #profile-section a.btn").attr("disabled", "disabled")
            }
            $(".private-listing #profile-section a.btn").click(function (e) {
                e.preventDefault();
                return false
            });
            $(".booking-box button[type=submit]").click(function (e) {
                var t = $(this).closest("form");
                if ($(this).attr("data-submission-url")) {
                    t.attr("action", $(this).attr("data-submission-url"))
                }
            });

            $(".booking-box select, .booking-box input").on("change.ListingDetail", throttle( function () {
                var e = $(this).closest("form");

                var thisValue = $('#id_start_date').val() + $('#id_start_time').val() + $('#id_end_date').val() + $('#id_end_time').val();

                if (window.lastDateTimes && thisValue == window.lastDateTimes) {
                    return false;
                }
                window.lastDateTimes = thisValue;

                if (e.find("input[name='start_date']").val()=="" || e.find("input[name='end_date']").val()=="") {
                    return false;
                }
                var e = $(this).closest("form");
                var t = PAMH.ListingId;

                $.ajax({
                    type: "GET",
                    url: "/parking-spaces/" + t + "/calculate-pricing-availability/",
                    dataType: "json",
                    data: e.serialize(),
                    beforeSend: function () {
                        $(".subtotal-calculation").addClass("ajax-loader").html("");
                        $(".availability_info").hide();
                        $(".opening-closing-time-error").hide();
                        $(".overnight-disabled-error").hide();
                        $(".max-booking-length-error").hide();
                        $(".notice-period-error").hide();
                        $(".max-lead-time-error").hide();
                        $(".delayed-start-error").hide();
                        $(".min_price_info").remove();
                        e.find("button").removeAttr("disabled")
                    },
                    success: function (t, n) {
                      if (t.availability.status != "available" || !t.pricing) {
                        if (t.availability.message === "OPENING_CLOSING_TIME") {
                            $(".opening-closing-time-error .opening-time").text(t.availability.string || moment(t.availability.opening_time, 'H:mm:ss').format('h:mma'));
                            $(".opening-closing-time-error .closing-time").text(t.availability.string || moment(t.availability.closing_time, 'H:mm:ss').format('h:mma'));
                            $(".opening-closing-time-error").fadeIn();
                        } else if (t.availability.message === 'MAX_BOOKING_LENGTH') {
                            $(".max-booking-length-error .js-max-booking-length-hours").text(t.availability.string || t.availability.max_booking_length);
                            $('.max-booking-length-error').fadeIn();
                        } else if (t.availability.message === 'MAX_LEAD_TIME') {
                            $(".max-lead-time-error .js-max-lead-time-hours").text(t.availability.string || t.availability.max_lead_time);
                            $('.max-lead-time-error').fadeIn();
                        } else if (t.availability.message === 'NOTICE_PERIOD') {
                            $(".notice-period-error .js-notice-period-hours").text(t.availability.string || t.availability.notice_period);
                            $('.notice-period-error').fadeIn();
                        } else if (t.availability.message === "OVERNIGHT_DISABLED") {
                            $(".overnight-disabled-error").fadeIn();
                        } else {
                            $(".availability_info").fadeIn();
                        }
                      e.find("button").attr("disabled", "disabled")
                    } else {
                            if (t.pricing.payment_dates.length <= 1) {
                                var total = t.pricing.total_payment.total > 0 ? PAMH.CurrencyCodes[t.pricing.currency] + number_format(t.pricing.total_payment.total, 2) : 'Free';
                                $(".subtotal-calculation").html("Total: <strong>" + total + "</strong>");
                                if (t.pricing.price_type == "min_rental") {
                                  /** TODO: The error is probably comming from
                                   *  higher up in the method
                                   */
                                  if (!$('.min_price_info').length) {
                                    $("<div />", {
                                        "class": "alert alert-info min_price_info",
                                        text: "A minimum booking value applies to this space"
                                    }).insertAfter(".subtotal-calculation");
                                  }
                                }
                            }
                        }
                    },
                    complete: function () {
                        $(".subtotal-calculation").removeClass("ajax-loader")
                    }
                });
                return false
            }, 1000)).change();

            if ($("#large-calendar").length) {
                $.extend(PAMH.datePickerOptions, PAMH.datePickerCustomOptions);
                $("#large-calendar").datepicker(PAMH.datePickerOptions);
                $("#large-calendar").availabilityCalendar({
                    startDate: $("#id_start_date").length ? $("#id_start_date").val() : null
                })
            }
            $("h1 a").click(function (e) {
                e.preventDefault()
            })
        })
    }
}

$(function () {
    if ($("body").hasClass("press-pages")) {
        $.each($("a[data-url]"), function (e, t) {
            var n = $(this).attr("data-url");
            $(this).attr("href", n)
        })
    }

    $("button[data-location-url]").on('click', function(event) {
        event.preventDefault();
        location.href = $(this).attr('data-location-url');
    });
});

function validateEnquiryMessage() {
  $textarea = $(this).find("textarea");
  if ($("#id_booking_id").length) {
    return true
  }
  if ($textarea.length && !PAMH.fraud_check) {
    if (PAMH.emailRegex.test($textarea.val()) || PAMH.websiteRegex.test($textarea.val()) || PAMH.phoneRegex.test($textarea.val())) {
      PAMH.fraud_check = true;
      alert("It appears as though you entered a website, phone number or email address. This information cannot be exchanged until after the booking has been completed.\n\nThis is to protect you from scams that can only occur if you communicate or exchange money outside of the justpark website. Please edit your message and try again.");
      location.reload()
      return false
    }
  }
  return true
}

$(function () {
    if ($("body").hasClass("messaging")) {
        $(".message-markup.is-receiver").each(function (e) {
            var t = $.trim($(this).html());
            t = t.replace("[Removed]", '<a class="security-info" rel="overlay" href="#security-info-content">[Removed]</a>');
            $(this).html(t)
        });
        $("body").on("submit", "form.message-send", validateEnquiryMessage.bind(this));
    }
    $("#change-price").live("click", function (e) {
        e.preventDefault();
        $(this).closest("p.intro").hide();
        $("#show-pricing").fadeIn("slow");
        return false
    });
    $("#id_start_date, #id_end_date").on("dateChange", function () {
        $("#id_price").change()
    });
    $("input[name^=weekdays], #id_specific_dates, #id_infinite, #id_start_time, #id_end_time").on("change.PAMH", function () {
        $("#id_price").change()
    });
    $("#id_price, #id_pricing_period").on("change", function () {
        var e = $(this).closest("form");
        var t = e.serialize();
        var n = $("#id_pid").val();
        var r = $("#id_booking_id").val();
        if (!n || !r) {
            return false
        }
        $.ajax({
            url: "/pricing/amended-pricing/" + n + "/" + r,
            type: "POST",
            dataType: "json",
            data: t,
            beforeSend: function (e) {},
            success: function (e, t) {
                if (e.infinite=="1"){
                    e.total_payment.total = e.initial_payment.total;
                    e.total_payment.fee   = e.initial_payment.fee;
                }
                $("#id_total").val(number_format(e.total_payment.total, 2, ".", ","));
                $("#owner-receives").html(function () {
                    return $(this).attr("data-currency") + number_format(e.total_payment.fee, 2, ".", ",")
                })
            }
        });
        return true
    }).change();
});
$(function () {
    if ($(document.body).hasClass("payment-source")) {
        $("#add-paypal-account").click(function () {
            if (confirm("To authorise your card we need to charge your card a small fee.\n\nThis amount will be immediately refunded back to you.")) {
                return true
            }
            return false
        })
    }
});
$(document).ready(function () {
    if ($("body").hasClass("listing-photos")) {
        if ($('.js-upload-photo').length === 0) {
          $("input[name=photo]").after($("<input />", {
              type: "submit",
              "class": "btn btn-success",
              value: "Upload"
          }));
        }
        $("input[name=photo]").change(function () {
            if (!$.browser.msie) {
                $(this).closest("form").submit();
                $(this).closest("li.add").showLoading()
            }
        });
        $("button.file-handler").click(function (e) {
            e.preventDefault();
            $(this).next("input[name=photo]").trigger("click")
        });
        $("button.delete-photo").click(function (e) {
            e.preventDefault();
            if (confirm("Are you sure you want to delete this photo?")) {
                $this = $(this);
                $.ajax({
                    url: $this.attr("data-url"),
                    type: "GET",
                    dataType: "json",
                    beforeSend: function () {
                        $("#photo-" + $this.attr("data-id")).showLoading()
                    },
                    success: function (e, t) {
                        $("#photo-" + $this.attr("data-id")).hideLoading();
                        $("#photo-" + $this.attr("data-id")).fadeOut()
                    }
                })
            }
            return false
        })
    }

});
if (PAMH.MapsAvailable) {
    if ($("body").hasClass("price-guide")) {
        (function (e) {
            e.PriceGuideMap = function (t, n) {
                var r = this;
                var i = {
                    defaultIconFactory: PAMH.mapUtils.largeMarkerIcon,
                    showMarkerAtCenter: false,
                    defaultZoom: 15,
                    constructorOptions: {
                        disableDefaultUI: true,
                        scaleControl: false,
                        clickableIcons: false,
                        scrollwheel: true,
                        panControl: false,
                        zoomControl: true,
                        mapTypeControl: false,
                        streetViewControl: false,
                        overviewMapControl: false,
                        zoomControlOptions: {
                            style: google.maps.ZoomControlStyle.SMALL
                        }
                    }
                };
                r.settings = e.extend({}, i, n);
                r = e(t).smallMap(r.settings);
                return r
            };
            e.fn.PriceGuideMap = function (t) {
                return new e.PriceGuideMap(this, t)
            }
        })(jQuery);
        $(function () {
            if (PAMH.MapsAvailable) {
                PAMH.mainMap = $("#price-guide-map").PriceGuideMap({
                    defaultCenter: PAMH.ListingOrigin
                })
            }
            $("#price-guide-form").submit(function (e) {
                e.preventDefault();
                var t = $(this);
                $.ajax({
                    url: t.attr("action"),
                    dataType: "json",
                    type: "POST",
                    cache: true,
                    beforeSend: function () {
                        t.showLoading()
                    },
                    error: function () {
                        alert("There was an error processing your request, please try again later.");
                        t.hideLoading();
                        $("#pricing-guide-results").hide()
                    },
                    data: t.serialize(),
                    success: function (e, t, n) {
                        for (var r = 0; r < PAMH.mainMap.loadedListingMarkers.length; r++) {
                            PAMH.mainMap.loadedListingMarkers[r].setMap(null)
                        }
                        if (e.count) {
                            var i, s;
                            var o = [];
                            PAMH.mainMap.overlayBounds = new google.maps.LatLngBounds;
                            PAMH.boundary1 = parseInt(e.count) / 3;
                            PAMH.boundary2 = parseInt(e.count) * 2 / 3;
                            $.each(e.listings, function (e, t) {
                                var n = new google.maps.LatLng(t.lat, t.lng);
                                if (e <= PAMH.boundary1) {
                                    var r = "green"
                                } else {
                                    if (e >= PAMH.boundary2) {
                                        var r = "red"
                                    } else {
                                        var r = "orange"
                                    }
                                }
                                var i = PAMH.mainMap.addMarker(n, PAMH.mapUtils.smallColouredMarkerIcon(r), {
                                    zIndex: e,
                                    title: formatted_total(t.prices.day, t.currency, 2, false) + " per day"
                                });
                                google.maps.event.addListener(i, "click", function (n) {
                                    PAMH.mainMap.showCallout(e, t.callout_url)
                                });
                                PAMH.mainMap.loadedListingMarkers.push(i);
                                PAMH.mainMap.overlayBounds.extend(n);
                                var s = {
                                    location: n,
                                    weight: parseFloat(t.prices.day) / 5
                                };
                                o.push(s)
                            });
                            $("#avg-price").html(formatted_total(e.prices.avg, e.prices.currency, 2, false) + " per day");
                            $("#max-price").html(formatted_total(e.prices.max, e.prices.currency, 2, false) + " per day");
                            $("#min-price").html(formatted_total(e.prices.min, e.prices.currency, 2, false) + " per day");
                            PAMH.mainMap.zoomToBounds(PAMH.mainMap.overlayBounds);
                            $("#pricing-guide-results").fadeIn()
                        } else {
                            alert("Sorry, but we do not have any data in this region");
                            $("#pricing-guide-results").hide()
                        }
                        var u = new google.maps.LatLng(e.location.lat, e.location.lng);
                        PAMH.mainMap.map.setCenter(u)
                    },
                    complete: function () {
                        t.hideLoading()
                    }
                });
                return false
            })
        })
    }
}
$(function () {
    if ($("body").hasClass("profile")) {
        var e = $("div.listing");
        if (e.length > 1) {
            var t = $("div.listing:gt(0)");
            t.hide();
            $("<a/>", {
                text: "Show all " + e.length + " listings",
                href: "#"
            }).click(function (e) {
                e.preventDefault();
                $("div.listing:gt(0)").slideDown();
                $(this).remove()
            }).insertAfter($("div.listing:last"))
        }
    }
    $("[rel=profile-badge]").each(function (e, t) {
        $(t).callout("#profile-badge-content", {
            gravity: "w"
        })
    })
});
$(function () {
    if ($("body").hasClass("profile-edit")) {
        $("[name^='photo_prefs']").click(function (e) {
            var t = $(this).attr("id");
            $("[class^='display_']").hide();
            $(".display_" + t).fadeIn()
        });
        $("[name^='photo_prefs']:checked").click()
    }
});
$(function () {
    if ($("#id_referral_description").length) {
        $("#id_referral_description").closest("li").hide();
        $("#id_referral_type").change(function () {
            if (!$("#id_referral_description").data("visible")) {
                $("#id_referral_description").closest("li").slideDown();
                $("#id_referral_description").data("visible", true)
            }
        })
    }
});
if (PAMH.MapsAvailable) {
    (function (e) {
        e.searchMap = function (t, n) {
            var r = this;
            var i = {
                showMarkerAtCenter: false,
                browsableMap: true,
                requestParams: {
                    max_results: 50
                },
                calloutOptions: {
                    googleShowEvent: "mousedown"
                },
                constructorOptions: {
                    disableDefaultUI: true,
                    zoomControl: true,
                    zoomControlOptions: {
                        style: google.maps.ZoomControlStyle.SMALL
                    },
                    navigationControl: true,
                    navigationControlOptions: {
                        style: google.maps.NavigationControlStyle.SMALL
                    }
                }
            };
            r.settings = e.extend({}, i, n);
            r = e(t).listingMap(r.settings);
            return r
        };
        e.fn.searchMap = function (t) {
            return new e.searchMap(this, t)
        }
    })(jQuery);
    $(document).ready(function () {
        $(".close-container").on("click", function () {
            $(this).closest(".section-container").slideUp()
        });
        if ($("body").hasClass("search") || $("body").hasClass("map-widget")) {
            $("#search-filters label a").click(function (e) {
                e.preventDefault();
                var t = $(this).parent("label").prev("input");
                t.attr("checked", !t.is(":checked"))
            });
            $("#id_temp_search_order").change(function () {
                $("#id_order").val($(this).val());
                $("#listings-column").showLoading();
                $("#refine-search").submit()
            }).val($("#id_order").val());
            if (typeof PAMH.SearchInfo != "undefined") {
                var e = $("#map-holder").searchMap({
                    defaultCenter: PAMH.SearchInfo.locationCenter
                });
                e.locationCenter = new google.maps.LatLng(PAMH.SearchInfo.locationCenter[0], PAMH.SearchInfo.locationCenter[1]);
                var t = e.addMarker(e.locationCenter, PAMH.mapUtils.currentLocationMarkerIcon(), {
                    zIndex: 1e3,
                    title: PAMH.InitialLocationName
                });
                e.overlayBounds = new google.maps.LatLngBounds;
                e.overlayBounds.extend(e.locationCenter);
                if (PAMH.SearchInfo.bounds) {
                    var n = e.addBounds(PAMH.SearchInfo.bounds)
                }
                $.each(PAMH.SearchInfo.results, function (t, n) {
                    var r = new google.maps.LatLng(n[0], n[1]);
                    var i = e.addMarker(r, PAMH.mapUtils.indexedMarkerIcon(n[2]), {
                        zIndex: n[9],
                        title: n[6]
                    });
                    e.loadedListings.push(n[5]);
                    e.loadedListingMarkers.push(i);
                    var s = e.loadedListingsContent.length;
                    google.maps.event.addListener(i, "click", function (t) {
                      e.showCallout(s, n[4]);

                      eventTracking.trackMapPinClickEvent({
                        listing: {
                          lat: n[0],
                          lng: n[1],
                          searchRank: n[2]
                        },
                        color: 'blue',
                      });
                    });
                    if (s < 5) {
                        e.overlayBounds.extend(r)
                    }
                });

                if (PAMH.SearchInfo.results.length) {
                    e.zoomToBounds(e.overlayBounds)
                }
                var r;
                $("#local-amenities .tab-content li a.load-marker").click(function (t) {
                    t.preventDefault();
                    if (!(r = $(this).data("added-to-map"))) {
                        var n = $(this).parent("li");
                        var i = n.attr("coords").split(",");
                        var i = new google.maps.LatLng(parseFloat(i[0]), parseFloat(i[1]));
                        r = e.addAmenityMarker(n.attr("id"), i, n.attr("category"), n.attr("subcategory"), {
                            title: $(this).text()
                        });
                        $(this).data("added-to-map", r)
                    }
                    $(this).siblings(".amenity-information").slideToggle();
                    r.setAnimation(google.maps.Animation.BOUNCE);
                    setTimeout(function () {
                        r.setAnimation(null)
                    }, 1400);
                    if (!e.map.getBounds().contains(r.getPosition())) {
                        e.map.panTo(r.getPosition())
                    }
                });
                if ($("#location-suggestion").length) {
                    var i = $("#location-suggestion").locationSuggester({
                        query: $("input[name=q]").val()
                    })
                }
                $(".book-instantly").click(function (e) {
                    var t = $(this);
                    var n = t.closest("ul").children("li").index(t.parents("li"));
                    n++;
                    return true
                });
                $("#form-search-alerts").submit(function () {
                    $form = $(this);
                    $.ajax({
                        url: $form.attr("action"),
                        type: "POST",
                        dataType: "json",
                        data: $form.serialize(),
                        beforeSend: function (e) {},
                        error: function (e, t, n) {
                            data = e.responseText;
                            $form.find(".control-group").addClass("error");
                            alert("Please correctly fill in the required fields")
                        },
                        success: function (e, t) {
                            if (e.status == "success") {
                                $form.html("<p>Thank you " + e.data.name + ", we'll be in touch soon.</p>");
                            }
                        }
                    });
                    return false
                })
            }
        }
    })
}
if (PAMH.MapsAvailable) {
    $(document).ready(function () {
        if (PAMH.SitemapInfo) {
            var e = $("#map-holder").smallMap({
                showMarkerAtCenter: true,
                defaultCenter: PAMH.SitemapInfo.locationCenter
            });
            var t = new google.maps.LatLngBounds;
            PAMH.SitemapInfo.bounds = $.map(PAMH.SitemapInfo.bounds, function (e) {
                return $.map(e, function (e) {
                    thisPoint = new google.maps.LatLng(e[0], e[1]);
                    t.extend(thisPoint);
                    return thisPoint
                })
            });
            if (PAMH.SitemapInfo.bounds) {
                var n = e.addBounds(PAMH.SitemapInfo.bounds);
                e.zoomToBounds(t)
            }
        }
    })
}
$(function () {
    $("body").on("touchstart.dropdown", ".dropdown-menu", function (e) {
        e.stopPropagation()
    }).on("touchstart.dropdown", ".dropdown-submenu", function (e) {
        e.preventDefault()
    })
});
$(function () {
    $("[rel=popover]").popover({
        trigger: "hover",
        html: true,
        content: $(this).attr("data-content") ? $(this).attr("data-content") : function () {
            if ($(this).attr("data-type") == "image") {
                if ($(this).attr("data-width") && $(this).attr("data-height")) {
                    return '<img src="' + $(this).attr("data-url") + '" width="' + $(this).attr("data-width") + '" height="' + $(this).attr("data-height") + '" alt="Parking Space photo" />'
                } else {
                    return '<img src="' + $(this).attr("data-url") + '" alt="Parking Space photo" />'
                }
            } else {
                if ($(this).attr("data-id")) {
                    return $("#" + $(this).attr("data-id")).html()
                }
            }
            return
        }
    });
    $("a[rel=tooltip], span[rel=tooltip]").tooltip({
        placement: $(this).attr("data-placement") ? $(this).attr("data-placement") : "top"
    });
    $("body").on("focus", "input.has-tooltip, select.has-tooltip, textarea.has-tooltip", function (e) {
        $(this).tooltip({
            trigger: "focus",
            placement: $(this).attr("data-placement") ? $(this).attr("data-placement") : "right"
        })
    });
    $("body").on("click", ".show-popover", function (e) {
        e.preventDefault();
        $(this).popover();
        $(this).unbind("hover")
    })
});
PAMH.fb_namespace = "parkatmyhouse";
$(function () {
    $("body").on("click", ".fb-enabled .publish-open-graph", function (e) {
        e.preventDefault();
        $this = $(this);
        var t = $this.attr("data-action");
        var n = $this.attr("data-object");
        var r = jQuery.parseJSON($("#og_json_data").val());
        if ($("#pamh_modal").length) {
            $("#pamh_modal").modal("hide")
        } else {
            $(".ui-dialog").dialog("close")
        } if ($this.attr("data-explicit")) {
            delete r["fb:explicitly_shared"]
        }
        if (PAMH_FB.status == "connected") {
            FB.api("me/" + PAMH.fb_namespace + ":" + t, "post", r, function (e) {
                if (e.id) {
                    r["action_id"] = e.id;
                    r["object"] = n;
                    r["action"] = t;
                    r["url"] = $this.attr("data-object-url");
                    $.post("/misc/facebook-og/save/", r);
                }
            })
        } else if (r["fb:explicitly_shared"]) {
            var r = jQuery.parseJSON($("#share_json_data").val());
            FB.ui({
                method: "feed",
                name: r.title,
                link: $this.attr("data-object-url"),
                picture: r.picture,
                caption: r.caption,
                description: r.description
            }, function (e) {
                $("#pamh_modal").modal("hide");
            })
        } else {
            $("#pamh_modal").modal("hide")
        }
        return false
    })
});

$(function () {
    $("body").on("click", "#listing-deactivate .activate-form", function () {
        $(".section").hide();
        $(".deactivate-form").show();
    });

    $("body").on("change", "#listing-deactivate #id_reason", function () {
        if ($("#id-" + $(this).val()).length) {
            $(".section").hide();
            $("#id-" + $(this).val()).show();
            $(".deactivate-form").hide();
        } else {
            $(".section").hide();
            $(".deactivate-form").show();
        }


    });
});


$(document).mouseup(function (e)
{
    var container = $("#search-form-reveal");
    var dateContainer = $("#ui-datepicker-div");
    var searchContainer = $("#header-search");

    if (!container.is(e.target) && container.has(e.target).length === 0
        && !dateContainer.is(e.target) && dateContainer.has(e.target).length === 0
        && !searchContainer.is(e.target) && searchContainer.has(e.target).length === 0)
    {
        container.css({'opacity':'0'});
        container.parent("form").removeClass("form-open");
    }
});

$(document).ready(function () {
    $("header .places-autocomplete").on("focus.showDates", function(){
        if ($(this).val() && !$(this).closest("form").hasClass("form-open")){
            $("#search-form-reveal").closest("form").addClass("form-open");
            $("#search-form-reveal").animate({'opacity':'1'}, 500);
        }
    });


    $("body").on("click", ".dismiss-jp-announcement", function(){
        $.cookie("pamh_dismiss", "1", {
            expires: 500,
            path: "/"
        });
        return true;
    });


    $("body").on("click", "#lookup-license-plate", function () {
        var $this = $(this);
        var form = $("form.vehicle-add");
        $.ajax({
            url: $this.attr("data-url"),
            type: "POST",
            dataType: "json",
            data: {
                "license_plate" : $("#id_registration").val()
            },
            beforeSend: function (e) {
                e.setRequestHeader("X-OVERLAY", "1");
                form.showLoading()
            }
        })
        .fail(function (xhr, status, error) {
            JSONError(xhr.responseText);
            $("#vehicle-meta").show();
        })
        .done(function (response, status, xhr) {
            $('#id_make').find('option').each(function () {
                if (response.data.make && $(this).val().toLowerCase() == response.data.make.toLowerCase()) {
                    $('#id_make').val($(this).val());
                }
            });
            $("#id_model").val(response.data.model);
            $("#id_model_id").val(response.data.model_id);
            $("#id_is_hired").closest(".control-group").hide();
            $("#vehicle-meta").show();
        })
        .always(function(){
            form.hideLoading();
        });
    });

    $("body").on("change", "#id_is_hired", function () {
        if ($(this).prop("checked")){
            $("#show-hired-vehicles").show();
            $("#id_category").closest(".control-group").hide();
            $("#id_make").closest(".control-group").hide();
            $("#id_model").closest(".control-group").hide();
        } else {
            $("#show-hired-vehicles").hide();
            $("#id_category").closest(".control-group").show();
            $("#id_make").closest(".control-group").show();
            $("#id_model").closest(".control-group").show();
        }
    });

    $("body").on("click", "#dont-know-license", function () {
        $(this).closest(".control-group").hide();
        $("#vehicle-meta").show();
        $("#id_is_hired").closest(".control-group").show();
    });


    $("body").on("submit", "form.vehicle-add", function (e) {
        e.preventDefault();
        var t = $(this);

        if ($("#vehicle-meta").is(':hidden')) {
            $('#lookup-license-plate').click();
            return false;
        }

        $.ajax({
            url: t.attr("action"),
            type: "POST",
            dataType: "json",
            data: t.serialize(),
            beforeSend: function (e) {
                e.setRequestHeader("X-OVERLAY", "1");
                $(".control-group").removeClass("error");
                t.showLoading()
            }
        })
        .fail(function (xhr, status, error) {
            if (xhr.status == 429) {
                alert('You are doing this action too many times, please wait and try again later');
            }
            JSONError(xhr.responseText);
        })
        .done(function (e, t) {
            if ($("#id_vehicles").length) {
                var n = $("<option />", {
                    value: e.extra.id,
                    text: e.extra.name
                });
                $("#id_vehicles").prepend(n);
                $("#id_vehicles").val($("#id_vehicles option[value=" + e.extra.id + "]").val())
            } else {
                var r = $("<tr><td>" + e.extra.category + "</td><td>" + e.extra.make + "</td><td>" + e.extra.model + "</td><td>" + e.extra.registration + '</td><td class="span1"><button type="button" class="btn btn-danger btn-mini" data-type="vehicle" data-url="/dashboard/vehicles/' + e.extra.id + '/delete/" data-option="delete-item">Delete</button></td></tr>');
                $("#vehicle-list tbody").prepend(r);
                $("#vehicle-list table").removeClass("hidden");
                $("#vehicle-list div.alert").hide()
            }
            $("#pamh_modal").modal("hide");
            analyticsTrack('action:checkout-step-1:added-vehicle');

            if ($("#change-vehicle").length > 0) {
                location.reload();
            }
        })
        .always(function(){
            t.hideLoading();
        });

        return false
    });

    $("body").on("click", "a[data-action='add-vehicle'], button[data-action='add-vehicle']", function (e) {
        e.preventDefault();
        $this = $(this);
        $("#pamh_modal").modal({
            remote: $this.attr("data-url")
        }).on("hidden", function () {
            $("form.vehicle-add").remove()
        })
    })
});


$(function () {
    $(".is-link").on("click", function(){
        location.href = $(this).attr("data-url");
    });

    $('#add-address').on('click', function() {
        $('#new-address-container').show();
        $('#current-address-container').remove();
    });
});

$(function () {
    if ($("#add-payment-method")) {
        $("#add-payment-method").click(function (e) {
            e.preventDefault();
            $("#current-payment-container").hide();
            $("#update-payment-method").show();
            // The current designs don't allow a user to return to the
            // payment method selection list after the 'Use a
            // different payment method' link is clicked. So we can
            // safely remove all payment methods from this select
            // to fix LAUNCH-39.
            $("#id_payment_source_id").empty();
        })
    }

    /**
     * Taken from add listing page
     */
    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

    $("#pricing-section input, #min_rental_price_container input").on("focus.tooltip, keyup.tooltip", function() {
        $this = $(this);

        if (!$this.val()) {
            return;
        }

        if (!isNumeric($this.val())) {
            return;
        }

        var new_price = roundNumber(Math.round(parseFloat($this.val())*1.25*10)/10,2);

        $this.attr("title", "The driver will pay " + PAMH.CurrencySymbol+new_price);
        $this.attr("data-original-title", "The driver will pay " + PAMH.CurrencySymbol + new_price);

        $this.tooltip({
            'placement': 'top',
            'trigger': 'manual'
        });

        $this.tooltip('show');
    });

    $("#pricing-section input, #min_rental_price_container input").on("blur.tooltip", function() {
        $(this).tooltip('hide');
    });

    PAMH.prices = {};
    PAMH.prices.hourly_price    = 0;
    PAMH.prices.daily_price     = 0;
    PAMH.prices.weekly_price    = 0;
    PAMH.prices.monthly_price   = 0;

    $("#id_pricing_car_day").on("change.update", function() {
        if (parseFloat($(this).val()) > PAMH.prices.daily_price) {
            $("#pricing-alert").fadeIn();
        } else {
            $("#pricing-alert").hide();
        }
    });

    $("#id_location").on("change.pricing", function() {

        var $this = $(this);

        $.ajax({
            url: $('[name=hidden_url_price_guide]').val(),
            dataType: 'json',
            type: 'POST',
            cache: true,
            data: {
                location: 'Auto',
                coords: $this.val(),
                distance: 1,
                category: 'is_driveway'
            },
            success: function(data, textStatus, jqXHR) {
                PAMH.prices.daily_price     = roundNumber(data.prices.avg * 0.7, 0);

                if (PAMH.prices.daily_price > 10 && PAMH.prices.daily_price <= 25){
                    PAMH.prices.daily_price = 10;
                }

                PAMH.prices.hourly_price    = roundNumber(PAMH.prices.daily_price / 8,0) > 1 ? roundNumber(PAMH.prices.daily_price / 8, 0) : '1.00';
                PAMH.prices.weekly_price    = roundNumber(PAMH.prices.daily_price * 5,0);
                PAMH.prices.monthly_price   = roundNumber(PAMH.prices.daily_price * 20,0);

                $("#id_pricing_car_day").val(PAMH.prices.daily_price);
                $("#id_pricing_car_hour").val(PAMH.prices.hourly_price);
                $("#id_pricing_car_week").val(PAMH.prices.weekly_price);
                $("#id_pricing_car_month").val(PAMH.prices.monthly_price);
            }
        });
    });

  // Add listener for each messaging macro button.
  for (i = 1; i < 14; i++) {
    $('body.messaging').on('click', '#macro-' + i, function() {
      // Get id of macro button
      var id = this.id.substr(this.id.lastIndexOf('-') + 1);
      var text = $('#id_macro-' + id).val();
      $('#id_message').val(text);
    });
  }

  var disableCalendarClicks = function() {
    var calendarCell = $('.availability-calendar td');
    calendarCell.off('click');

    calendarCell.on('click', function (e) {
      e.preventDefault();
    });

  };

  disableCalendarClicks();

  $('.availability-calendar').on('click', '', disableCalendarClicks);
});


$(function () {
  if (! $('body').hasClass('login')) {
    return;
  }

  var $node = $('#content');
  var $newAccount = $('#account_type-no_account');
  var $hasAccount = $('#account_type-has_account');
  var $newAccountRadio = $('input[value=no_account]:radio', $node);
  var $hasAccountRadio = $('input[value=has_account]:radio', $node);
  var $newAccountContainer = $('.fields-container', $newAccount);
  var $hasAccountContainer = $('.fields-container', $hasAccount);
  var $forgotPassword = $('#forgot_password');
  var $passwordHelperText = $('.pw-helper-text');
  var $passwordLabel = $('label[for="id_password"]');
  var $passwordField = $('#login-form #id_password');
  var $form = $('#login-form');
  var passwordValidator;

  // Detach the code which currently applies the animation to the
  // login/signup form.
  $('input[name="account_type[]"]:radio', $node).off('change');
  $('input[name="account_type[]"]:radio', $node).off('click');
  $('.selection-container.account_type', $node).unbind();

  $passwordField.wrap('<span class="validation-icon"></span>');

  var setupFormValidation = function() {
    if (passwordValidator) {
        passwordValidator.destroy();
    }

    if (typeof window.Parsley !== 'object') {
        return;
    }

    passwordValidator = new window.Parsley.Factory($passwordField, {
        required: true,
        minlength: 8,
        trigger: 'keydown',
        validationThreshold: 1,
        errorsMessagesDisabled: true
    });

    passwordValidator.on('field:success', function() {
        this.$element.parent().addClass('validation-success').removeClass('validation-failed');
    });
    passwordValidator.on('field:error', function() {
        this.$element.parent().addClass('validation-failed').removeClass('validation-success');
    });
  };

  var disableFormValidation = function() {
    $passwordField.parent().removeClass('validation-failed validation-success');
    if (passwordValidator) {
        passwordValidator.destroy(); // destroy the validation object
        passwordValidator = new window.Parsley.Factory($passwordField); // and recreate it with no rules
    }
  };

  // Redisplay on login or signup option change.
  $('input[name="account_type[]"]:radio', $node).on('change', function() {
    var $this = $(this);

    if ('no_account' === $this.val()) {
      $hasAccount.fadeOut("fast", function() {
        $newAccount.fadeIn("fast", function() {
          $hasAccountContainer.html('');
        });
      });

      $forgotPassword.hide();
      $passwordHelperText.show();
      $passwordLabel.text('Set a password');
      setupFormValidation();
    }

    if ('has_account' === $this.val()) {
      $newAccount.fadeOut("fast", function() {
        $hasAccount.fadeIn("fast", function() {
          $newAccountContainer.html('');
        });
      });

      $forgotPassword.show();
      $passwordHelperText.hide();
      $passwordLabel.text('Password');
      disableFormValidation();
    }
  });

  // Display the new account section by default.
  var $show = $newAccountRadio;

  // If the has account option is clicked (for example because the
  // page was reloaded with validation errors in has_account) we show
  // the login section.
  if ($hasAccountRadio.is(':checked')) {
    $show = $hasAccountRadio;
  }

  $show.change();

});

/**
 **************************** NOTE ************************************
 * A copy of this code is present in logout.js
 *
 * Please ensure both sections are updated at once.
 *
 * @note I have considered moving this listener inside of the
 * google_tag_manager.html file, the only reason I haven't centralised
 * it there is because otherwise the JS wouldn't get minified.
 *
 ***********************************************************************
 */
$(function() {
  $('.js-rent-out-space-header').click(function() {
    window.dataLayer.push({
      'event': 'Rent Out Click',
      'RentOutClickData': {
        'Page': window.location.pathname,
        'Area': 'header'
      }
    });
  });

  $('.js-rent-out-space-page').click(function() {
    window.dataLayer.push({
      'event': 'Rent Out Click',
      'RentOutClickData': {
        'Page': window.location.pathname,
        'Area': 'body'
      }
    });
  });
});

$(function () {
  $('.js-header-toggle-mobile-menu').on('click touchstart', function (e) {
    e.preventDefault();
    $('.c-header__menu-container').toggleClass('c-header__menu-container--visible');
    $('.c-header__menu-overlay').toggleClass('c-header__menu-overlay--visible');
    $('input').each(function() {
      $(this).trigger('blur');
    });
    $('body').toggleClass('no-scroll');
  });

  $('.js-header-toggle-notifications').on('click touchstart', function (e) {
    e.preventDefault();
    $('.c-header__menu--messages').toggleClass('c-header__menu--visible');
  });

  $('.js-notification-back').on('click touchstart', function (e) {
    e.preventDefault();
    $('.c-header__menu--messages').toggleClass('c-header__menu--visible');
  });

  $('.c-header__menu-overlay').on('click touchstart', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    $('.c-header__menu-overlay').toggleClass('c-header__menu-overlay--visible');
    $('.c-header__menu-container').toggleClass('c-header__menu-container--visible');
    $('body').toggleClass('no-scroll');
  });

  $('.c-header__menu--message-count').on('click touchstart', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = '/dashboard/messaging/';
  });

  $('.js-header-toggle-secondary').on('click touchstart', function (e) {
    // if desktop
    if (window.innerWidth >= 600) {
      e.preventDefault();
      e.stopImmediatePropagation();
      $('.c-header__menu--secondary').toggleClass('c-header__menu--visible');
      $('.c-header__menu-secondary-container').toggleClass('c-header__menu--visible');
    }
  });

  if (window.innerWidth <= 600) {
    new GeminiScrollbar({
      element: document.querySelector('.c-header__mobile-scroll')
    }).create();
  }
});

},{"./cancellations/cancellation_end_date.js":24,"./extensions/availability_calendar.js":26,"./extensions/character_counter.js":27,"./extensions/credit_card_fields.js":28,"./extensions/debug.js":29,"./extensions/event_tracking.js":30,"./extensions/form_selection_groups.js":31,"./extensions/growl.js":32,"./extensions/modal.js":33,"./extensions/placeholder.js":34,"./extensions/rating_input.js":35,"./listings/add.js":36,"./listings/details.js":37,"./listings/edit.js":38,"./search/results.js":39,"./user.js":40,"bootstrap/js/bootstrap-alert.js":1,"bootstrap/js/bootstrap-button.js":2,"bootstrap/js/bootstrap-dropdown.js":3,"bootstrap/js/bootstrap-popover.js":4,"bootstrap/js/bootstrap-tab.js":5,"bootstrap/js/bootstrap-tooltip.js":6,"bootstrap/js/bootstrap-transition.js":7,"bootstrap/js/bootstrap-typeahead.js":8,"gemini-scrollbar":9,"lodash/throttle":21,"moment":23}],26:[function(require,module,exports){
module.exports = function(e, PAMH) {
  e.availabilityCalendar = function(t, n) {
    var r = {
      startDate: new Date,
      pickable: e("body").hasClass("dashboard") ? false : true,
      editable: false,
      cache: e("body").hasClass("dashboard") ? false : true
    };
    var i = this;
    i.settings = e.extend({}, r, n);
    if (i.settings.startDate) {
      t.datepicker("setDate", i.settings.startDate)
    }
    i.calendarData = {};
    i.calendarData.currentDate = new Date(i.settings.startDate);
    i.calendarData.currentContainer = t;
    i.calendarData.loadedAvailability = [];
    i.dateClickedHandler = function(t, n) {
      var r;
      if (e("body").hasClass("dashboard")) {
        return false
      } else {
        r = e.substitute("/parking-spaces/{slug}/book/?start_date={date}", {
          slug: PAMH.ListingSlug,
          date: t
        });
        window.location.href = r
      }
    }, i.loadAvailability = function(t) {
      var n = e.datepicker.formatDate("yy-mm", t);
      if (i.calendarData.currentContainer.data(n) && i.settings.cache) {
        i.renderAvailability(i.calendarData.currentContainer.data(n))
      } else {
        var r = e.substitute("/availability/calendar/{listing_id}/", {
          listing_id: PAMH.ListingId
        });
        var s = {};
        e.extend(s, {
          date: n
        });
        if (e("body").hasClass("listings-availability")) {
          e.extend(s, {
            nocache: 1
          })
        }
        e.ajax({
          url: r,
          dataType: "json",
          type: "GET",
          cache: i.settings.cache,
          beforeSend: function() {
            i.calendarData.currentContainer.showLoading()
          },
          data: s
        }).done(function(e) {
          i.renderAvailability(e)
        }).always(function() {
          i.calendarData.currentContainer.hideLoading()
        })
      }
    }, i.updateColours = function(t) {
      var n = e.datepicker.formatDate("yy-mm", t);
      if (i.calendarData.currentContainer.data(n)) {
        var r = e.datepicker.formatDate("yy-mm-dd", t);

        if (i.calendarData.currentContainer.data(n).extra.availability[r]){
        var s = i.calendarData.currentContainer.data(n).extra.availability[r].status;
        if (s) {
          switch (s) {
            case "full":
              var o = "available";
              var u = "Available all day";
              var f = true;
              break;
            case "partial":
              var o = "limited";
              var u = "Limited availability";
              var f = true;
              break;
            default:
              var o = "unavailable";
              var u = "Unavailable";
              var f = e("body").hasClass("dashboard") ? false : true
          }
        }

          return new Array(f, o, u)
        }
      }
      return new Array(true, "")
    }, i.renderAvailability = function(t) {
      if (!i.calendarData.currentContainer.data(t.extra.q) || !i.settings.cache) {
        i.calendarData.currentContainer.data(t.extra.q, t)
      }
      e.each(t.extra.availability, function(e, t) {
        if (t.status) {
          var n = String(e.match(/^\d{4}\-\d{2}-(\d{2})$/)[1]).replace(/^[0]+/g, "");
          var r = i.calendarData.currentContainer.find("tbody td a:econtains('" + n + "')");
          if (!r.hasClass("ui-datepicker-unselectable")) {
            var s;
            switch (t.status) {
              case "full":
                r.parent("td").addClass("available");
                r.attr("title", "Available all day");
                s = true;
                break;
              case "partial":
                if (t.partial_start_time && t.partial_end_time) {
                  r.attr("title", "Available before " + t.partial_start_time + " and after " + t.partial_end_time + " only")
                } else {
                  if (t.partial_start_time) {
                    r.attr("title", "Available before " + t.partial_start_time + " only")
                  } else {
                    if (t.partial_end_time) {
                      r.attr("title", "Available after " + t.partial_end_time + " only")
                    }
                  }
                }
                r.tooltip();
                r.parent("td").addClass("limited");
                s = true;
                break;
              default:
                r.parent("td").addClass("unavailable");
                r.attr("title", "Unavailable");
                s = false
            }
            r.css("background", "none")
          }
        }
      })
    };
    i.loadAvailability(new Date(i.settings.startDate));
    e("#status-explicit-date-add").on("new_explicit_date", function() {
      i.loadAvailability(i.calendarData.currentDate, true)
    });
    e("#large-calendar").datepicker("option", {
      beforeShowDay: i.updateColours,
      onSelect: i.dateClickedHandler,
      onChangeMonthYear: function(e, t, n) {
        i.loadAvailability(new Date(e, t - 1, 1));
        i.calendarData.currentDate = new Date(e, t - 1, 1)
      }
    });
    return i
  };
  e.fn.availabilityCalendar = function(t) {
    return new e.availabilityCalendar(this, t)
  }
};

},{}],27:[function(require,module,exports){
(function(e) {
  e.fn.characterCounter = function(t) {
    return this.filter("textarea, input:text").each(function() {
      var n = e(this),
        r = function(r) {
          if (n.val().length > t) {
            n.val(n.val().substring(0, t));
            e.growl("You have reached the " + t + " character limit", {
              type: "error",
              position: "bottomright"
            });
            r.preventDefault();
            r.stopPropagation()
          }
        };
      n.keydown(function(e) {
        var t = {
          DELETE: 46,
          BACKSPACE: 8,
          TAB: 9,
          LEFT: 37,
          UP: 38,
          RIGHT: 39,
          DOWN: 40
        };
        switch (e.which) {
          case t.UP:
          case t.DOWN:
          case t.LEFT:
          case t.RIGHT:
          case t.TAB:
            break;
          default:
            r(e);
            break
        }
      });
      n.bind("paste cut", function(e) {
        setTimeout(function() {
          r(e);
          e = null
        }, 150)
      })
    })
  }
})(jQuery);

},{}],28:[function(require,module,exports){
!(function(e) {
  e.fn.creditCardFields = function() {
    function r() {
      t.wrap('<div class="clearfix" />');
      t.css("float", "left").after('<div class="cc-indicator"></div>');
      t.change(s).keyup(s);
      t.change()
    }

    function i() {
      e(".cc-indicator").destroy();
      t.unbind("change", s).unbind("keyup", s)
    }

    function s(r) {
      var i = t.val().split(/\s/).join("");
      cls = null;
      e.each(n, function(t, n) {
        if (i.match(n[0])) {
          e("#id_card_type").val(n[1]);
          cls = t;
          e(".cc-indicator").addClass(t)
        }
      });
      e.each(n, function(t, n) {
        if (t != cls) {
          e(".cc-indicator").removeClass(t)
        }
      });
    }
    var t = e(this);
    var n = {
      visa: [/^4\d{12}(\d{3})?$/, "Visa"],
      mc: [/^(5[1-5]\d{4}|677189)\d{10}$/, "MasterCard"],
      maestro: [/(^6759[0-9]{2}([0-9]{10})$)|(^6759[0-9]{2}([0-9]{12})$)|(^6759[0-9]{2}([0-9]{13})$)/, "Maestro"],
      amex: [/^3[47]\d{13}$/, "American Express"]
    };
    r()
  }
})(jQuery);

},{}],29:[function(require,module,exports){
/**
 * Wrapper on Bugsnag in order to enable simple JS debugging
 */

module.exports = {

  /**
   * Accessor
   */
  setUser: function(user) {
    if (!user) {
      return;
    }

    if (typeof user.serialize === 'function') {
      Bugsnag.user = user.serialize();
    }
  },

  /**
   * Loging some info
   */
  log: function() {
    console.log.call(console, arguments);
  },

  /**
   * Listen to Ajax errors
   */
  registerAjax: function() {
    $(window.document).ajaxError(function(event, jqxhr, settings, thrownError) {
      Bugsnag.notify("AjaxError", thrownError, {
        event: event,
        settings: settings,
        jqxhr: jqxhr
      });
    });
  }
};

},{}],30:[function(require,module,exports){
/**
 * EventTracking module. It offers a facade for our event tracking tools, used
 * for metrics and analytics
 *
 * Google Tag Manager is used for the current implementation
 *  It uses the global property: `dataLayer`
 */

var PAGE_PATH_REGEX = {
  LISTING_INFO: /^\/[a-zA-Z]{2}\/(?:parking|driveways|garages|car-parks)\/(?:[\w-]+)\/s\/(?:[a-zA-Z0-9_.-]+)\/?$/,
  SEARCH_RESULTS: /\/search\//
};

var PAGES = {
  LISTING_INFO: 'Listing Info',
  SEARCH_RESULTS: 'Search Results',
  UNKNOWN: 'Unknown',
};

module.exports = {

  /**
   * Tracks a new specific event
   */
  _pushEvent: function(options) {
    if (typeof options.event === 'undefined') {
      throwEventPropertyRequired();
      return;
    }

    dataLayer.push(options);
  },

  /**
   * If listing in search results: letter
   * If listing added on drag: none
   */
  _getPinLabelType: function(isSmall) {
    if (isSmall) {
      return 'empty';
    }

    return 'letter';
  },

  /**
   * Position of the results
   */
  _getResultsPosition: function(index) {
    return (typeof index === 'undefined') ? null : index;
  },

  /**
   * Deduce the color depending on the options provided and the current page
   */
  _calculateColor: function(options) {
    if (options.color) {
      return options.color;
    }

    switch(this._getCurrentPage()) {
      case PAGES.SEARCH_RESULTS:
        return 'blue';
      case PAGES.LISTING_INFO:
        return 'gray';
      default:
        return null;
    }
  },

  _getCurrentPage: function() {
    switch(true) {
      case PAGE_PATH_REGEX.SEARCH_RESULTS.test(window.location.pathname):
        return PAGES.SEARCH_RESULTS;
      case PAGE_PATH_REGEX.LISTING_INFO.test(window.location.pathname):
        return PAGES.LISTING_INFO;
      default:
        return PAGES.UNKNOWN;
    }
  },

  /**
   * Tracks clicks on the map pin
   */
  trackMapPinClickEvent: function(options) {
    var resultPosition = this._getResultsPosition(options.listing.searchRank);
    var color = this._calculateColor(options);
    var eventProperties = {
      event: 'map-pin click',
      pinLabelType: this._getPinLabelType(options.isSmall),
      lat: options.listing.lat,
      lng: options.listing.lng,
      currentPage: this._getCurrentPage()
    };

    if (color) {
      eventProperties['color'] = color;
    }

    if (resultPosition) {
      eventProperties['searchRank'] = resultPosition;
    }

    this._pushEvent(eventProperties);
  }

};

function throwEventPropertyRequired() {
  throw new Error('Event Property is required');
}

},{}],31:[function(require,module,exports){
!(function(e) {
  e.fn.formSelectionGroups = function() {
    var t = [];
    e(this).each(function(n, r) {
      t.push(e(r).attr("name").replace("[]", ""))
    });
    t = e.unique(t);
    e.each(t, function(t, n) {
      var r = e("input.selection-chooser[type=radio][name^=" + n + "]");
      var i = e(".selection-container." + n);
      var s = r.filter(":checked");
      if (s) {
        var o = r.index(s[0])
      } else {
        var o = 0
      }
      e(".selection-container." + n + ":not(:eq(" + o + "))").hide();
      if (e.browser.msie) {
        r.click(function() {
          var t = r.index(e(this));
          e(".selection-container." + n + ":not(:eq(" + t + "))").hide();
          e(".selection-container." + n + ":eq(" + t + ")").slideDown()
        });
        e("input.selection-chooser[type=radio][name^=" + n + "]:eq(" + o + ")").click()
      } else {
        r.change(function() {
          var t = r.index(e(this));
          e(".selection-container." + n + ":not(:eq(" + t + "))").hide();
          e(".selection-container." + n + ":eq(" + t + ")").slideDown()
        });
        e("input.selection-chooser[type=radio][name^=" + n + "]:eq(" + o + ")").change()
      }
    })
  }
})(jQuery);

},{}],32:[function(require,module,exports){
(function(e) {
  e.growl = function(t, n) {
    var r = {
      type: "warning",
      position: "topright",
      timeout: 5e3,
      _class: "span4"
    };
    var n = e.extend(r, n);
    var i = {
      bottomright: {
        bottom: 0,
        right: 10
      },
      bottomleft: {
        bottom: 0,
        left: 0
      },
      topright: {
        top: 10,
        right: 10
      },
      topleft: {
        top: 10,
        left: 0
      }
    };
    var s = e('<div class="alert"><button class="close" data-dismiss="alert">×</button>' + t + "</div>");
    e(s).addClass("alert-" + n.type).hide();
    var o = e("#growl" + n.position);
    if (!e(o).length) {
      o = e('<div id="growl' + n.position + '"></div>');
      e("body").append(o);
      e(o).css({
        position: "fixed"
      }).css(i[n.position]).addClass(n._class)
    }
    e(o).prepend(s);
    e(s).slideDown("slow").delay(n.timeout).slideUp("slow", function() {
      e(this).remove();
      if (e(o).children().length <= 0) {
        e(o).remove()
      }
    });
    return true
  }
})(jQuery);

},{}],33:[function(require,module,exports){
/**
 * This is bootstrap, but the version is != 2.3.2, therefore we keep the source
 * in version 2.3.2, the element listened to for fata loading is .modal-body,
 * not .modal-content
 *
 * TODO: find current Bootstrap version for this module
 */

! function(e) {
  var t = function(t, n) {
    this.options = n;
    this.$element = e(t).delegate('[data-dismiss="modal"]', "click.dismiss.modal", e.proxy(this.hide, this));
    var r = this.$element.find(".modal-content");
    var i = this.options.remote;
    if (i && r) {
      e.ajax({
        url: i
      }).done(function(e, t, n) {
        if (n.getResponseHeader("redirected")) {
          window.location.href = i
        } else {
          r.html(e)
        }
      })
    }
  };
  t.prototype = {
    constructor: t,
    toggle: function() {
      return this[!this.isShown ? "show" : "hide"]()
    },
    show: function() {
      var t = this,
        n = e.Event("show");
      this.$element.trigger(n);
      if (this.isShown || n.isDefaultPrevented()) {
        return
      }
      this.isShown = true;
      this.escape();
      this.backdrop(function() {
        var n = e.support.transition && t.$element.hasClass("fade");
        if (!t.$element.parent().length) {
          t.$element.appendTo(document.body)
        }
        t.$element.show();
        if (n) {
          t.$element[0].offsetWidth
        }
        t.$element.addClass("in").attr("aria-hidden", false);
        t.enforceFocus();
        n ? t.$element.one(e.support.transition.end, function() {
          t.$element.focus().trigger("shown")
        }) : t.$element.focus().trigger("shown")
      })
    },
    hide: function(t) {
      t && t.preventDefault();
      var n = this;
      t = e.Event("hide");
      this.$element.trigger(t);
      if (!this.isShown || t.isDefaultPrevented()) {
        return
      }
      this.isShown = false;
      this.escape();
      e(document).off("focusin.modal");
      this.$element.removeClass("in").attr("aria-hidden", true);
      e.support.transition && this.$element.hasClass("fade") ? this.hideWithTransition() : this.hideModal()
    },
    enforceFocus: function() {
      var t = this;
      e(document).on("focusin.modal", function(e) {
        if (t.$element[0] !== e.target && !t.$element.has(e.target).length) {
          t.$element.focus()
        }
      })
    },
    escape: function() {
      var e = this;
      if (this.isShown && this.options.keyboard) {
        this.$element.on("keyup.dismiss.modal", function(t) {
          t.which == 27 && e.hide()
        })
      } else {
        if (!this.isShown) {
          this.$element.off("keyup.dismiss.modal")
        }
      }
    },
    hideWithTransition: function() {
      var t = this,
        n = setTimeout(function() {
          t.$element.off(e.support.transition.end);
          t.hideModal()
        }, 500);
      this.$element.one(e.support.transition.end, function() {
        clearTimeout(n);
        t.hideModal()
      })
    },
    hideModal: function() {
      var e = this;
      this.$element.hide();
      this.backdrop(function() {
        e.removeBackdrop();
        e.$element.trigger("hidden")
      })
    },
    removeBackdrop: function() {
      this.$backdrop && this.$backdrop.remove();
      this.$backdrop = null
    },
    backdrop: function(t) {
      var n = this,
        r = this.$element.hasClass("fade") ? "fade" : "";
      if (this.isShown && this.options.backdrop) {
        var i = e.support.transition && r;
        this.$backdrop = e('<div class="modal-backdrop ' + r + '" />').appendTo(document.body);
        this.$backdrop.click(this.options.backdrop == "static" ? e.proxy(this.$element[0].focus, this.$element[0]) : e.proxy(this.hide, this));
        if (i) {
          this.$backdrop[0].offsetWidth
        }
        this.$backdrop.addClass("in");
        if (!t) {
          return
        }
        i ? this.$backdrop.one(e.support.transition.end, t) : t()
      } else {
        if (!this.isShown && this.$backdrop) {
          this.$backdrop.removeClass("in");
          e.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one(e.support.transition.end, t) : t()
        } else {
          if (t) {
            t()
          }
        }
      }
    }
  };
  var n = e.fn.modal;
  e.fn.modal = function(n) {
    return this.each(function() {
      var r = e(this),
        i = r.data("modal"),
        s = e.extend({}, e.fn.modal.defaults, r.data(), typeof n == "object" && n);
      if (!i) {
        r.data("modal", i = new t(this, s))
      }
      if (typeof n == "string") {
        i[n]()
      } else {
        if (s.show) {
          i.show()
        }
      }
    })
  };
  e.fn.modal.defaults = {
    backdrop: true,
    keyboard: true,
    show: true
  };
  e.fn.modal.Constructor = t;
  e.fn.modal.noConflict = function() {
    e.fn.modal = n;
    return this
  };
  e(document).on("click.modal.data-api", '[data-toggle="modal"]', function(t) {
    var n = e(this),
      r = n.attr("href"),
      i = e(n.attr("data-target") || r && r.replace(/.*(?=#[^\s]+$)/, "")),
      s = i.data("modal") ? "toggle" : e.extend({
        remote: !/#/.test(r) && r
      }, i.data(), n.data());
    t.preventDefault();
    i.modal(s).one("hide", function() {
      n.focus()
    })
  })
}(window.jQuery);

},{}],34:[function(require,module,exports){
!(function(e) {
  e.support.placeholder = "placeholder" in document.createElement("input");
  e.fn.placeholder = function(t) {
    t = e.extend({
      blurClass: "placeholderBlur",
      activeClass: "placeholderFocus",
      overrideSupport: false
    }, t);
    if (!t.overrideSupport && e.support.placeholder) {
      return this
    }
    return this.each(function() {
      var n = e(this);
      if (!n.is("[placeholder]")) {
        return
      }
      if (n.is(":password")) {
        return
      }
      n.focus(function() {
        var n = e(this);
        if (n.val() == n.attr("placeholder")) {
          n.val("").removeClass(t.blurClass).addClass(t.activeClass)
        }
      });
      n.blur(function() {
        var n = e(this);
        if (n.val() == "") {
          n.val(n.attr("placeholder")).removeClass(t.activeClass).addClass(t.blurClass)
        }
      });
      n.parents("form").submit(function() {
        e(this).find("[placeholder]").each(function() {
          var t = e(this);
          if (t.val() == t.attr("placeholder")) {
            t.val("")
          }
        })
      });
      n.triggerHandler("blur")
    })
  }
})(jQuery);

},{}],35:[function(require,module,exports){
!(function(e) {
  e.ratingInput = function(t) {

    // Fix to not show more than one meter rating if clicking on the same
    // modal more than once.
    if (t.parent().find('ul.rating-meter').length >= 1) {
      return;
    }

    function s(t) {
      var r = parseInt(e(this).text());
      n.children("li").addClass("temp-empty-star");
      n.children("li:lt(" + r + ")").addClass("temp-full-star");
    }

    function o(e) {
      n.children("li").removeClass("temp-empty-star").removeClass("temp-full-star");
    }

    function u(t) {
      var r = parseInt(e(this).text());
      n.siblings("input").val(r);
      n.children("li").removeClass("star");
      n.children("li:lt(" + r + ")").addClass("star");
    }
    t.hide();
    var n = e('<ul class="rating-meter rating-input">');
    var r = t.val() ? t.val() : 0;
    n.bind({
      mouseout: o
    });

    var i = [1, 2, 3, 4, 5];

    e.each(i, function(t) {
      var o = e("<li>", {
        "class": i[t] <= r ? "star" : "",
        text: i[t]
      }).bind({
        click: u,
        mouseover: s
      }).appendTo(n)
    });
    t.parent().prepend(n);
  };
  e.fn.ratingInput = function() {
    return new e.ratingInput(this);
  }
})(jQuery);

},{}],36:[function(require,module,exports){
function minimizeWidget() {
  $('.marketing-widget').addClass('marketing-widget--minimized');
  $('.marketing-widget--close-button').addClass('marketing-widget--maximize-button').html('&plus;');
}

function maximizeWidget() {
  $('.marketing-widget').removeClass('marketing-widget--minimized');

  $('.marketing-widget--maximize-button').removeClass('marketing-widget--maximize-button').html('&mdash;');
}

$(function() {
  $(document).ready(function() {

    $(document)
      .on('click', '.marketing-widget--close-button', minimizeWidget)
      .on('click', '.marketing-widget--maximize-button', maximizeWidget);
  });
});

},{}],37:[function(require,module,exports){
function setCorrectState() {
  removeValidationErrors();

  if ($('#id2_start_date').val() === '' || $('#id2_end_date').val() === '' || $('#id2_start_time').val() === '' || $('#id2_end_time').val() === '') {
    $('#submit_button_2').addClass('disabled');
  } else {
    $('#submit_button_2').removeClass('disabled');
  }

  if ($('#id_start_date').val() === '' || $('#id_end_date').val() === '' || $('#id_start_time').val() === '' || $('#id_end_time').val() === '') {
    $('#submit_button').addClass('disabled');
  } else {
    $('#submit_button').removeClass('disabled');
  }
}

function removeValidationErrors() {
  $('.control-group').each(function() {
    $(this).removeClass('error')
  });
}

function areDatesSpecified() {
  if ($('#id2_start_date').val() === '' || $('#id2_end_date').val() === '' || $('#id2_start_time').val() === '' || $('#id2_end_time').val() === '') {
    return false;
  }

  return true;
}

function addValidationErrorsIfNeeded() {
  var startDateInput = $('#id2_start_date');
  if (startDateInput.val() === '') {
    startDateInput.closest('.control-group').addClass('error');
  }

  var startTimeInput = $('#id2_start_time');
  if (startTimeInput.val() === '') {
    startTimeInput.closest('.control-group').addClass('error');
  }

  var endDateInput = $('#id2_end_date');
  if (endDateInput.val() === '') {
    endDateInput.closest('.control-group').addClass('error');
  }

  var endTimeInput = $('#id2_end_time');
  if (endTimeInput.val() === '') {
    endTimeInput.closest('.control-group').addClass('error');
  }

  startDateInput = $('#id_start_date');
  if (startDateInput.val() === '') {
    startDateInput.closest('.control-group').addClass('error');
  }

  startTimeInput = $('#id_start_time');
  if (startTimeInput.val() === '') {
    startTimeInput.closest('.control-group').addClass('error');
  }

  endDateInput = $('#id_end_date');
  if (endDateInput.val() === '') {
    endDateInput.closest('.control-group').addClass('error');
  }

  endTimeInput = $('id_end_time');
  if (endTimeInput.val() === '') {
    endTimeInput.closest('.control-group').addClass('error');
  }
}

module.exports = {
  setCorrectState: setCorrectState,

  init: function(){
    $(document).ready(function() {
      setCorrectState();
      $('#id_start_date, #id_start_time, #id2_start_date, #id2_start_time, #id_end_date, #id_end_time, #id2_end_date, #id2_end_time').on('change', setCorrectState);

      $('#submit_button_2, #submit_button').on('click', function(e) {

        addValidationErrorsIfNeeded();

        if (areDatesSpecified()) {
          return;
        }

        return e.preventDefault();
      });
    });
  }
};

},{}],38:[function(require,module,exports){
$(function() {

  var hourInput = $('#pricing-section #id_pricing_car_hour');
  var dayInput = $('#pricing-section #id_pricing_car_day');
  var weekInput = $('#pricing-section #id_pricing_car_week');
  var monthInput = $('#pricing-section #id_pricing_car_month');


  hourInput.attr('max', parseFloat(dayInput.val()) - 0.01);
  dayInput.attr('max', parseFloat(weekInput.val()) - 0.01);
  weekInput.attr('max', parseFloat(monthInput.val()) - 0.01);

  monthInput.on('change', function() {
    weekInput.attr('max', parseFloat($(this).val()) - 0.01);
  });

  weekInput.on('change', function() {
    dayInput.attr('max', parseFloat($(this).val()) - 0.01);
  });

  dayInput.on('change', function() {
    hourInput.attr('max', parseFloat($(this).val()) - 0.01);
  });
});

},{}],39:[function(require,module,exports){
module.exports = {

  disableBookingButtons: function() {
    $('.is-link').each(function() {
      $(this).removeClass('is-link');
      $(this).addClass('is-link-disabled');
    });
  },

  enableBookingButtons: function() {
    $('.is-link-disabled').each(function() {
      $(this).removeClass('is-link-disabled');
      $(this).addClass('is-link');
    })
  },

  areDatesSpecified: function() {
    if ($('#id_start_date').val() === '' || $('#id_end_date').val() === '' || $('#id_start_time').val() === '' || $('#id_end_time').val() === '') {
      return false;
    }

    return true;
  },

  handleBookingButtons: function() {
    if (this.areDatesSpecified()) {
      return this.enableBookingButtons()
    }

    return this.disableBookingButtons();
  },

  init: function() {
    this.handleBookingButtons();
  },

  showDatesErrors: function() {
    var startDate = $('#id_start_date');
    var startTime = $('#id_start_time');

    var endDate = $('#id_end_date');
    var endTime = $('#id_end_time');

    if ('' === startDate.val()) {
      startDate.closest('.control-group').addClass('error');
    }

    if ('' === endDate.val()) {
      endDate.closest('.control-group').addClass('error');
    }

    if ('' === startTime.val()) {
      startTime.closest('.control-group').addClass('error');
    }

    if ('' === endTime.val()) {
      endTime.closest('.control-group').addClass('error');
    }
  },

  hookBookingButtonFailBehaviour: function() {
    var self = this;
    $(document).on('click', '.is-link-disabled', function() {
      // Please enter date and time information to ensure up-to-date results
      self.showDatesErrors();
    });
  }
};

},{}],40:[function(require,module,exports){

/**
 * The user module. It stores basic info on the current user
 */

var debug = require('./extensions/debug.js');

var User = function(options) {
  this.attributes = options;
}

User.prototype = {

  /**
   * Accessor
   */
  get: function(attr) {
    return this.attributes[attr];
  },

  /**
   * Checks if the user has an attribute
   */
  has: function(attr) {
    return this.attributes.indexOf(attr) !== -1;
  },

  /**
   * Accessor for all properties
   */
  serialize: function() {
    return this.attributes;
  },
};

module.exports = {

  /**
   * Defining the current user
   */
  initialize: function(options) {
    if (typeof options === 'string' && options === 'guest') {
      return this.setCurrent(null);
    }

    this.setCurrent(new User(options));
  },


  /**
   * Accessor
   */
  getCurrent: function() {
    return this.currentUser;
  },

  /**
   * Accessor
   */
  setCurrent: function(user) {
    this.currentUser = user;
    debug.setUser(user);
    return user;
  }

};

},{"./extensions/debug.js":29}]},{},[25])(25)
});